{
  "pummel": {
    "num": 1,
    "accuracy": 100,
    "basePower": 25,
    "category": "Physical",
    "name": "Pummel",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user pummels the foe repeatedly.\nThis hits 2-5 times in a row. Contact.",
    "shortDesc": "The user pummels the foe repeatedly.\nThis hits 2-5 times in a row. Contact.",
    "flags": {
      "contact": 1,
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": [
      2,
      5
    ],
    "zMove": {
      "basePower": 140
    }
  },
  "karatechop": {
    "num": 2,
    "accuracy": 100,
    "basePower": 60,
    "category": "Physical",
    "name": "Karate Chop",
    "pp": 20,
    "priority": 0,
    "critRatio": 2,
    "type": "Fighting",
    "target": "normal",
    "desc": "The target is attacked with a swift chop.\nThis has +1 (12%) critical hit rate. Contact.",
    "shortDesc": "The target is attacked with a swift chop.\nThis has +1 (12%) critical hit rate. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    }
  },
  "doubleslap": {
    "num": 3,
    "accuracy": 100,
    "basePower": 30,
    "category": "Physical",
    "name": "Double Slap",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The target is slapped twice back and forth. This hits\ntwice. Each hit has a 15% flinch chance. Contact.",
    "shortDesc": "The target is slapped twice back and forth. This hits\ntwice. Each hit has a 15% flinch chance. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": 2,
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 15,
        "volatileStatus": "flinch"
      }
    ]
  },
  "cometpunch": {
    "num": 4,
    "accuracy": 100,
    "basePower": 25,
    "category": "Physical",
    "name": "Comet Punch",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The target is hit with a flurry of punches imbued\nwith celestial fairy energy.\nThey hit 2-5 times in a row. Contact.",
    "shortDesc": "The target is hit with a flurry of punches imbued\nwith celestial fairy energy.\nThey hit 2-5 times in a row. Contact.",
    "flags": {
      "contact": 1,
      "heal": 1,
      "mirror": 1,
      "protect": 1,
      "sound": 1
    },
    "multihit": [
      2,
      5
    ],
    "zMove": {
      "basePower": 140
    }
  },
  "seismicfist": {
    "num": 5,
    "accuracy": 100,
    "basePower": 90,
    "category": "Physical",
    "name": "Seismic Fist",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "normal",
    "desc": "A ground-breaking punch is thrown at the target.\nHas a 30% chance to drop the foe's Defense. Contact.",
    "shortDesc": "A ground-breaking punch is thrown at the target.\nHas a 30% chance to drop the foe's Defense. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 30,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "payday": {
    "num": 6,
    "accuracy": 100,
    "basePower": 40,
    "category": "Physical",
    "name": "Pay Day",
    "pp": 5,
    "priority": 0,
    "critRatio": 3,
    "type": "Normal",
    "target": "normal",
    "desc": "Persian flings coins at the foe. This hits 3 times,\nwith EACH hit having a 50% crit rate.\nThe Z-Effect of this gives Persian +1 to all stats.",
    "shortDesc": "Persian flings coins at the foe. This hits 3 times,\nwith EACH hit having a 50% crit rate.\nThe Z-Effect of this gives Persian +1 to all stats.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "multihit": 3,
    "zMove": {
      "basePower": 180
    }
  },
  "firepunch": {
    "num": 7,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Fire Punch",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The target is punched with a fiery fist. This has a\n10% chance to burn the foe. Contact.",
    "shortDesc": "The target is punched with a fiery fist. This has a\n10% chance to burn the foe. Contact.",
    "flags": {
      "contact": 1,
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 10,
        "status": "brn"
      }
    ]
  },
  "icepunch": {
    "num": 8,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Ice Punch",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Ice",
    "target": "normal",
    "desc": "The target is punched with an icy fist. This has a\n10% chance to freeze the foe. Contact.",
    "shortDesc": "The target is punched with an icy fist. This has a\n10% chance to freeze the foe. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 10,
        "status": "frz"
      }
    ]
  },
  "thunderpunch": {
    "num": 9,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Thunder Punch",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "The target is punched with an electrified fist.This\nhas a 10% chance to paralyze the foe. Contact.",
    "shortDesc": "The target is punched with an electrified fist.This\nhas a 10% chance to paralyze the foe. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 10,
        "status": "par"
      }
    ]
  },
  "metalclaw": {
    "num": 10,
    "accuracy": 100,
    "basePower": 60,
    "category": "Physical",
    "name": "Metal Claw",
    "pp": 20,
    "priority": 0,
    "critRatio": 2,
    "type": "Steel",
    "target": "normal",
    "desc": "The target is raked with a steel-hard claw,\nblade, scythe, talon, or the like.\nThis has a 12%, or +1 critical hit rate. Contact.",
    "shortDesc": "The target is raked with a steel-hard claw,\nblade, scythe, talon, or the like.\nThis has a 12%, or +1 critical hit rate. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    }
  },
  "vicegrip": {
    "num": 11,
    "accuracy": 100,
    "basePower": 60,
    "category": "Physical",
    "name": "Vice Grip",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "normal",
    "desc": "The target is gripped firmly from both sides, trapping\nthem on the field for 6 turns & dealing 12% of their\nmax HP at the end of each turn. Contact.",
    "shortDesc": "The target is gripped firmly from both sides, trapping\nthem on the field for 6 turns & dealing 12% of their\nmax HP at the end of each turn. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    }
  },
  "guillotine": {
    "num": 12,
    "accuracy": true,
    "basePower": 1,
    "category": "Physical",
    "name": "Guillotine",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user slices the target in two, always fainting it.\nThis attack NEVER misses, but can only be used once.\nContact.",
    "shortDesc": "The user slices the target in two, always fainting it.\nThis attack NEVER misses, but can only be used once.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 255
    }
  },
  "razorwind": {
    "num": 13,
    "accuracy": 100,
    "basePower": 120,
    "category": "Special",
    "name": "Razor Wind",
    "pp": 5,
    "priority": 0,
    "critRatio": 7,
    "type": "Flying",
    "target": "allAdjacentFoes",
    "desc": "A 2 turn attack where the user fires vicious blades\nof wind. This attack always results in a critical\nhit, and flinches 30% of the time. Ignores protect.",
    "shortDesc": "A 2 turn attack where the user fires vicious blades\nof wind. This attack always results in a critical\nhit, and flinches 30% of the time. Ignores protect.",
    "flags": {
      "charge": 1,
      "mirror": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 220
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "swordsdance": {
    "num": 14,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Swords Dance",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "A frenetic dance to uplift the fighting spirit.\nRaises user's Attack by 2. Z-Effect +2 crit rate.",
    "shortDesc": "A frenetic dance to uplift the fighting spirit.\nRaises user's Attack by 2. Z-Effect +2 crit rate.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "atk": 2
        }
      }
    ]
  },
  "creepingstrike": {
    "num": 15,
    "accuracy": true,
    "basePower": 50,
    "category": "Physical",
    "name": "Creeping Strike",
    "pp": 15,
    "priority": 1,
    "critRatio": 1,
    "type": "Bug",
    "target": "normal",
    "desc": "The user quickly strikes the foe.\nThis has +1 Priority, and can't miss.",
    "shortDesc": "The user quickly strikes the foe.\nThis has +1 Priority, and can't miss.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "gust": {
    "num": 16,
    "accuracy": true,
    "basePower": 45,
    "category": "Special",
    "name": "Gust",
    "pp": 20,
    "priority": 1,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "A weak gust of wind is whipped up and launched\nquickly at the foe. +1 Priority. Can't miss.",
    "shortDesc": "A weak gust of wind is whipped up and launched\nquickly at the foe. +1 Priority. Can't miss.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 90
    }
  },
  "dualwingbeat": {
    "num": 17,
    "accuracy": 100,
    "basePower": 45,
    "category": "Physical",
    "name": "Dual Wingbeat",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "The user strikes the foe twice with it's wings. Each\nstrike has a 15% flinch chance. Contact.",
    "shortDesc": "The user strikes the foe twice with it's wings. Each\nstrike has a 15% flinch chance. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": 2,
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 15,
        "volatileStatus": "flinch"
      }
    ]
  },
  "whirlwind": {
    "num": 18,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Whirlwind",
    "pp": 3,
    "priority": 4,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "The target is blown away, and a random Pokemon is\ndragged out onto the field in their place.\nThis has +4 priority. Z-Effect +3 Speed.",
    "shortDesc": "The target is blown away, and a random Pokemon is\ndragged out onto the field in their place.\nThis has +4 priority. Z-Effect +3 Speed.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "reflectable": 1
    }
  },
  "fly": {
    "num": 19,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Fly",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "The user soars, then strikes the foe on the next turn.\nAfter attacking, the user gains +1 Accuracy. Contact.\nBypasses Protect.",
    "shortDesc": "The user soars, then strikes the foe on the next turn.\nAfter attacking, the user gains +1 Accuracy. Contact.\nBypasses Protect.",
    "flags": {
      "charge": 1,
      "contact": 1,
      "gravity": 1,
      "mirror": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "accuracy": 1
          }
        }
      }
    ]
  },
  "bind": {
    "num": 20,
    "accuracy": 100,
    "basePower": 60,
    "category": "Physical",
    "name": "Bind",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "Things such as long bodies or tentacles are used to\nsqueeze the foe for 6 turns, preventing switching and\ndealing 12% of the foe's max HP per turn. Contact.",
    "shortDesc": "Things such as long bodies or tentacles are used to\nsqueeze the foe for 6 turns, preventing switching and\ndealing 12% of the foe's max HP per turn. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    }
  },
  "whiplash": {
    "num": 21,
    "accuracy": 100,
    "basePower": 90,
    "category": "Physical",
    "name": "Whiplash",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The foe is slammed with a long tail or appendage.\nThis drops Defense by 1 after each hit. Contact.",
    "shortDesc": "The foe is slammed with a long tail or appendage.\nThis drops Defense by 1 after each hit. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "vinelashes": {
    "num": 22,
    "accuracy": 100,
    "basePower": 40,
    "category": "Physical",
    "name": "Vine Lashes",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The foe is lashed twice with whiplike vines.\nThis ALWAYS drops Defense by 1 after each hit.  Contact.",
    "shortDesc": "The foe is lashed twice with whiplike vines.\nThis ALWAYS drops Defense by 1 after each hit.  Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": 2,
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "stomp": {
    "num": 23,
    "accuracy": 100,
    "basePower": 70,
    "category": "Physical",
    "name": "Stomp",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The target is stomped on. Has a 30% chance to flinch\n the foe. Contact.",
    "shortDesc": "The target is stomped on. Has a 30% chance to flinch\n the foe. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 140
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "doublekick": {
    "num": 24,
    "accuracy": 100,
    "basePower": 35,
    "category": "Physical",
    "name": "Double Kick",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The target is kicked twice in succession using both\nfeet. Hits twice, each hit has a 15% flinch chance.\nContact.",
    "shortDesc": "The target is kicked twice in succession using both\nfeet. Hits twice, each hit has a 15% flinch chance.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": 2,
    "zMove": {
      "basePower": 140
    },
    "secondaries": [
      {
        "chance": 15,
        "volatileStatus": "flinch"
      }
    ]
  },
  "megatonkick": {
    "num": 25,
    "accuracy": 90,
    "basePower": 120,
    "category": "Physical",
    "name": "Megaton Kick",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "normal",
    "desc": "The user launches a kick towards the ground with\nmassive force. This drops Defense 30% of the time.\nContact.",
    "shortDesc": "The user launches a kick towards the ground with\nmassive force. This drops Defense 30% of the time.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 190
    },
    "secondaries": [
      {
        "chance": 30,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "highjumpkick": {
    "num": 26,
    "accuracy": 90,
    "basePower": 140,
    "category": "Physical",
    "name": "High Jump Kick",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user jumps up high, then strikes with a kick.\nIf this misses, the user loses 50% of it's max HP.\nContact.",
    "shortDesc": "The user jumps up high, then strikes with a kick.\nIf this misses, the user loses 50% of it's max HP.\nContact.",
    "flags": {
      "contact": 1,
      "gravity": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 190
    }
  },
  "rollingkick": {
    "num": 27,
    "accuracy": 100,
    "basePower": 60,
    "category": "Physical",
    "name": "Rolling Kick",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user kicks the foe while quickly spinning.\nThis ALWAYS boosts the user's Speed by 1. Contact.",
    "shortDesc": "The user kicks the foe while quickly spinning.\nThis ALWAYS boosts the user's Speed by 1. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "spe": 1
          }
        }
      }
    ]
  },
  "sandsling": {
    "num": 28,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Sand Sling",
    "pp": 1,
    "priority": 4,
    "critRatio": 1,
    "type": "Ground",
    "target": "normal",
    "desc": "The user quickly slings sand into the target's eyes.\nThis ALWAYS flinches & inflicts Taunt on the opponent,\nblocking status moves for 3 turns. Z-Move +1 All.",
    "shortDesc": "The user quickly slings sand into the target's eyes.\nThis ALWAYS flinches & inflicts Taunt on the opponent,\nblocking status moves for 3 turns. Z-Move +1 All.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "11"
      },
      {
        "chance": 100,
        "volatileStatus": "flinch"
      }
    ]
  },
  "headbutt": {
    "num": 29,
    "accuracy": 100,
    "basePower": 75,
    "category": "Physical",
    "name": "Headbutt",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user headbutts the target. Has a 30% chance to\nflinch. Contact.",
    "shortDesc": "The user headbutts the target. Has a 30% chance to\nflinch. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 150
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "peck": {
    "num": 30,
    "accuracy": 100,
    "basePower": 50,
    "category": "Physical",
    "name": "Peck",
    "pp": 25,
    "priority": 0,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "The target is jabbed with a beak, horn, or the like.\n20% chance to drop the foe's Defense. Contact.",
    "shortDesc": "The target is jabbed with a beak, horn, or the like.\n20% chance to drop the foe's Defense. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 110
    },
    "secondaries": [
      {
        "chance": 20,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "spikecannon": {
    "num": 31,
    "accuracy": 100,
    "basePower": 25,
    "category": "Physical",
    "name": "Spike Cannon",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "normal",
    "desc": "The user rapidly shoots steel-hard spikes at the foe.\nThis attack hits 2-5 times in succession.",
    "shortDesc": "The user rapidly shoots steel-hard spikes at the foe.\nThis attack hits 2-5 times in succession.",
    "flags": {
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": [
      2,
      5
    ],
    "zMove": {
      "basePower": 140
    }
  },
  "horndrill": {
    "num": 32,
    "accuracy": true,
    "basePower": 1,
    "category": "Physical",
    "name": "Horn Drill",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user stabs the foe through their vitals, fainting it.\nThis attack NEVER misses, but can only be used once.\nContact.",
    "shortDesc": "The user stabs the foe through their vitals, fainting it.\nThis attack NEVER misses, but can only be used once.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 255
    }
  },
  "tackle": {
    "num": 33,
    "accuracy": 100,
    "basePower": 55,
    "category": "Physical",
    "name": "Tackle",
    "pp": 35,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "A physical attack in which the user charges and\nslams into the target with its whole body. Contact.",
    "shortDesc": "A physical attack in which the user charges and\nslams into the target with its whole body. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 110
    }
  },
  "bodyslam": {
    "num": 34,
    "accuracy": 100,
    "basePower": 90,
    "category": "Physical",
    "name": "Body Slam",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user drops onto the target with its full body\nweight. Paralyzes the target 30% of the time. Contact.",
    "shortDesc": "The user drops onto the target with its full body\nweight. Paralyzes the target 30% of the time. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 30,
        "status": "par"
      }
    ]
  },
  "wrap": {
    "num": 35,
    "accuracy": 100,
    "basePower": 60,
    "category": "Physical",
    "name": "Wrap",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "A long body, vines, or the like are used to wrap and \nsqueeze the foe for 6 turns, preventing switching and\ndealing 12% of the foe's max HP per turn. Contact.",
    "shortDesc": "A long body, vines, or the like are used to wrap and \nsqueeze the foe for 6 turns, preventing switching and\ndealing 12% of the foe's max HP per turn. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    }
  },
  "takedown": {
    "num": 36,
    "accuracy": 100,
    "basePower": 110,
    "category": "Physical",
    "name": "Take Down",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "A reckless, full-body charge attack for slamming into\nthe target. User takes 20% recoil damage.\nThis has a 30% chance to drop Defense. Contact.",
    "shortDesc": "A reckless, full-body charge attack for slamming into\nthe target. User takes 20% recoil damage.\nThis has a 30% chance to drop Defense. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      20,
      100
    ],
    "zMove": {
      "basePower": 185
    },
    "secondaries": [
      {
        "chance": 30,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "kerfuffle": {
    "num": 37,
    "accuracy": true,
    "basePower": 120,
    "category": "Physical",
    "name": "Kerfuffle",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "randomNormal",
    "desc": "The user rampages and attacks for two to three\nturns. The user then becomes confused. Contact.",
    "shortDesc": "The user rampages and attacks for two to three\nturns. The user then becomes confused. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 190
    }
  },
  "doubleedge": {
    "num": 38,
    "accuracy": 100,
    "basePower": 125,
    "category": "Physical",
    "name": "Double-Edge",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "A reckless, life-risking tackle. User takes 25% of\ndamage dealt. Has a 50% chance to drop the foe's\nDefense stat by 1 after use. Contact.",
    "shortDesc": "A reckless, life-risking tackle. User takes 25% of\ndamage dealt. Has a 50% chance to drop the foe's\nDefense stat by 1 after use. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      1,
      4
    ],
    "zMove": {
      "basePower": 195
    },
    "secondaries": [
      {
        "chance": 50,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "tailwag": {
    "num": 39,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Tail Wag",
    "pp": 30,
    "priority": 4,
    "critRatio": 1,
    "type": "Normal",
    "target": "allAdjacentFoes",
    "desc": "The user wags its tail cutely, making opposing\nPokemon less wary, dropping their Defense stat by 1.\nThis has +4 priority. Z-Effect is +1 Attack.",
    "shortDesc": "The user wags its tail cutely, making opposing\nPokemon less wary, dropping their Defense stat by 1.\nThis has +4 priority. Z-Effect is +1 Attack.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "barbbarrage": {
    "num": 40,
    "accuracy": 100,
    "basePower": 20,
    "category": "Physical",
    "name": "Barb Barrage",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "The user shoots 3 venomous barbs at the target.\nThis ALWAYS poisons the foe and hits 3 times.",
    "shortDesc": "The user shoots 3 venomous barbs at the target.\nThis ALWAYS poisons the foe and hits 3 times.",
    "flags": {
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": 3,
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "psn"
      }
    ]
  },
  "poisondart": {
    "num": 41,
    "accuracy": true,
    "basePower": 50,
    "category": "Physical",
    "name": "Poison Dart",
    "pp": 15,
    "priority": 1,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "The user rapidly shoots out a poisonous barb.\nThis has +1 priority, and can't miss.",
    "shortDesc": "The user rapidly shoots out a poisonous barb.\nThis has +1 priority, and can't miss.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "pinmissile": {
    "num": 42,
    "accuracy": 100,
    "basePower": 25,
    "category": "Physical",
    "name": "Pin Missile",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Bug",
    "target": "normal",
    "desc": "Sharp spikes are shot at the target in rapid\nsuccession. They hit two to five times in a row.",
    "shortDesc": "Sharp spikes are shot at the target in rapid\nsuccession. They hit two to five times in a row.",
    "flags": {
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": [
      2,
      5
    ],
    "zMove": {
      "basePower": 140
    }
  },
  "leer": {
    "num": 43,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Leer",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "allAdjacentFoes",
    "desc": "The user gives opposing Pokemon an intimidating\nleer, lowering BOTH Defense & Sp. Def by 1.\nZ-Effect +2 Crit Rate.",
    "shortDesc": "The user gives opposing Pokemon an intimidating\nleer, lowering BOTH Defense & Sp. Def by 1.\nZ-Effect +2 Crit Rate.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "def": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spd": -1
        }
      }
    ]
  },
  "jaggedfangs": {
    "num": 44,
    "accuracy": 100,
    "basePower": 85,
    "category": "Physical",
    "name": "Jagged Fangs",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Rock",
    "target": "normal",
    "desc": "The user bites the foe with jagged, hard fangs.\nThis has a 30% chance to drop the foe's Defense by 1.\nContact.",
    "shortDesc": "The user bites the foe with jagged, hard fangs.\nThis has a 30% chance to drop the foe's Defense by 1.\nContact.",
    "flags": {
      "bite": 1,
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 170
    },
    "secondaries": [
      {
        "chance": 30,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "growl": {
    "num": 45,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Growl",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "allAdjacentFoes",
    "desc": "The user growls in an endearing way, making\nopposing Pokemon less wary. This lowers their\nAttack & Speed stats by 1. Z-Effect +2 Attack.",
    "shortDesc": "The user growls in an endearing way, making\nopposing Pokemon less wary. This lowers their\nAttack & Speed stats by 1. Z-Effect +2 Attack.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spe": -1
        }
      }
    ]
  },
  "roar": {
    "num": 46,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Roar",
    "pp": 3,
    "priority": 4,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The target is scared off, and a random Pokemon is\ndragged out. This has +4 priority. Z-Effect +2 Attack.",
    "shortDesc": "The target is scared off, and a random Pokemon is\ndragged out. This has +4 priority. Z-Effect +2 Attack.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "reflectable": 1
    }
  },
  "sing": {
    "num": 47,
    "accuracy": 80,
    "basePower": 0,
    "category": "Status",
    "name": "Sing",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "A soothing lullaby is sung in a calming voice, putting\nthe target in a deep sleep that lasts 2 turns.\nZ-Effect +1 Speed.",
    "shortDesc": "A soothing lullaby is sung in a calming voice, putting\nthe target in a deep sleep that lasts 2 turns.\nZ-Effect +1 Speed.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "supersonic": {
    "num": 48,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Supersonic",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user emits odd sound waves from it's body, which\nconfuse the target for 4 turns. Z-Effect +2 Sp. Atk.",
    "shortDesc": "The user emits odd sound waves from it's body, which\nconfuse the target for 4 turns. Z-Effect +2 Sp. Atk.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "sonicboom": {
    "num": 49,
    "accuracy": 100,
    "basePower": 1,
    "category": "Special",
    "name": "Sonic Boom",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The target is hit with a destructive shock wave that\nalways inflicts 20 HP damage.",
    "shortDesc": "The target is hit with a destructive shock wave that\nalways inflicts 20 HP damage.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 125
    }
  },
  "disable": {
    "num": 50,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Disable",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "For five turns, this move prevents the target from\nusing the move it last used. Z-Effect +2 Sp. Atk.",
    "shortDesc": "For five turns, this move prevents the target from\nusing the move it last used. Z-Effect +2 Sp. Atk.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "acidspray": {
    "num": 51,
    "accuracy": 100,
    "basePower": 50,
    "category": "Special",
    "name": "Acid Spray",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "allAdjacentFoes",
    "desc": "The user sprays highly corrosive acid at the target.\nThis ALWAYS drops the foe's Sp. Def by 4, or 2/3.",
    "shortDesc": "The user sprays highly corrosive acid at the target.\nThis ALWAYS drops the foe's Sp. Def by 4, or 2/3.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spd": -4
        }
      }
    ]
  },
  "ignite": {
    "num": 52,
    "accuracy": true,
    "basePower": 45,
    "category": "Special",
    "name": "Ignite",
    "pp": 25,
    "priority": 1,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The user quickly ignites and shoots weak flames.\nThis move has +1 priority, and can't miss.",
    "shortDesc": "The user quickly ignites and shoots weak flames.\nThis move has +1 priority, and can't miss.",
    "flags": {
      "defrost": 1,
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 90
    }
  },
  "flamethrower": {
    "num": 53,
    "accuracy": 100,
    "basePower": 90,
    "category": "Special",
    "name": "Flamethrower",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The target is scorched with an intense blast of fire.\nThis burns the target 10% of the time.",
    "shortDesc": "The target is scorched with an intense blast of fire.\nThis burns the target 10% of the time.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 10,
        "status": "brn"
      }
    ]
  },
  "mist": {
    "num": 54,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Mist",
    "pp": 30,
    "priority": 0,
    "critRatio": 1,
    "type": "Ice",
    "target": "normal",
    "desc": "The user cloaks itself and its allies in a white mist\nthat prevents any of their stats from being lowered\nfor five turns. Z-Mist heals the user fully.",
    "shortDesc": "The user cloaks itself and its allies in a white mist\nthat prevents any of their stats from being lowered\nfor five turns. Z-Mist heals the user fully.",
    "flags": {
      "snatch": 1
    }
  },
  "snipeshot": {
    "num": 55,
    "accuracy": true,
    "basePower": 50,
    "category": "Special",
    "name": "Snipe Shot",
    "pp": 5,
    "priority": 3,
    "critRatio": 7,
    "type": "Water",
    "target": "normal",
    "desc": "The user fires a highly concentrated jet of water.\nThis has +3 priority, & ALWAYS lands a critical hit.",
    "shortDesc": "The user fires a highly concentrated jet of water.\nThis has +3 priority, & ALWAYS lands a critical hit.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 150
    }
  },
  "hydropump": {
    "num": 56,
    "accuracy": 90,
    "basePower": 120,
    "category": "Special",
    "name": "Hydro Pump",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "The target is blasted by a huge volume of water\nlaunched under great pressure.",
    "shortDesc": "The target is blasted by a huge volume of water\nlaunched under great pressure.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 195
    }
  },
  "surf": {
    "num": 57,
    "accuracy": 100,
    "basePower": 95,
    "category": "Special",
    "name": "Surf",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "allAdjacent",
    "desc": "The user attacks everything around it by swamping\nits surroundings with a giant wave.",
    "shortDesc": "The user attacks everything around it by swamping\nits surroundings with a giant wave.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    }
  },
  "icebeam": {
    "num": 58,
    "accuracy": 100,
    "basePower": 90,
    "category": "Special",
    "name": "Ice Beam",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Ice",
    "target": "normal",
    "desc": "The target is struck with an icy-cold beam of energy.\nThis freezes the target 10% of the time.",
    "shortDesc": "The target is struck with an icy-cold beam of energy.\nThis freezes the target 10% of the time.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 10,
        "status": "frz"
      }
    ]
  },
  "blizzard": {
    "num": 59,
    "accuracy": 85,
    "basePower": 120,
    "category": "Special",
    "name": "Blizzard",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ice",
    "target": "allAdjacentFoes",
    "desc": "A howling blizzard is summoned to strike opponents.\nThis freezes the opponents 10% of the time.",
    "shortDesc": "A howling blizzard is summoned to strike opponents.\nThis freezes the opponents 10% of the time.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 195
    },
    "secondaries": [
      {
        "chance": 10,
        "status": "frz"
      }
    ]
  },
  "influx": {
    "num": 60,
    "accuracy": true,
    "basePower": 45,
    "category": "Special",
    "name": "Influx",
    "pp": 20,
    "priority": 1,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "A quick psychic beam is rapidly shot at the target.\nThis has +1 priority, and can't miss.",
    "shortDesc": "A quick psychic beam is rapidly shot at the target.\nThis has +1 priority, and can't miss.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 90
    }
  },
  "bubbleshot": {
    "num": 61,
    "accuracy": true,
    "basePower": 45,
    "category": "Special",
    "name": "Bubble Shot",
    "pp": 20,
    "priority": 1,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "The user quickly fires a jet of bubbles at the foe.\nThis has +1 priority, and can't miss.",
    "shortDesc": "The user quickly fires a jet of bubbles at the foe.\nThis has +1 priority, and can't miss.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 90
    }
  },
  "aurorabeam": {
    "num": 62,
    "accuracy": 100,
    "basePower": 70,
    "category": "Special",
    "name": "Aurora Beam",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Ice",
    "target": "normal",
    "desc": "The foe is hit with an icy, rainbow-colored beam.\nThis ALWAYS drops the foe's attacking stats by 1.",
    "shortDesc": "The foe is hit with an icy, rainbow-colored beam.\nThis ALWAYS drops the foe's attacking stats by 1.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 140
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      }
    ]
  },
  "hyperbeam": {
    "num": 63,
    "accuracy": 100,
    "basePower": 160,
    "category": "Special",
    "name": "Hyper Beam",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The target is attacked with a powerful beam.\nDrops user's Sp. Atk by 2.",
    "shortDesc": "The target is attacked with a powerful beam.\nDrops user's Sp. Atk by 2.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "spa": -2
      }
    },
    "zMove": {
      "basePower": 220
    }
  },
  "furypecks": {
    "num": 64,
    "accuracy": 100,
    "basePower": 25,
    "category": "Physical",
    "name": "Fury Pecks",
    "pp": 3,
    "priority": 0,
    "critRatio": 7,
    "type": "Flying",
    "target": "normal",
    "desc": "The foe is violently pecked at with great force.\nThis hits 3 times and ALWAYS crits. Contact.\nBypasses protect.",
    "shortDesc": "The foe is violently pecked at with great force.\nThis hits 3 times and ALWAYS crits. Contact.\nBypasses protect.",
    "flags": {
      "contact": 1,
      "heal": 1,
      "mirror": 1
    },
    "willCrit": true,
    "multihit": 3,
    "zMove": {
      "basePower": 190
    }
  },
  "drillpeck": {
    "num": 65,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Drill Peck",
    "pp": 10,
    "priority": 0,
    "critRatio": 3,
    "type": "Flying",
    "target": "normal",
    "desc": "A corkscrewing attack with a sharp appendage acting as\na drill. This attack has a 50% (+2) crit rate.",
    "shortDesc": "A corkscrewing attack with a sharp appendage acting as\na drill. This attack has a 50% (+2) crit rate.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    }
  },
  "submission": {
    "num": 66,
    "accuracy": 100,
    "basePower": 150,
    "category": "Physical",
    "name": "Submission",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user beats the target into hopeless submission.\nThis deals 50% recoil to the user, and drops the\nuser's Defensive stats by 1 after use. Contact.",
    "shortDesc": "The user beats the target into hopeless submission.\nThis deals 50% recoil to the user, and drops the\nuser's Defensive stats by 1 after use. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      1,
      2
    ],
    "self": {
      "boosts": {
        "def": -1,
        "spd": -1
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "lowkick": {
    "num": 67,
    "accuracy": 100,
    "basePower": 1,
    "category": "Physical",
    "name": "Low Kick",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "A powerful low kick that makes the target fall over.\nThe heavier the target, the stronger this becomes.\nThis ALWAYS drops the foe's Speed by 1. Contact.",
    "shortDesc": "A powerful low kick that makes the target fall over.\nThe heavier the target, the stronger this becomes.\nThis ALWAYS drops the foe's Speed by 1. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -1
        }
      }
    ]
  },
  "counter": {
    "num": 68,
    "accuracy": 100,
    "basePower": 1,
    "category": "Physical",
    "name": "Counter",
    "pp": 20,
    "priority": -6,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "A retaliation move that counters any physical attack,\ninflicting double the damage taken. Contact.",
    "shortDesc": "A retaliation move that counters any physical attack,\ninflicting double the damage taken. Contact.",
    "flags": {
      "contact": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    }
  },
  "seismictoss": {
    "num": 69,
    "accuracy": true,
    "basePower": 1,
    "category": "Physical",
    "name": "Seismic Toss",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The target is thrown using the power of gravity.\nIt inflicts damage equal to the user’s level. Contact.\nThis ALWAYS gives the user +1 Accuracy after use.",
    "shortDesc": "The target is thrown using the power of gravity.\nIt inflicts damage equal to the user’s level. Contact.\nThis ALWAYS gives the user +1 Accuracy after use.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "accuracy": 1
          }
        }
      }
    ]
  },
  "strength": {
    "num": 70,
    "accuracy": 100,
    "basePower": 120,
    "category": "Physical",
    "name": "Strength",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user fights the target up close without guarding\nitself. This also lowers the user’s Defense and\nSp. Def stats by 1. Contact.",
    "shortDesc": "The user fights the target up close without guarding\nitself. This also lowers the user’s Defense and\nSp. Def stats by 1. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "def": -1,
        "spd": -1
      }
    },
    "zMove": {
      "basePower": 190
    }
  },
  "siphon": {
    "num": 71,
    "accuracy": 100,
    "basePower": 50,
    "category": "Special",
    "name": "Siphon",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Bug",
    "target": "normal",
    "desc": "The user siphons the foe's vital fluids or energy.\nThis heals the user by 100% of damage dealt.",
    "shortDesc": "The user siphons the foe's vital fluids or energy.\nThis heals the user by 100% of damage dealt.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "drain": [
      100,
      100
    ],
    "zMove": {
      "basePower": 100
    }
  },
  "megadrain": {
    "num": 72,
    "accuracy": 100,
    "basePower": 60,
    "category": "Special",
    "name": "Mega Drain",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "A nutrient-draining attack. The user’s HP is restored\nby 75% of the damage taken by the target.",
    "shortDesc": "A nutrient-draining attack. The user’s HP is restored\nby 75% of the damage taken by the target.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "drain": [
      3,
      4
    ],
    "zMove": {
      "basePower": 120
    }
  },
  "leechseed": {
    "num": 73,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Leech Seed",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "A seed is planted on the target. It steals 12% HP\nfrom the target every turn. Z-Effect heals user fully.",
    "shortDesc": "A seed is planted on the target. It steals 12% HP\nfrom the target every turn. Z-Effect heals user fully.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "growth": {
    "num": 74,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Growth",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "self",
    "desc": "The user’s body grows all at once, raising the\nAttack and Sp. Atk stats by one, or two in the Sun.\nZ-Effect heals user fully.",
    "shortDesc": "The user’s body grows all at once, raising the\nAttack and Sp. Atk stats by one, or two in the Sun.\nZ-Effect heals user fully.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "atk": 1
        }
      },
      {
        "chance": 0,
        "boosts": {
          "spa": 1
        }
      }
    ]
  },
  "razorleaf": {
    "num": 75,
    "accuracy": 100,
    "basePower": 60,
    "category": "Physical",
    "name": "Razor Leaf",
    "pp": 20,
    "priority": 0,
    "critRatio": 2,
    "type": "Grass",
    "target": "allAdjacentFoes",
    "desc": "Sharp-edged leaves are launched to slash at the\nfoes. This has a 12% (+1) crit rate.",
    "shortDesc": "Sharp-edged leaves are launched to slash at the\nfoes. This has a 12% (+1) crit rate.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    }
  },
  "solarbeam": {
    "num": 76,
    "accuracy": 100,
    "basePower": 90,
    "category": "Special",
    "name": "Solar Beam",
    "pp": 10,
    "priority": 0,
    "critRatio": 7,
    "type": "Grass",
    "target": "normal",
    "desc": "In this two-turn attack, the user gathers light, then\nblasts a bundled beam on the next turn.This doesn't\ncharge in Sun. ALWAYS CRITS, ignores Protect.",
    "shortDesc": "In this two-turn attack, the user gathers light, then\nblasts a bundled beam on the next turn.This doesn't\ncharge in Sun. ALWAYS CRITS, ignores Protect.",
    "flags": {
      "charge": 1,
      "mirror": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 200
    }
  },
  "poisonpowder": {
    "num": 77,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Poison Powder",
    "pp": 35,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "The user scatters a cloud of poisonous dust that\npoisons the target. Z-Effect +2 Sp. Def.",
    "shortDesc": "The user scatters a cloud of poisonous dust that\npoisons the target. Z-Effect +2 Sp. Def.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "stunspore": {
    "num": 78,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Stun Spore",
    "pp": 30,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user scatters a cloud of numbing powder that\nparalyzes the target. Z-Effect +2 Sp. Def.",
    "shortDesc": "The user scatters a cloud of numbing powder that\nparalyzes the target. Z-Effect +2 Sp. Def.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "sleeppowder": {
    "num": 79,
    "accuracy": 85,
    "basePower": 0,
    "category": "Status",
    "name": "Sleep Powder",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user scatters a big cloud of sleep-inducing dust,\nputting the target to sleep for 2 turns.\nZ-Effect heals the user fully.",
    "shortDesc": "The user scatters a big cloud of sleep-inducing dust,\nputting the target to sleep for 2 turns.\nZ-Effect heals the user fully.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "petaldance": {
    "num": 80,
    "accuracy": 100,
    "basePower": 120,
    "category": "Special",
    "name": "Petal Dance",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "randomNormal",
    "desc": "The user attacks the target by scattering petals for\ntwo to three turns. The user then becomes confused.",
    "shortDesc": "The user attacks the target by scattering petals for\ntwo to three turns. The user then becomes confused.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 190
    }
  },
  "stringshot": {
    "num": 81,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "String Shot",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Bug",
    "target": "allAdjacentFoes",
    "desc": "The opposing Pokemon are bound with silk. This\nlowers their Speed by 2, & Sp. Atk by 2.\nZ-Effect +3 Speed.",
    "shortDesc": "The opposing Pokemon are bound with silk. This\nlowers their Speed by 2, & Sp. Atk by 2.\nZ-Effect +3 Speed.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -2
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spa": -2
        }
      }
    ]
  },
  "dragonburst": {
    "num": 82,
    "accuracy": 100,
    "basePower": 1,
    "category": "Special",
    "name": "Dragon Burst",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Dragon",
    "target": "normal",
    "desc": "In a rage, the user fires 3 shockwaves of dragon\nenergy at the foe. Each individual shockwave deals\n40 HP damage for a total of 120 flat HP damage.",
    "shortDesc": "In a rage, the user fires 3 shockwaves of dragon\nenergy at the foe. Each individual shockwave deals\n40 HP damage for a total of 120 flat HP damage.",
    "flags": {
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": 3,
    "zMove": {
      "basePower": 220
    }
  },
  "firespin": {
    "num": 83,
    "accuracy": 100,
    "basePower": 60,
    "category": "Special",
    "name": "Fire Spin",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The target becomes trapped within a fierce vortex of\nfire that traps foe for 6 turns, preventing switching\nand dealing 12% of the foe's max HP per turn.",
    "shortDesc": "The target becomes trapped within a fierce vortex of\nfire that traps foe for 6 turns, preventing switching\nand dealing 12% of the foe's max HP per turn.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    }
  },
  "thundershock": {
    "num": 84,
    "accuracy": 100,
    "basePower": 40,
    "category": "Special",
    "name": "Thunder Shock",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "A jolt of concentrated static electricity strikes the foe.\nThis will ALWAYS leave the foe with paralysis.",
    "shortDesc": "A jolt of concentrated static electricity strikes the foe.\nThis will ALWAYS leave the foe with paralysis.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 80
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "par"
      }
    ]
  },
  "thunderbolt": {
    "num": 85,
    "accuracy": 100,
    "basePower": 90,
    "category": "Special",
    "name": "Thunderbolt",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "A strong electric blast crashes down on the target.\nThis leaves the target paralyzed 10% of the time.",
    "shortDesc": "A strong electric blast crashes down on the target.\nThis leaves the target paralyzed 10% of the time.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 10,
        "status": "par"
      }
    ]
  },
  "thunderwave": {
    "num": 86,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Thunder Wave",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "The user launches a weak wave of electricity that\nparalyzes the target. Z-Effect +2 Sp. Def.",
    "shortDesc": "The user launches a weak wave of electricity that\nparalyzes the target. Z-Effect +2 Sp. Def.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "thunder": {
    "num": 87,
    "accuracy": 85,
    "basePower": 120,
    "category": "Special",
    "name": "Thunder",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "A wicked thunderbolt is dropped on the target.\nThis leaves the target paralyzed 30% of the time.\nThis can't miss in the Rain.",
    "shortDesc": "A wicked thunderbolt is dropped on the target.\nThis leaves the target paralyzed 30% of the time.\nThis can't miss in the Rain.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 195
    },
    "secondaries": [
      {
        "chance": 30,
        "status": "par"
      }
    ]
  },
  "faerieblow": {
    "num": 88,
    "accuracy": true,
    "basePower": 50,
    "category": "Physical",
    "name": "Faerie Blow",
    "pp": 15,
    "priority": 1,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user quickly strikes the target whimsically.\nThis has +1 priority, and can't miss. Contact.",
    "shortDesc": "The user quickly strikes the target whimsically.\nThis has +1 priority, and can't miss. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1,
      "sound": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "earthquake": {
    "num": 89,
    "accuracy": 100,
    "basePower": 100,
    "category": "Physical",
    "name": "Earthquake",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "allAdjacent",
    "desc": "The user sets off an earthquake that strikes every\nPokemon around it.",
    "shortDesc": "The user sets off an earthquake that strikes every\nPokemon around it.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    }
  },
  "fissure": {
    "num": 90,
    "accuracy": true,
    "basePower": 1,
    "category": "Physical",
    "name": "Fissure",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "normal",
    "desc": "The opens up a fissure under the foe, fainting them.\nThis attack NEVER misses, but can only be used once.\nContact.",
    "shortDesc": "The opens up a fissure under the foe, fainting them.\nThis attack NEVER misses, but can only be used once.\nContact.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 255
    }
  },
  "dig": {
    "num": 91,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Dig",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "normal",
    "desc": "The user burrows, then attacks on the next turn.\nThe user gains +1 Accuracy after attacking. Contact.\nBypasses protect.",
    "shortDesc": "The user burrows, then attacks on the next turn.\nThe user gains +1 Accuracy after attacking. Contact.\nBypasses protect.",
    "flags": {
      "charge": 1,
      "contact": 1,
      "mirror": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "accuracy": 1
          }
        }
      }
    ]
  },
  "toxic": {
    "num": 92,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Toxic",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "A move that leaves the target badly poisoned.\nIts poison damage worsens every turn.\nZ-Effect heals user fully.",
    "shortDesc": "A move that leaves the target badly poisoned.\nIts poison damage worsens every turn.\nZ-Effect heals user fully.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "confusion": {
    "num": 93,
    "accuracy": 100,
    "basePower": 60,
    "category": "Special",
    "name": "Confusion",
    "pp": 25,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The target is hit by a weak telekinetic force.\nThis confuses the target for 4 turns 50% of the time.",
    "shortDesc": "The target is hit by a weak telekinetic force.\nThis confuses the target for 4 turns 50% of the time.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 50,
        "status": "tox"
      }
    ]
  },
  "psychic": {
    "num": 94,
    "accuracy": 100,
    "basePower": 90,
    "category": "Special",
    "name": "Psychic",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The target is hit by a strong telekinetic force.\nThis drops the foe's Sp. Def 25% of the time.",
    "shortDesc": "The target is hit by a strong telekinetic force.\nThis drops the foe's Sp. Def 25% of the time.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 25,
        "boosts": {
          "spd": -1
        }
      }
    ]
  },
  "hypnosis": {
    "num": 95,
    "accuracy": 80,
    "basePower": 0,
    "category": "Status",
    "name": "Hypnosis",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user employs hypnotic suggestion, putting the\ntarget in a deep sleep that lasts 2 turns.\nZ-Effect +2 Sp. Def.",
    "shortDesc": "The user employs hypnotic suggestion, putting the\ntarget in a deep sleep that lasts 2 turns.\nZ-Effect +2 Sp. Def.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "meditate": {
    "num": 96,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Meditate",
    "pp": 3,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "self",
    "desc": "The user meditates to awaken the power deep\nwithin its body and raise its Attack and Sp. Def by 1.\nZ-Effect gives +3 Speed.",
    "shortDesc": "The user meditates to awaken the power deep\nwithin its body and raise its Attack and Sp. Def by 1.\nZ-Effect gives +3 Speed.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "spd": 1
        }
      },
      {
        "chance": 0,
        "boosts": {
          "atk": 1
        }
      }
    ]
  },
  "agility": {
    "num": 97,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Agility",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "self",
    "desc": "The user relaxes and lightens its body to move\nfaster. This raises Speed by 2. Z-Effect +2 Crit Rate.",
    "shortDesc": "The user relaxes and lightens its body to move\nfaster. This raises Speed by 2. Z-Effect +2 Crit Rate.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "spe": 2
        }
      }
    ]
  },
  "quickattack": {
    "num": 98,
    "accuracy": true,
    "basePower": 50,
    "category": "Physical",
    "name": "Quick Attack",
    "pp": 15,
    "priority": 1,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user lunges quickly at the target.\n+1 Priority, can't miss, and makes contact.",
    "shortDesc": "The user lunges quickly at the target.\n+1 Priority, can't miss, and makes contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "rage": {
    "num": 99,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Rage",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user attacks with rage. As long as this move is in\nuse, rage raises the Attack stat by 1 each time the\nuser is hit. Contact.",
    "shortDesc": "The user attacks with rage. As long as this move is in\nuse, rage raises the Attack stat by 1 each time the\nuser is hit. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    }
  },
  "teleport": {
    "num": 100,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Teleport",
    "pp": 15,
    "priority": -6,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "Use it to flee from any wild Pokemon.",
    "shortDesc": "Use it to flee from any wild Pokemon.",
    "flags": {}
  },
  "soulabsorb": {
    "num": 101,
    "accuracy": 100,
    "basePower": 1,
    "category": "Special",
    "name": "Soul Absorb",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "The user absorbs the foe's vital energy, or soul.\nThis deals damage equal to the user's level, and\nrecovers damage equal to the user's level.",
    "shortDesc": "The user absorbs the foe's vital energy, or soul.\nThis deals damage equal to the user's level, and\nrecovers damage equal to the user's level.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "drain": [
      100,
      100
    ],
    "zMove": {
      "basePower": 160
    }
  },
  "mimic": {
    "num": 102,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Mimic",
    "pp": 10,
    "priority": 6,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user copies the target’s last move. The move\ncan be used during battle until the Pokemon is\nswitched out. Z-Effect +1 all stats. +6 Priority.",
    "shortDesc": "The user copies the target’s last move. The move\ncan be used during battle until the Pokemon is\nswitched out. Z-Effect +1 all stats. +6 Priority.",
    "flags": {
      "bypasssub": 1,
      "protect": 1
    }
  },
  "screech": {
    "num": 103,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Screech",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "allAdjacentFoes",
    "desc": "An earsplitting screech that lowers the foe's Defense\nstat by 2 stages. Z-Effect +3 Accuracy.",
    "shortDesc": "An earsplitting screech that lowers the foe's Defense\nstat by 2 stages. Z-Effect +3 Accuracy.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "def": -2
        }
      }
    ]
  },
  "hyperspeed": {
    "num": 104,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Hyper Speed",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user moves so rapidly that it becomes nearly\ninvisible to the human eye, boosting the user's Speed\nstat by 3 stages. Z-Effect gives +1 Attack.",
    "shortDesc": "The user moves so rapidly that it becomes nearly\ninvisible to the human eye, boosting the user's Speed\nstat by 3 stages. Z-Effect gives +1 Attack.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": 3
        }
      }
    ]
  },
  "recover": {
    "num": 105,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Recover",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "Restoring its own cells, the user restores its own HP\nby half of its max HP. Z-Effect +2 Sp. Def.",
    "shortDesc": "Restoring its own cells, the user restores its own HP\nby half of its max HP. Z-Effect +2 Sp. Def.",
    "flags": {
      "snatch": 1
    }
  },
  "harden": {
    "num": 106,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Harden",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user hardens its body, boosting Defense by 1.\nZ-Effect heals user fully.",
    "shortDesc": "The user hardens its body, boosting Defense by 1.\nZ-Effect heals user fully.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "def": 1
        }
      }
    ]
  },
  "deflate": {
    "num": 107,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Deflate",
    "pp": 3,
    "priority": 4,
    "critRatio": 1,
    "type": "Flying",
    "target": "self",
    "desc": "The user deflates itself to recover HP. This heals\nthe user to FULL HP, AND has +4 Priority.\nZ-Effect gives the user +1 to all stats.",
    "shortDesc": "The user deflates itself to recover HP. This heals\nthe user to FULL HP, AND has +4 Priority.\nZ-Effect gives the user +1 to all stats.",
    "flags": {
      "snatch": 1
    }
  },
  "noxiousgas": {
    "num": 108,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Noxious Gas",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "allAdjacentFoes",
    "desc": "The user expels an utterly putrid smelling gas.\nThis poisons the foes while dropping their Attack,\nSp. Atk and Speed stats by 2. Z-Effect +1 All Stats.",
    "shortDesc": "The user expels an utterly putrid smelling gas.\nThis poisons the foes while dropping their Attack,\nSp. Atk and Speed stats by 2. Z-Effect +1 All Stats.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "psn"
      },
      {
        "chance": 100,
        "boosts": {
          "atk": -2
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spa": -2
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spe": -2
        }
      }
    ]
  },
  "confuseray": {
    "num": 109,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Confuse Ray",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "The target is exposed to a sinister ray that\nconfuses them for four turns. Z-Effect +2 Sp. Atk.",
    "shortDesc": "The target is exposed to a sinister ray that\nconfuses them for four turns. Z-Effect +2 Sp. Atk.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "withdraw": {
    "num": 110,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Withdraw",
    "pp": 3,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user withdraws its body into its hard shell,\nraising its Defense and Sp. Def stats by 1.\nZ-Effect heals user fully.",
    "shortDesc": "The user withdraws its body into its hard shell,\nraising its Defense and Sp. Def stats by 1.\nZ-Effect heals user fully.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "def": 1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spd": 1
        }
      }
    ]
  },
  "defensecurl": {
    "num": 111,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Defense Curl",
    "pp": 40,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user curls up to conceal weak spots and raise\nits Defense stat by 1. Z-Effect heals user fully.",
    "shortDesc": "The user curls up to conceal weak spots and raise\nits Defense stat by 1. Z-Effect heals user fully.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "def": 1
        }
      }
    ]
  },
  "barrier": {
    "num": 112,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Barrier",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "self",
    "desc": "The user throws up a psychic wall that raises its\nDefense stat by 2. Z-Effect heals user fully.",
    "shortDesc": "The user throws up a psychic wall that raises its\nDefense stat by 2. Z-Effect heals user fully.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "def": 2
        }
      }
    ]
  },
  "lightscreen": {
    "num": 113,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Light Screen",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "A wondrous wall of light is put up to halve damage\nfrom special attacks for 5 turns. Z-Effect +2 Sp. Atk.",
    "shortDesc": "A wondrous wall of light is put up to halve damage\nfrom special attacks for 5 turns. Z-Effect +2 Sp. Atk.",
    "flags": {
      "snatch": 1
    }
  },
  "haze": {
    "num": 114,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Haze",
    "pp": 30,
    "priority": 4,
    "critRatio": 1,
    "type": "Ice",
    "target": "normal",
    "desc": "The user creates a haze that eliminates every stat\nchange on the field. Z-Effect heals user fully.\nThis has +4 Priority.",
    "shortDesc": "The user creates a haze that eliminates every stat\nchange on the field. Z-Effect heals user fully.\nThis has +4 Priority.",
    "flags": {
      "bypasssub": 1
    }
  },
  "reflect": {
    "num": 115,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Reflect",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "A wondrous wall of light is put up to halve damage of\nphysical attacks for 5 turns. Z-Effect +2 Sp. Atk.",
    "shortDesc": "A wondrous wall of light is put up to halve damage of\nphysical attacks for 5 turns. Z-Effect +2 Sp. Atk.",
    "flags": {
      "snatch": 1
    }
  },
  "focusenergy": {
    "num": 116,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Focus Energy",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user takes a moment to focus. This boosts the\nthe user's crit rate by +2. Z-Effect +2 Speed.",
    "shortDesc": "The user takes a moment to focus. This boosts the\nthe user's crit rate by +2. Z-Effect +2 Speed.",
    "flags": {
      "dance": 1,
      "snatch": 1
    }
  },
  "bide": {
    "num": 117,
    "accuracy": true,
    "basePower": 1,
    "category": "Physical",
    "name": "Bide",
    "pp": 10,
    "priority": 1,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user endures attacks for two turns, then strikes\nback to cause double the damage taken.",
    "shortDesc": "The user endures attacks for two turns, then strikes\nback to cause double the damage taken.",
    "flags": {
      "contact": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "metronome": {
    "num": 118,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Metronome",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user waggles a finger and stimulates its brain\ninto randomly using nearly any move. Z-Effect boosts\nall stats by +1 before using the random Z-move.",
    "shortDesc": "The user waggles a finger and stimulates its brain\ninto randomly using nearly any move. Z-Effect boosts\nall stats by +1 before using the random Z-move.",
    "flags": {}
  },
  "mirrormove": {
    "num": 119,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Mirror Move",
    "pp": 5,
    "priority": 6,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "The user counters the target by mimicking the\ntarget’s last move. Z-Effect +2 Attack.\nThis has +6 Priority.",
    "shortDesc": "The user counters the target by mimicking the\ntarget’s last move. Z-Effect +2 Attack.\nThis has +6 Priority.",
    "flags": {}
  },
  "detonate": {
    "num": 120,
    "accuracy": 100,
    "basePower": 250,
    "category": "Special",
    "name": "Detonate",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "allAdjacent",
    "desc": "The user detonates itself, causing a fiery explosion.\nThis causes the user to faint. In exchange, everything\nhit by the explosion is left with a burn. Ignores Protect.",
    "shortDesc": "The user detonates itself, causing a fiery explosion.\nThis causes the user to faint. In exchange, everything\nhit by the explosion is left with a burn. Ignores Protect.",
    "flags": {
      "defrost": 1,
      "heal": 1,
      "mirror": 1
    },
    "zMove": {
      "basePower": 255
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "brn"
      }
    ]
  },
  "eggcannon": {
    "num": 121,
    "accuracy": 100,
    "basePower": 25,
    "category": "Physical",
    "name": "Egg Cannon",
    "pp": 5,
    "priority": 0,
    "critRatio": 7,
    "type": "Normal",
    "target": "normal",
    "desc": "The user fires a barrage of three exploding eggs.\nThis hits 3 times and ALWAYS lands a critical hit.",
    "shortDesc": "The user fires a barrage of three exploding eggs.\nThis hits 3 times and ALWAYS lands a critical hit.",
    "flags": {
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "willCrit": true,
    "multihit": 3,
    "zMove": {
      "basePower": 190
    }
  },
  "deviouslick": {
    "num": 122,
    "accuracy": true,
    "basePower": 20,
    "category": "Special",
    "name": "Devious Lick",
    "pp": 3,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "The user uses its filthy tongue to lick the foe.\nThis leaves the foe afflicted with a curse, causing\nthem to lose 1/4 of their max HP after each turn.",
    "shortDesc": "The user uses its filthy tongue to lick the foe.\nThis leaves the foe afflicted with a curse, causing\nthem to lose 1/4 of their max HP after each turn.",
    "flags": {
      "bypasssub": 1,
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "10"
      }
    ]
  },
  "smog": {
    "num": 123,
    "accuracy": 100,
    "basePower": 40,
    "category": "Special",
    "name": "Smog",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "allAdjacentFoes",
    "desc": "The foes are attacked with a discharge of filthy gases\nThis ALWAYS poisons those exposed to the smog.",
    "shortDesc": "The foes are attacked with a discharge of filthy gases\nThis ALWAYS poisons those exposed to the smog.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 80
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "psn"
      }
    ]
  },
  "sludgefling": {
    "num": 124,
    "accuracy": 100,
    "basePower": 60,
    "category": "Special",
    "name": "Sludge Fling",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "The user flings thick, slimy sludge at the foe.\nThis ALWAYS lowers the foe's Speed by 1.",
    "shortDesc": "The user flings thick, slimy sludge at the foe.\nThis ALWAYS lowers the foe's Speed by 1.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -1
        }
      }
    ]
  },
  "boneclub": {
    "num": 125,
    "accuracy": 100,
    "basePower": 90,
    "category": "Physical",
    "name": "Bone Club",
    "pp": 1,
    "priority": 4,
    "critRatio": 1,
    "type": "Ground",
    "target": "normal",
    "desc": "The user clubs the target with a hard bone.\nThis ALWAYS lowers the foe's Defense by 1,\nand ALWAYS flinches the foe. +4 Priority.",
    "shortDesc": "The user clubs the target with a hard bone.\nThis ALWAYS lowers the foe's Defense by 1,\nand ALWAYS flinches the foe. +4 Priority.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "25"
      },
      {
        "chance": 100,
        "volatileStatus": "flinch"
      },
      {
        "chance": 100,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "fireblast": {
    "num": 126,
    "accuracy": 90,
    "basePower": 120,
    "category": "Special",
    "name": "Fire Blast",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The target is attacked with an intense blast of\nflames. This burns the target 25% of the time.",
    "shortDesc": "The target is attacked with an intense blast of\nflames. This burns the target 25% of the time.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 195
    },
    "secondaries": [
      {
        "chance": 20,
        "status": "brn"
      }
    ]
  },
  "wavecrash": {
    "num": 127,
    "accuracy": 100,
    "basePower": 125,
    "category": "Physical",
    "name": "Wave Crash",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "The user surges at the target with great force.\nThis deals 25% recoil to the user, and has a 20%\nflinch rate. Contact.",
    "shortDesc": "The user surges at the target with great force.\nThis deals 25% recoil to the user, and has a 20%\nflinch rate. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      1,
      4
    ],
    "zMove": {
      "basePower": 195
    },
    "secondaries": [
      {
        "chance": 20,
        "volatileStatus": "flinch"
      }
    ]
  },
  "clamp": {
    "num": 128,
    "accuracy": 100,
    "basePower": 60,
    "category": "Physical",
    "name": "Clamp",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "The target is clamped and squeezed by the user’s\nsturdy shell for 6 turns, preventing switching and\ndealing 12% of the foe's max HP per turn. Contact.",
    "shortDesc": "The target is clamped and squeezed by the user’s\nsturdy shell for 6 turns, preventing switching and\ndealing 12% of the foe's max HP per turn. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    }
  },
  "swift": {
    "num": 129,
    "accuracy": true,
    "basePower": 55,
    "category": "Special",
    "name": "Swift",
    "pp": 10,
    "priority": 2,
    "critRatio": 1,
    "type": "Normal",
    "target": "allAdjacentFoes",
    "desc": "Star-shaped rays are rapidly shot at foe.\nThis attack has +2 Priority, and can't miss.",
    "shortDesc": "Star-shaped rays are rapidly shot at foe.\nThis attack has +2 Priority, and can't miss.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 110
    }
  },
  "skullbash": {
    "num": 130,
    "accuracy": true,
    "basePower": 90,
    "category": "Physical",
    "name": "Skull Bash",
    "pp": 5,
    "priority": 0,
    "critRatio": 7,
    "type": "Normal",
    "target": "normal",
    "desc": "On the 1st turn, the user tucks in its head, raising\nDefense by 1. On the 2nd, the user charges, gaining\n+1 Attack & Accuracy. ALWAYS crits, Ignores protect.",
    "shortDesc": "On the 1st turn, the user tucks in its head, raising\nDefense by 1. On the 2nd, the user charges, gaining\n+1 Attack & Accuracy. ALWAYS crits, Ignores protect.",
    "flags": {
      "charge": 1,
      "contact": 1,
      "mirror": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 200
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "atk": 1
          }
        }
      },
      {
        "chance": 100,
        "self": {
          "boosts": {
            "accuracy": 1
          }
        }
      }
    ]
  },
  "burningbarrage": {
    "num": 131,
    "accuracy": 100,
    "basePower": 20,
    "category": "Physical",
    "name": "Burning Barrage",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The user fires three burning projectiles at the foe.\nThis will ALWAYS leave the target with a burn.",
    "shortDesc": "The user fires three burning projectiles at the foe.\nThis will ALWAYS leave the target with a burn.",
    "flags": {
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": 3,
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "brn"
      }
    ]
  },
  "constrict": {
    "num": 132,
    "accuracy": 100,
    "basePower": 60,
    "category": "Physical",
    "name": "Constrict",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The target is constricted with thick, strong vines.\nFor 6 turns, the foe can't switch out of battle and\nloses 12% of their max HP after each turn. Contact.",
    "shortDesc": "The target is constricted with thick, strong vines.\nFor 6 turns, the foe can't switch out of battle and\nloses 12% of their max HP after each turn. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -1
        }
      }
    ]
  },
  "amnesia": {
    "num": 133,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Amnesia",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "self",
    "desc": "The user temporarily empties its mind to forget its\nconcerns. This raises the user's Sp. Def by +2.\nZ-Effect heals user fully.",
    "shortDesc": "The user temporarily empties its mind to forget its\nconcerns. This raises the user's Sp. Def by +2.\nZ-Effect heals user fully.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "spd": 2
        }
      }
    ]
  },
  "kinesis": {
    "num": 134,
    "accuracy": 80,
    "basePower": 0,
    "category": "Status",
    "name": "Kinesis",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user distracts the target by bending a spoon.\nThis lowers the target’s accuracy.",
    "shortDesc": "The user distracts the target by bending a spoon.\nThis lowers the target’s accuracy.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "accuracy": -1
        }
      }
    ]
  },
  "softboiled": {
    "num": 135,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Soft-Boiled",
    "pp": 3,
    "priority": 4,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user consumes the egg it holds, healing itself to\nfull HP. This has +4 Priority, but only 2 PP.\nZ-Effect gives the user +3 Speed.",
    "shortDesc": "The user consumes the egg it holds, healing itself to\nfull HP. This has +4 Priority, but only 2 PP.\nZ-Effect gives the user +3 Speed.",
    "flags": {
      "snatch": 1
    }
  },
  "divebomb": {
    "num": 136,
    "accuracy": 90,
    "basePower": 140,
    "category": "Physical",
    "name": "Divebomb",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "The user recklessly dives onto the target from above.\nIf it misses, the user loses half max HP. Contact.",
    "shortDesc": "The user recklessly dives onto the target from above.\nIf it misses, the user loses half max HP. Contact.",
    "flags": {
      "contact": 1,
      "gravity": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 200
    }
  },
  "glare": {
    "num": 137,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Glare",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user intimidates the target with a glare,\ncausing paralysis AND lowering offensive stats by 1.\nZ-Effect gives +2 Attack.",
    "shortDesc": "The user intimidates the target with a glare,\ncausing paralysis AND lowering offensive stats by 1.\nZ-Effect gives +2 Attack.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      }
    ]
  },
  "dreameater": {
    "num": 138,
    "accuracy": 100,
    "basePower": 120,
    "category": "Special",
    "name": "Dream Eater",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user eats the dreams of a sleeping target. It\nabsorbs 100% of the damage caused to heal its own HP.",
    "shortDesc": "The user eats the dreams of a sleeping target. It\nabsorbs 100% of the damage caused to heal its own HP.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "drain": [
      100,
      100
    ],
    "zMove": {
      "basePower": 195
    }
  },
  "poisongas": {
    "num": 139,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Poison Gas",
    "pp": 40,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "allAdjacentFoes",
    "desc": "A cloud of poison gas is sprayed at the opponents,\npoisoning those hit. Z-Effect +2 Sp. Atk.",
    "shortDesc": "A cloud of poison gas is sprayed at the opponents,\npoisoning those hit. Z-Effect +2 Sp. Atk.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "psn"
      }
    ]
  },
  "triplecannonade": {
    "num": 140,
    "accuracy": 100,
    "basePower": 25,
    "category": "Physical",
    "name": "Triple Cannonade",
    "pp": 3,
    "priority": 0,
    "critRatio": 7,
    "type": "Steel",
    "target": "normal",
    "desc": "Three rounds of heavy artillery are fired at the foe.\nThis ALWAYS results in a critical hit, hits 3 times,\nand bypasses Protect.",
    "shortDesc": "Three rounds of heavy artillery are fired at the foe.\nThis ALWAYS results in a critical hit, hits 3 times,\nand bypasses Protect.",
    "flags": {
      "bullet": 1,
      "heal": 1,
      "mirror": 1
    },
    "willCrit": true,
    "multihit": 3,
    "zMove": {
      "basePower": 190
    }
  },
  "leechlife": {
    "num": 141,
    "accuracy": 100,
    "basePower": 60,
    "category": "Physical",
    "name": "Leech Life",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Bug",
    "target": "normal",
    "desc": "The user drains the target’s vital fluids.\nThis heals the user by ALL damage dealt. Contact.",
    "shortDesc": "The user drains the target’s vital fluids.\nThis heals the user by ALL damage dealt. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "drain": [
      100,
      100
    ],
    "zMove": {
      "basePower": 120
    }
  },
  "dreamykiss": {
    "num": 142,
    "accuracy": 85,
    "basePower": 0,
    "category": "Status",
    "name": "Dreamy Kiss",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user kisses the target dreamily, causing the\ntarget to sleep for 2 turns. Z-Effect +2 Sp. Def.",
    "shortDesc": "The user kisses the target dreamily, causing the\ntarget to sleep for 2 turns. Z-Effect +2 Sp. Def.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1,
      "sound": 1
    }
  },
  "skyattack": {
    "num": 143,
    "accuracy": true,
    "basePower": 120,
    "category": "Physical",
    "name": "Sky Attack",
    "pp": 5,
    "priority": 0,
    "critRatio": 7,
    "type": "Flying",
    "target": "normal",
    "desc": "A 2 turn attack where the user soars from the sky\nwith full power. This ALWAYS crits.\n30% Flinch rate. Ignores protect. Contact.",
    "shortDesc": "A 2 turn attack where the user soars from the sky\nwith full power. This ALWAYS crits.\n30% Flinch rate. Ignores protect. Contact.",
    "flags": {
      "charge": 1,
      "mirror": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 220
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "transform": {
    "num": 144,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Transform",
    "pp": 10,
    "priority": 6,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user transforms into an identical copy of the foe,\nbesides the HP stat. Z-Effect heals user.\nThis has +6 priority.",
    "shortDesc": "The user transforms into an identical copy of the foe,\nbesides the HP stat. Z-Effect heals user.\nThis has +6 priority.",
    "flags": {}
  },
  "bubblebarrage": {
    "num": 145,
    "accuracy": 100,
    "basePower": 20,
    "category": "Special",
    "name": "Bubble Barrage",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "The user fires a barrage of bubbles at the foe.\nHits 3 times. Each hit lowers the foe's Speed by 1.",
    "shortDesc": "The user fires a barrage of bubbles at the foe.\nHits 3 times. Each hit lowers the foe's Speed by 1.",
    "flags": {
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": 3,
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -1
        }
      }
    ]
  },
  "dizzypunches": {
    "num": 146,
    "accuracy": 100,
    "basePower": 30,
    "category": "Physical",
    "name": "Dizzy Punches",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The target is hit with 3 punches imbued with psychic\nenergy. Each hit has a 30% chance to confuse for 4\nturns. Contact.",
    "shortDesc": "The target is hit with 3 punches imbued with psychic\nenergy. Each hit has a 30% chance to confuse for 4\nturns. Contact.",
    "flags": {
      "contact": 1,
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": 3,
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 30,
        "status": "tox"
      }
    ]
  },
  "spore": {
    "num": 147,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Spore",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user scatters bursts of spores that\ninduce sleep for 2 turns. Z-Effect +2 Sp. Def.",
    "shortDesc": "The user scatters bursts of spores that\ninduce sleep for 2 turns. Z-Effect +2 Sp. Def.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "neuralyze": {
    "num": 148,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Neuralyze",
    "pp": 5,
    "priority": 6,
    "critRatio": 1,
    "type": "Psychic",
    "target": "allAdjacentFoes",
    "desc": "The user flashes a strange light that wipes the foe's\nmemory, causing them to forget their last used move\nfor 15 turns. +6 Priority. Z-Effect +3 Sp. Def.",
    "shortDesc": "The user flashes a strange light that wipes the foe's\nmemory, causing them to forget their last used move\nfor 15 turns. +6 Priority. Z-Effect +3 Sp. Def.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "pendulumwave": {
    "num": 149,
    "accuracy": true,
    "basePower": 0,
    "category": "Special",
    "name": "Pendulum Wave",
    "pp": 1,
    "priority": 4,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "Hypno swings its pendulum, firing off a psywave that\nvaries in power, and sleeps the foe for 2 FULL turns\nAFTER its used. +4 Priority. Z-Effect +2 Speed.",
    "shortDesc": "Hypno swings its pendulum, firing off a psywave that\nvaries in power, and sleeps the foe for 2 FULL turns\nAFTER its used. +4 Priority. Z-Effect +2 Speed.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "slp"
      }
    ]
  },
  "hop": {
    "num": 150,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Hop",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user just hops around, doing absolutely nothing.\nZ-Effect +3 Attack.",
    "shortDesc": "The user just hops around, doing absolutely nothing.\nZ-Effect +3 Attack.",
    "flags": {
      "gravity": 1
    }
  },
  "acidarmor": {
    "num": 151,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Acid Armor",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "self",
    "desc": "The user alters its cellular structure to liquefy itself,\nraising Defense by 3. Z-Effect heals user fully.",
    "shortDesc": "The user alters its cellular structure to liquefy itself,\nraising Defense by 3. Z-Effect heals user fully.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "def": 3
        }
      }
    ]
  },
  "crabhammer": {
    "num": 152,
    "accuracy": true,
    "basePower": 80,
    "category": "Physical",
    "name": "Crabhammer",
    "pp": 5,
    "priority": 0,
    "critRatio": 7,
    "type": "Water",
    "target": "normal",
    "desc": "The target is hammered hard with the user's pincer.\nThis ALWAYS crits and can't miss.\n30% Defense drop rate. Contact.",
    "shortDesc": "The target is hammered hard with the user's pincer.\nThis ALWAYS crits and can't miss.\n30% Defense drop rate. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 190
    },
    "secondaries": [
      {
        "chance": 30,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "explosion": {
    "num": 153,
    "accuracy": 100,
    "basePower": 250,
    "category": "Special",
    "name": "Explosion",
    "pp": 5,
    "priority": 0,
    "critRatio": 7,
    "type": "Normal",
    "target": "allAdjacent",
    "desc": "The user blows itself up, causing massive destruction.\nThis will ALWAYS result in a critical hit.\nThis also bypasses Protect.",
    "shortDesc": "The user blows itself up, causing massive destruction.\nThis will ALWAYS result in a critical hit.\nThis also bypasses Protect.",
    "flags": {
      "heal": 1,
      "mirror": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 255
    }
  },
  "furyswipes": {
    "num": 154,
    "accuracy": 100,
    "basePower": 25,
    "category": "Physical",
    "name": "Fury Swipes",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The target is raked with sharp claws, scythes, or the\nlike furiously 2-5 times in a row. Contact.",
    "shortDesc": "The target is raked with sharp claws, scythes, or the\nlike furiously 2-5 times in a row. Contact.",
    "flags": {
      "contact": 1,
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": [
      2,
      5
    ],
    "zMove": {
      "basePower": 140
    }
  },
  "bonemerang": {
    "num": 155,
    "accuracy": 100,
    "basePower": 60,
    "category": "Physical",
    "name": "Bonemerang",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "normal",
    "desc": "The user throws a bone like a boomerang, hitting 2\ntimes. Each hit has a 20% flinch rate.",
    "shortDesc": "The user throws a bone like a boomerang, hitting 2\ntimes. Each hit has a 20% flinch rate.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "multihit": 2,
    "zMove": {
      "basePower": 190
    },
    "secondaries": [
      {
        "chance": 20,
        "volatileStatus": "flinch"
      }
    ]
  },
  "rest": {
    "num": 156,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Rest",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user goes to sleep for two turns. This fully\nrestores the user’s HP and heals any\nstatus conditions. Z-Effect +2 Sp. Def.",
    "shortDesc": "The user goes to sleep for two turns. This fully\nrestores the user’s HP and heals any\nstatus conditions. Z-Effect +2 Sp. Def.",
    "flags": {
      "snatch": 1
    }
  },
  "rockslide": {
    "num": 157,
    "accuracy": 95,
    "basePower": 95,
    "category": "Physical",
    "name": "Rock Slide",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Rock",
    "target": "allAdjacentFoes",
    "desc": "Large boulders are hurled at the opposing Pokemon\nto inflict damage. This flinches 30% of the time.",
    "shortDesc": "Large boulders are hurled at the opposing Pokemon\nto inflict damage. This flinches 30% of the time.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "hyperfang": {
    "num": 158,
    "accuracy": true,
    "basePower": 80,
    "category": "Physical",
    "name": "Hyper Fang",
    "pp": 5,
    "priority": 0,
    "critRatio": 7,
    "type": "Normal",
    "target": "normal",
    "desc": "The user bites the foe with specialized front teeth.\nThis will ALWAYS result in a critical hit, and has a\n30% flinch rate, and can't miss. Contact.",
    "shortDesc": "The user bites the foe with specialized front teeth.\nThis will ALWAYS result in a critical hit, and has a\n30% flinch rate, and can't miss. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 190
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "fortify": {
    "num": 159,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Fortify",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "self",
    "desc": "The user fortifies the metal on its body.\nThis heals the user by 50% of their max HP.\nZ-Effect gives +2 Defense.",
    "shortDesc": "The user fortifies the metal on its body.\nThis heals the user by 50% of their max HP.\nZ-Effect gives +2 Defense.",
    "flags": {
      "snatch": 1
    }
  },
  "acclimate": {
    "num": 160,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Acclimate",
    "pp": 30,
    "priority": 4,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user changes its type to become the same type\nas the move at the top of the list of moves it knows.\nZ-Effect +1 all stats. +4 Priority.",
    "shortDesc": "The user changes its type to become the same type\nas the move at the top of the list of moves it knows.\nZ-Effect +1 all stats. +4 Priority.",
    "flags": {
      "snatch": 1
    }
  },
  "triattack": {
    "num": 161,
    "accuracy": 100,
    "basePower": 35,
    "category": "Special",
    "name": "Tri Attack",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user fires three volatile beams of energy.\nThis hits 3 times, with each hit having a 10% chance\nto either burn, paralyze or freeze, totaling to 27%.",
    "shortDesc": "The user fires three volatile beams of energy.\nThis hits 3 times, with each hit having a 10% chance\nto either burn, paralyze or freeze, totaling to 27%.",
    "flags": {
      "defrost": 1,
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": 3,
    "zMove": {
      "basePower": 180
    },
    "secondaries": [
      {
        "chance": 10,
        "volatileStatus": "25"
      }
    ]
  },
  "superfang": {
    "num": 162,
    "accuracy": true,
    "basePower": 1,
    "category": "Physical",
    "name": "Super Fang",
    "pp": 1,
    "priority": 4,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user chomps hard on the target with its sharp\nfront fangs. This cuts the target’s HP in half. Contact.\nThis has +4 Priority and ALWAYS flinches the foe.",
    "shortDesc": "The user chomps hard on the target with its sharp\nfront fangs. This cuts the target’s HP in half. Contact.\nThis has +4 Priority and ALWAYS flinches the foe.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "flinch"
      }
    ]
  },
  "slash": {
    "num": 163,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Slash",
    "pp": 10,
    "priority": 0,
    "critRatio": 3,
    "type": "Normal",
    "target": "normal",
    "desc": "The target is attacked with a slash of claws, blades,\nor the like. This has a 50% (+2) crit rate. Contact.",
    "shortDesc": "The target is attacked with a slash of claws, blades,\nor the like. This has a 50% (+2) crit rate. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    }
  },
  "substitute": {
    "num": 164,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Substitute",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user makes a decoy using 25% of it's HP. This\ndecoy can absorb most attacks for the user.\nZ-Effect +3 Accuracy.",
    "shortDesc": "The user makes a decoy using 25% of it's HP. This\ndecoy can absorb most attacks for the user.\nZ-Effect +3 Accuracy.",
    "flags": {
      "snatch": 1
    }
  },
  "struggle": {
    "num": 165,
    "accuracy": true,
    "basePower": 50,
    "category": "Physical",
    "name": "Struggle",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "randomNormal",
    "desc": "This attack is used in desperation only if the user\nhas no PP. It has 50% recoil for the user.",
    "shortDesc": "This attack is used in desperation only if the user\nhas no PP. It has 50% recoil for the user.",
    "flags": {
      "contact": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 1
    }
  },
  "sketch": {
    "num": 166,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Sketch",
    "pp": 1,
    "priority": 6,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "Smeargle instantly learns the last used move.\nThis has +6 priority now, because the Z-Effect gives\nSmeargle +1 to all of its stats.",
    "shortDesc": "Smeargle instantly learns the last used move.\nThis has +6 priority now, because the Z-Effect gives\nSmeargle +1 to all of its stats.",
    "flags": {
      "bypasssub": 1
    }
  },
  "triplekick": {
    "num": 167,
    "accuracy": true,
    "basePower": 10,
    "category": "Physical",
    "name": "Triple Kick",
    "pp": 10,
    "priority": 0,
    "critRatio": 7,
    "type": "Fighting",
    "target": "normal",
    "desc": "This kick ALWAYS lands a critical hit, and won't\nmiss anymore. It's effectively 15, 30 and then 45 BP.\nThis adds up to 90 BP overall. Contact.",
    "shortDesc": "This kick ALWAYS lands a critical hit, and won't\nmiss anymore. It's effectively 15, 30 and then 45 BP.\nThis adds up to 90 BP overall. Contact.",
    "flags": {
      "contact": 1,
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "willCrit": true,
    "multihit": 3,
    "zMove": {
      "basePower": 175
    }
  },
  "thief": {
    "num": 168,
    "accuracy": 100,
    "basePower": 60,
    "category": "Physical",
    "name": "Thief",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user attacks and steals the target’s held item\nsimultaneously. The user can’t steal anything if it\nalready holds an item. Contact.",
    "shortDesc": "The user attacks and steals the target’s held item\nsimultaneously. The user can’t steal anything if it\nalready holds an item. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    }
  },
  "spiderweb": {
    "num": 169,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Spider Web",
    "pp": 10,
    "priority": 4,
    "critRatio": 1,
    "type": "Bug",
    "target": "normal",
    "desc": "The user ensnares the target within it's web. This\nhas +4 priority, prevents the foe from switching, and\ndrops Defense & Evasion by 3. Z-Effect +1 all stats.",
    "shortDesc": "The user ensnares the target within it's web. This\nhas +4 priority, prevents the foe from switching, and\ndrops Defense & Evasion by 3. Z-Effect +1 all stats.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -4
        }
      },
      {
        "chance": 100,
        "boosts": {
          "evasion": -4
        }
      }
    ]
  },
  "mindreader": {
    "num": 170,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Mind Reader",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user senses the target’s movements with its\nmind to ensure its next attack does not miss\nthe target. Z-Effect +3 Sp. Atk.",
    "shortDesc": "The user senses the target’s movements with its\nmind to ensure its next attack does not miss\nthe target. Z-Effect +3 Sp. Atk.",
    "flags": {
      "mirror": 1,
      "protect": 1
    }
  },
  "nightmare": {
    "num": 171,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Nightmare",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user inflicts the foe with a horrible nightmare\nif it's asleep, making it lose 25% of it's HP per turn.\nZ-Effect +1 all stats.",
    "shortDesc": "The user inflicts the foe with a horrible nightmare\nif it's asleep, making it lose 25% of it's HP per turn.\nZ-Effect +1 all stats.",
    "flags": {
      "mirror": 1,
      "protect": 1
    }
  },
  "flamewheel": {
    "num": 172,
    "accuracy": 100,
    "basePower": 60,
    "category": "Physical",
    "name": "Flame Wheel",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The user cloaks itself in fire and charges at the\ntarget spinning.This boosts the user's Speed by 1.\nContact.",
    "shortDesc": "The user cloaks itself in fire and charges at the\ntarget spinning.This boosts the user's Speed by 1.\nContact.",
    "flags": {
      "contact": 1,
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 110
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "spe": 1
          }
        }
      }
    ]
  },
  "snore": {
    "num": 173,
    "accuracy": 100,
    "basePower": 60,
    "category": "Special",
    "name": "Snore",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "This attack can be used only if the user is asleep.\nThe harsh noise will ALWAYS flinch the target.",
    "shortDesc": "This attack can be used only if the user is asleep.\nThe harsh noise will ALWAYS flinch the target.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "punch": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "flinch"
      }
    ]
  },
  "conjure": {
    "num": 174,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Conjure",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "The user gathers energy from the \"other side.\"\nThis boosts the user's Defense & Sp. Atk by 1.\nZ-Effect gives +2 Sp. Def. Only works on Ghost types.",
    "shortDesc": "The user gathers energy from the \"other side.\"\nThis boosts the user's Defense & Sp. Atk by 1.\nZ-Effect gives +2 Sp. Def. Only works on Ghost types.",
    "flags": {
      "dance": 1,
      "mirror": 1,
      "reflectable": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spa": 1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "def": 1
        }
      }
    ]
  },
  "flail": {
    "num": 175,
    "accuracy": true,
    "basePower": 1,
    "category": "Physical",
    "name": "Flail",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user flails about aimlessly to attack. The less HP\nthe user has, the greater the move’s power. This\ncannot miss, and makes contact.",
    "shortDesc": "The user flails about aimlessly to attack. The less HP\nthe user has, the greater the move’s power. This\ncannot miss, and makes contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    }
  },
  "accustom": {
    "num": 176,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Accustom",
    "pp": 30,
    "priority": 4,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user changes its type to make itself resistant to\nthe type of the attack the opponent used last.\nZ-Effect +1 all stats. +4 Priority.",
    "shortDesc": "The user changes its type to make itself resistant to\nthe type of the attack the opponent used last.\nZ-Effect +1 all stats. +4 Priority.",
    "flags": {
      "bypasssub": 1
    }
  },
  "aeroblast": {
    "num": 177,
    "accuracy": 100,
    "basePower": 65,
    "category": "Special",
    "name": "Aeroblast",
    "pp": 5,
    "priority": 0,
    "critRatio": 7,
    "type": "Flying",
    "target": "normal",
    "desc": "A fierce vortex of air is shot at the target.\nThis ALWAYS results in a critical hit.\nThis is now a Sound Move.",
    "shortDesc": "A fierce vortex of air is shot at the target.\nThis ALWAYS results in a critical hit.\nThis is now a Sound Move.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "punch": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 175
    }
  },
  "cottonspore": {
    "num": 178,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Cotton Spore",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "allAdjacentFoes",
    "desc": "The user releases cotton-like spores that cling to\nthe foes, lowering Speed by 2, and Sp. Atk by 2.\nZ-Effect gives the user +3 Defense.",
    "shortDesc": "The user releases cotton-like spores that cling to\nthe foes, lowering Speed by 2, and Sp. Atk by 2.\nZ-Effect gives the user +3 Defense.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -2
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spa": -2
        }
      }
    ]
  },
  "reversal": {
    "num": 179,
    "accuracy": true,
    "basePower": 1,
    "category": "Physical",
    "name": "Reversal",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "An all-out attack that becomes more powerful the\nless HP the user has. This can't miss. Contact.",
    "shortDesc": "An all-out attack that becomes more powerful the\nless HP the user has. This can't miss. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    }
  },
  "spitefulspell": {
    "num": 180,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Spiteful Spell",
    "pp": 5,
    "priority": 4,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "The user casts a spiteful spell on the foe, disabling\nfairy moves for 15 turns and removing 4 PP.\nThis has +4 Priority. Z-Effect heals user.",
    "shortDesc": "The user casts a spiteful spell on the foe, disabling\nfairy moves for 15 turns and removing 4 PP.\nThis has +4 Priority. Z-Effect heals user.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "24"
      }
    ]
  },
  "frostflurry": {
    "num": 181,
    "accuracy": true,
    "basePower": 45,
    "category": "Special",
    "name": "Frost Flurry",
    "pp": 20,
    "priority": 1,
    "critRatio": 1,
    "type": "Ice",
    "target": "allAdjacentFoes",
    "desc": "The user attacks with a rapid flurry of frost. This\nattack has +1 priority, and can't miss.",
    "shortDesc": "The user attacks with a rapid flurry of frost. This\nattack has +1 priority, and can't miss.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 90
    }
  },
  "protect": {
    "num": 182,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Protect",
    "pp": 10,
    "priority": 6,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "Enables the user to evade all attacks. Its chance of\nfailing rises if it is used in succession.\nZ-Effect resets lowered stats.",
    "shortDesc": "Enables the user to evade all attacks. Its chance of\nfailing rises if it is used in succession.\nZ-Effect resets lowered stats.",
    "flags": {}
  },
  "machpunch": {
    "num": 183,
    "accuracy": true,
    "basePower": 45,
    "category": "Physical",
    "name": "Mach Punch",
    "pp": 20,
    "priority": 1,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user throws a punch at blinding speed. This\nattack has +1 priority, and can't miss. Contact.",
    "shortDesc": "The user throws a punch at blinding speed. This\nattack has +1 priority, and can't miss. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 90
    }
  },
  "scaryface": {
    "num": 184,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Scary Face",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user scares the target with a frightening face. \nThis drops Attack AND Speed by 2, and inflicts a\nsleeping foe with a nightmare. Z-Effect +2 crit rate.",
    "shortDesc": "The user scares the target with a frightening face. \nThis drops Attack AND Speed by 2, and inflicts a\nsleeping foe with a nightmare. Z-Effect +2 crit rate.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "9"
      },
      {
        "chance": 0,
        "boosts": {
          "spe": -2
        }
      },
      {
        "chance": 0,
        "boosts": {
          "atk": -2
        }
      }
    ]
  },
  "wickedblow": {
    "num": 185,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Wicked Blow",
    "pp": 3,
    "priority": 0,
    "critRatio": 7,
    "type": "Dark",
    "target": "normal",
    "desc": "The user strikes the target with a wicked blow. This\nattack always results in a critical hit. Contact.\nThis attack bypasses Protect.",
    "shortDesc": "The user strikes the target with a wicked blow. This\nattack always results in a critical hit. Contact.\nThis attack bypasses Protect.",
    "flags": {
      "contact": 1,
      "mirror": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 190
    }
  },
  "charmingkiss": {
    "num": 186,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Charming Kiss",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user kisses the foe in a charming, calming manner.\nThis lowers the foe's Attack by 2 in addition to\nputting the foe to sleep for 2 turns. Z-Effect heals.",
    "shortDesc": "The user kisses the foe in a charming, calming manner.\nThis lowers the foe's Attack by 2 in addition to\nputting the foe to sleep for 2 turns. Z-Effect heals.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1,
      "sound": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "atk": -2
        }
      }
    ]
  },
  "bellydrum": {
    "num": 187,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Belly Drum",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user maximizes its Attack stat in exchange for\n50% of it's max HP. Z-Effect heals user fully.",
    "shortDesc": "The user maximizes its Attack stat in exchange for\n50% of it's max HP. Z-Effect heals user fully.",
    "flags": {
      "dance": 1,
      "snatch": 1
    }
  },
  "sludgebomb": {
    "num": 188,
    "accuracy": 100,
    "basePower": 95,
    "category": "Special",
    "name": "Sludge Bomb",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "Unsanitary sludge explodes all over the target.\nThis attack poisons 30% of the time.",
    "shortDesc": "Unsanitary sludge explodes all over the target.\nThis attack poisons 30% of the time.",
    "flags": {
      "bullet": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 30,
        "status": "psn"
      }
    ]
  },
  "mudfling": {
    "num": 189,
    "accuracy": 100,
    "basePower": 60,
    "category": "Special",
    "name": "Mud Fling",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "normal",
    "desc": "The user flings mud at the target, slowing it down.\nThis drops the foe's Speed by one 100% of the time.",
    "shortDesc": "The user flings mud at the target, slowing it down.\nThis drops the foe's Speed by one 100% of the time.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -1
        }
      }
    ]
  },
  "scumshot": {
    "num": 190,
    "accuracy": true,
    "basePower": 60,
    "category": "Special",
    "name": "Scum Shot",
    "pp": 1,
    "priority": 4,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "The user rapidly shoots a dark, foul muck at the foe,\nstartling them. This has +4 Priority, and will ALWAYS\nflinch as well as BADLY poison the foe.",
    "shortDesc": "The user rapidly shoots a dark, foul muck at the foe,\nstartling them. This has +4 Priority, and will ALWAYS\nflinch as well as BADLY poison the foe.",
    "flags": {
      "bullet": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "psn"
      },
      {
        "chance": 100,
        "volatileStatus": "flinch"
      }
    ]
  },
  "spikes": {
    "num": 191,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Spikes",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "normal",
    "desc": "The user lays a trap of spikes at the opposing side.\nThis damages foes that switch in, for 12-25% of their\nHP depending on how many layers. Z-Effect +3 Defense.",
    "shortDesc": "The user lays a trap of spikes at the opposing side.\nThis damages foes that switch in, for 12-25% of their\nHP depending on how many layers. Z-Effect +3 Defense.",
    "flags": {
      "reflectable": 1
    }
  },
  "zapcannon": {
    "num": 192,
    "accuracy": 100,
    "basePower": 150,
    "category": "Special",
    "name": "Zap Cannon",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "The user fires an intensely powerful blast of\nelectricity at the foe. This lowers the user's Sp. Atk\nstat by 2 after use.",
    "shortDesc": "The user fires an intensely powerful blast of\nelectricity at the foe. This lowers the user's Sp. Atk\nstat by 2 after use.",
    "flags": {
      "bullet": 1,
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "spa": -2
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "investigate": {
    "num": 193,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Investigate",
    "pp": 40,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "Gumshoos investigates the target, allowing them to\nbe hit by Normal or Fighting moves, even if they're\na Ghost-type. Z-EFFECT GIVES +3 ATTACK.",
    "shortDesc": "Gumshoos investigates the target, allowing them to\nbe hit by Normal or Fighting moves, even if they're\na Ghost-type. Z-EFFECT GIVES +3 ATTACK.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "destinybond": {
    "num": 194,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Destiny Bond",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "self",
    "desc": "After using this move, if the user faints, the\nPokemon that landed the knockout hit also faints.\nZ-Effect heals the user's replacement fully.",
    "shortDesc": "After using this move, if the user faints, the\nPokemon that landed the knockout hit also faints.\nZ-Effect heals the user's replacement fully.",
    "flags": {
      "bypasssub": 1
    }
  },
  "perishsong": {
    "num": 195,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Perish Song",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "Any Pokemon that hears this sound faints in 3 turns.\nSwitching out removes this timer.\nZ-Effect heals user fully.",
    "shortDesc": "Any Pokemon that hears this sound faints in 3 turns.\nSwitching out removes this timer.\nZ-Effect heals user fully.",
    "flags": {
      "bypasssub": 1
    }
  },
  "icywind": {
    "num": 196,
    "accuracy": 100,
    "basePower": 60,
    "category": "Special",
    "name": "Icy Wind",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Ice",
    "target": "allAdjacentFoes",
    "desc": "The user attacks with a gust of freezing air. This\nalways lowers the foe's Speed stat by 1.",
    "shortDesc": "The user attacks with a gust of freezing air. This\nalways lowers the foe's Speed stat by 1.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -1
        }
      }
    ]
  },
  "detect": {
    "num": 197,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Detect",
    "pp": 10,
    "priority": 6,
    "critRatio": 1,
    "type": "Fighting",
    "target": "self",
    "desc": "Enables the user to evade all attacks. Its chance of\nfailing rises if it is used in succession.\nZ-Effect will heal the user fully while protected.",
    "shortDesc": "Enables the user to evade all attacks. Its chance of\nfailing rises if it is used in succession.\nZ-Effect will heal the user fully while protected.",
    "flags": {
      "snatch": 1
    }
  },
  "bonerush": {
    "num": 198,
    "accuracy": true,
    "basePower": 50,
    "category": "Physical",
    "name": "Bone Rush",
    "pp": 15,
    "priority": 1,
    "critRatio": 1,
    "type": "Ground",
    "target": "normal",
    "desc": "The user quickly throws a hard bone at the foe.\nThis has +1 priority, and can't miss.",
    "shortDesc": "The user quickly throws a hard bone at the foe.\nThis has +1 priority, and can't miss.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "lockon": {
    "num": 199,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Lock-On",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "normal",
    "desc": "The user takes sure aim at the target. This ensures\nthe next attack does not miss the target.\nZ-Effect +3 Sp. Atk.",
    "shortDesc": "The user takes sure aim at the target. This ensures\nthe next attack does not miss the target.\nZ-Effect +3 Sp. Atk.",
    "flags": {
      "mirror": 1,
      "protect": 1
    }
  },
  "outrage": {
    "num": 200,
    "accuracy": true,
    "basePower": 130,
    "category": "Physical",
    "name": "Outrage",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Dragon",
    "target": "randomNormal",
    "desc": "The user rampages and attacks for two to three\nturns. The user then becomes confused. Contact.",
    "shortDesc": "The user rampages and attacks for two to three\nturns. The user then becomes confused. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 190
    }
  },
  "sandstorm": {
    "num": 201,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Sandstorm",
    "pp": 5,
    "priority": 4,
    "critRatio": 1,
    "type": "Rock",
    "target": "normal",
    "desc": "The user summons a sandstorm.\nZ-Effect gives +2 Defense.\nTHIS HAS +4 PRIORITY.",
    "shortDesc": "The user summons a sandstorm.\nZ-Effect gives +2 Defense.\nTHIS HAS +4 PRIORITY.",
    "flags": {}
  },
  "gigadrain": {
    "num": 202,
    "accuracy": 100,
    "basePower": 75,
    "category": "Special",
    "name": "Giga Drain",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "A powerful nutrient-draining attack. The user’s HP is\nrestored by 50% of the damage taken by the target.",
    "shortDesc": "A powerful nutrient-draining attack. The user’s HP is\nrestored by 50% of the damage taken by the target.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "drain": [
      1,
      2
    ],
    "zMove": {
      "basePower": 150
    }
  },
  "endure": {
    "num": 203,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Endure",
    "pp": 10,
    "priority": 6,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user endures any attack with at least 1 HP.\nIts chance of failing rises if it is used in succession.\nZ-Effect +2 Speed.",
    "shortDesc": "The user endures any attack with at least 1 HP.\nIts chance of failing rises if it is used in succession.\nZ-Effect +2 Speed.",
    "flags": {}
  },
  "charm": {
    "num": 204,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Charm",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user gazes at the target rather charmingly,\nmaking it less wary. This lowers their Attack by 2.\nZ-Charm +2 Attack.",
    "shortDesc": "The user gazes at the target rather charmingly,\nmaking it less wary. This lowers their Attack by 2.\nZ-Charm +2 Attack.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1,
      "sound": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "atk": -2
        }
      }
    ]
  },
  "rollout": {
    "num": 205,
    "accuracy": 90,
    "basePower": 30,
    "category": "Physical",
    "name": "Rollout",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Rock",
    "target": "normal",
    "desc": "The user continually rolls into the target over five\nturns. It becomes more powerful each time it hits. Contact.",
    "shortDesc": "The user continually rolls into the target over five\nturns. It becomes more powerful each time it hits. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "falsestrike": {
    "num": 206,
    "accuracy": true,
    "basePower": 45,
    "category": "Physical",
    "name": "False Strike",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Dragon",
    "target": "normal",
    "desc": "The user feigns a strike that will never faint the\ntarget. In exchange, this boosts the user's Attack\nand Accuracy by 1 after use. Can't miss. Contact.",
    "shortDesc": "The user feigns a strike that will never faint the\ntarget. In exchange, this boosts the user's Attack\nand Accuracy by 1 after use. Can't miss. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 90
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "atk": 1
          }
        }
      },
      {
        "chance": 100,
        "self": {
          "boosts": {
            "accuracy": 1
          }
        }
      }
    ]
  },
  "swagger": {
    "num": 207,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Swagger",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user enrages and confuses the target for 3 turns.\nThis raises their Attack by 2, making them hit\nthemselves for more damage. Z-Effect +2 Attack.",
    "shortDesc": "The user enrages and confuses the target for 3 turns.\nThis raises their Attack by 2, making them hit\nthemselves for more damage. Z-Effect +2 Attack.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "tox"
      },
      {
        "chance": 0,
        "boosts": {
          "atk": 2
        }
      }
    ]
  },
  "milkdrink": {
    "num": 208,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Milk Drink",
    "pp": 10,
    "priority": 4,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "Miltank drinks its own milk, healing to FULL HP.\nZ-Effect gives +2 Defense.\nThis also has +4 PRIORITY. Yummy.",
    "shortDesc": "Miltank drinks its own milk, healing to FULL HP.\nZ-Effect gives +2 Defense.\nThis also has +4 PRIORITY. Yummy.",
    "flags": {
      "heal": 1,
      "snatch": 1
    }
  },
  "spark": {
    "num": 209,
    "accuracy": true,
    "basePower": 55,
    "category": "Physical",
    "name": "Spark",
    "pp": 10,
    "priority": 2,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "The user, charged with electricity, rapidly dashes at\nthe target. This has +2 priority, and can't miss.\nContact.",
    "shortDesc": "The user, charged with electricity, rapidly dashes at\nthe target. This has +2 priority, and can't miss.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 110
    }
  },
  "furycutter": {
    "num": 210,
    "accuracy": 90,
    "basePower": 35,
    "category": "Physical",
    "name": "Fury Cutter",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Bug",
    "target": "normal",
    "desc": "The target is slashed with scythes or claws. This\nmove doubles in power if used in sucession. Contact.",
    "shortDesc": "The target is slashed with scythes or claws. This\nmove doubles in power if used in sucession. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "steelwing": {
    "num": 211,
    "accuracy": 100,
    "basePower": 60,
    "category": "Physical",
    "name": "Steel Wing",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "normal",
    "desc": "The user hardens its wings and strikes the foe.\nThis ALWAYS boosts the user's Defense by 1 after use.\nContact.",
    "shortDesc": "The user hardens its wings and strikes the foe.\nThis ALWAYS boosts the user's Defense by 1 after use.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "def": 1
          }
        }
      }
    ]
  },
  "mesmereyes": {
    "num": 212,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Mesmer-Eyes",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user mesmerizes the target with it's eyes\nputting it to sleep for 2 turns. Z-Effect +1 Speed.\nThis move fails on Ghost-types.",
    "shortDesc": "The user mesmerizes the target with it's eyes\nputting it to sleep for 2 turns. Z-Effect +1 Speed.\nThis move fails on Ghost-types.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "attract": {
    "num": 213,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Attract",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "Doesn't exist.",
    "shortDesc": "Doesn't exist.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "sleeptalk": {
    "num": 214,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Sleep Talk",
    "pp": 10,
    "priority": 3,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "While it is asleep, the user randomly uses one of the\nmoves it knows. Z-Effect +2 crit rate.\nThis has +4 Priority.",
    "shortDesc": "While it is asleep, the user randomly uses one of the\nmoves it knows. Z-Effect +2 crit rate.\nThis has +4 Priority.",
    "flags": {}
  },
  "timeout": {
    "num": 215,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Time Out",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user calls a time out.\nThis heals the user's side of the field by 50% of\ntheir max HP. Z-Effect gives the user +2 Speed.",
    "shortDesc": "The user calls a time out.\nThis heals the user's side of the field by 50% of\ntheir max HP. Z-Effect gives the user +2 Speed.",
    "flags": {
      "bypasssub": 1,
      "snatch": 1
    }
  },
  "return": {
    "num": 216,
    "accuracy": 100,
    "basePower": 1,
    "category": "Physical",
    "name": "Return",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "This full-power attack grows more powerful the\nmore the user likes its Trainer, for a max of 102\nbase power. Contact.",
    "shortDesc": "This full-power attack grows more powerful the\nmore the user likes its Trainer, for a max of 102\nbase power. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    }
  },
  "present": {
    "num": 217,
    "accuracy": true,
    "basePower": 1,
    "category": "Physical",
    "name": "Present",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "Delibird gives the foe a gift that can deal damage, or\nheal them. With NORMALIUM-Z, this becomes 250 BP, and\ngives you +2 to ALL stats BEFORE using TWINKLE TACKLE.",
    "shortDesc": "Delibird gives the foe a gift that can deal damage, or\nheal them. With NORMALIUM-Z, this becomes 250 BP, and\ngives you +2 to ALL stats BEFORE using TWINKLE TACKLE.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "multihit": [
      2,
      5
    ],
    "zMove": {
      "basePower": 250
    }
  },
  "frustration": {
    "num": 218,
    "accuracy": 100,
    "basePower": 1,
    "category": "Physical",
    "name": "Frustration",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "Doesn't exist.",
    "shortDesc": "Doesn't exist.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "atk": 1
          }
        }
      }
    ]
  },
  "safeguard": {
    "num": 219,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Safeguard",
    "pp": 25,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user creates a protective field that prevents\nstatus conditions for five turns.\nZ-Effect heals user fully.",
    "shortDesc": "The user creates a protective field that prevents\nstatus conditions for five turns.\nZ-Effect heals user fully.",
    "flags": {
      "snatch": 1
    }
  },
  "painsplit": {
    "num": 220,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Pain Split",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "The user adds its HP to the target’s HP, then equally\nshares the combined HP with the target.\nZ-Effect +2 Sp. Def.",
    "shortDesc": "The user adds its HP to the target’s HP, then equally\nshares the combined HP with the target.\nZ-Effect +2 Sp. Def.",
    "flags": {
      "mirror": 1,
      "protect": 1
    }
  },
  "infernalparade": {
    "num": 221,
    "accuracy": 80,
    "basePower": 130,
    "category": "Special",
    "name": "Infernal Parade",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "The user attacks the foe with an infernal flame\nfueled by spiritual energy. This attack leaves the\ntarget with a burn 100% of the time.",
    "shortDesc": "The user attacks the foe with an infernal flame\nfueled by spiritual energy. This attack leaves the\ntarget with a burn 100% of the time.",
    "flags": {
      "bypasssub": 1,
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 205
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "brn"
      }
    ]
  },
  "magnitude": {
    "num": 222,
    "accuracy": 100,
    "basePower": 1,
    "category": "Physical",
    "name": "Magnitude",
    "pp": 30,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "allAdjacent",
    "desc": "The user lets off an earthquake of varying magnitude.\nThe average power is 70, with a maximum of 150 and a\nminimum of 10.",
    "shortDesc": "The user lets off an earthquake of varying magnitude.\nThe average power is 70, with a maximum of 150 and a\nminimum of 10.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 150
    }
  },
  "knockoutpunch": {
    "num": 223,
    "accuracy": 80,
    "basePower": 130,
    "category": "Physical",
    "name": "Knockout Punch",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user punches the foe with great force.\nThe resulting fatigue causes the target to fall asleep\non the next turn. Contact. Affected by Rapid Fire.",
    "shortDesc": "The user punches the foe with great force.\nThe resulting fatigue causes the target to fall asleep\non the next turn. Contact. Affected by Rapid Fire.",
    "flags": {
      "contact": 1,
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 200
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "14"
      }
    ]
  },
  "megahorn": {
    "num": 224,
    "accuracy": 100,
    "basePower": 120,
    "category": "Physical",
    "name": "Megahorn",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Bug",
    "target": "normal",
    "desc": "Using its tough and impressive horn, the user rams\ninto the target with no letup. This lowers the user's\ndefensive stats by 1 after use. Contact.",
    "shortDesc": "Using its tough and impressive horn, the user rams\ninto the target with no letup. This lowers the user's\ndefensive stats by 1 after use. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "def": -1,
        "spd": -1
      }
    },
    "zMove": {
      "basePower": 190
    }
  },
  "dragonbreath": {
    "num": 225,
    "accuracy": 100,
    "basePower": 75,
    "category": "Special",
    "name": "Dragon Breath",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Dragon",
    "target": "normal",
    "desc": "The user exhales a destructive breath of dragon\nenergy. This burns the target 30% of the time.",
    "shortDesc": "The user exhales a destructive breath of dragon\nenergy. This burns the target 30% of the time.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 150
    },
    "secondaries": [
      {
        "chance": 30,
        "status": "brn"
      }
    ]
  },
  "batonpass": {
    "num": 226,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Baton Pass",
    "pp": 5,
    "priority": -6,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user switches places with a party Pokemon in\nwaiting and passes along any stat changes.\nZ-Effect heals the ally fully. This ALWAYS goes last.",
    "shortDesc": "The user switches places with a party Pokemon in\nwaiting and passes along any stat changes.\nZ-Effect heals the ally fully. This ALWAYS goes last.",
    "flags": {}
  },
  "encore": {
    "num": 227,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Encore",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user compels the target to keep using the move\nit encored for three turns. Z-Effect +2 Speed.",
    "shortDesc": "The user compels the target to keep using the move\nit encored for three turns. Z-Effect +2 Speed.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "pursuit": {
    "num": 228,
    "accuracy": true,
    "basePower": 50,
    "category": "Physical",
    "name": "Pursuit",
    "pp": 15,
    "priority": 0,
    "critRatio": 7,
    "type": "Dark",
    "target": "normal",
    "desc": "The user strikes the target violently. The power of\nthe move doubles if target attempts to switch out.\nALWAYS results in a critical hit, can't miss, contact.",
    "shortDesc": "The user strikes the target violently. The power of\nthe move doubles if target attempts to switch out.\nALWAYS results in a critical hit, can't miss, contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 150
    }
  },
  "rapidspin": {
    "num": 229,
    "accuracy": 100,
    "basePower": 50,
    "category": "Physical",
    "name": "Rapid Spin",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "A spin attack that can also eliminate the effects of\ntrapping moves, entry hazards and more. This ALWAYS\nsharply raises the user's Speed by 2. Contact.",
    "shortDesc": "A spin attack that can also eliminate the effects of\ntrapping moves, entry hazards and more. This ALWAYS\nsharply raises the user's Speed by 2. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "spe": 2
          }
        }
      }
    ]
  },
  "sweetscent": {
    "num": 230,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Sweet Scent",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "allAdjacentFoes",
    "desc": "A sweet scent that lowers the opponents Sp. Def and\nSp. Atk by 1. Z-Effect raises user's Accuracy by 3.",
    "shortDesc": "A sweet scent that lowers the opponents Sp. Def and\nSp. Atk by 1. Z-Effect raises user's Accuracy by 3.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "spa": -1
        }
      },
      {
        "chance": 0,
        "boosts": {
          "spd": -1
        }
      }
    ]
  },
  "irontail": {
    "num": 231,
    "accuracy": 90,
    "basePower": 110,
    "category": "Physical",
    "name": "Iron Tail",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "normal",
    "desc": "The target is slammed with a steel-hard tail.\nThis drops the foe's Defense 50% of the time. Contact.",
    "shortDesc": "The target is slammed with a steel-hard tail.\nThis drops the foe's Defense 50% of the time. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 185
    },
    "secondaries": [
      {
        "chance": 50,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "laceration": {
    "num": 232,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Laceration",
    "pp": 10,
    "priority": 0,
    "critRatio": 3,
    "type": "Steel",
    "target": "normal",
    "desc": "The foe is slashed with steel-hard claws, blades, or\nthe like. This has a 50% (+2) crit rate. Contact.",
    "shortDesc": "The foe is slashed with steel-hard claws, blades, or\nthe like. This has a 50% (+2) crit rate. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    }
  },
  "skirmish": {
    "num": 233,
    "accuracy": 100,
    "basePower": 70,
    "category": "Physical",
    "name": "Skirmish",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user picks a fight, roughhousing the foe.\nThis ALWAYS drops the foe's attacking stats by 1.\nContact.",
    "shortDesc": "The user picks a fight, roughhousing the foe.\nThis ALWAYS drops the foe's attacking stats by 1.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 140
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      }
    ]
  },
  "morningsun": {
    "num": 234,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Morning Sun",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "self",
    "desc": "The user heals itself by 50% of it's max HP. This\nrestores 2/3 of it's max HP in the Sun, and 1/3 in\nother weather. Z-Effect +2 Sp. Def.",
    "shortDesc": "The user heals itself by 50% of it's max HP. This\nrestores 2/3 of it's max HP in the Sun, and 1/3 in\nother weather. Z-Effect +2 Sp. Def.",
    "flags": {
      "defrost": 1,
      "snatch": 1
    }
  },
  "synthesis": {
    "num": 235,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Synthesis",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "self",
    "desc": "The user heals itself by 50% of it's max HP. This\nrestores 2/3 of it's max HP in the Sun, and 1/3 in\nother weather. Z-Effect +2 Sp. Def.",
    "shortDesc": "The user heals itself by 50% of it's max HP. This\nrestores 2/3 of it's max HP in the Sun, and 1/3 in\nother weather. Z-Effect +2 Sp. Def.",
    "flags": {
      "snatch": 1
    }
  },
  "moonlight": {
    "num": 236,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Moonlight",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "self",
    "desc": "The user heals itself by 50% of it's max HP. This\nrestores 2/3 of it's max HP in the Sun, and 1/3 in\nother weather. Z-Effect +2 Sp. Def.",
    "shortDesc": "The user heals itself by 50% of it's max HP. This\nrestores 2/3 of it's max HP in the Sun, and 1/3 in\nother weather. Z-Effect +2 Sp. Def.",
    "flags": {
      "snatch": 1
    }
  },
  "hiddenpower": {
    "num": 237,
    "accuracy": 100,
    "basePower": 60,
    "category": "Special",
    "name": "Hidden Power",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "A unique attack that varies in type depending on the\nIVs of the user.",
    "shortDesc": "A unique attack that varies in type depending on the\nIVs of the user.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    }
  },
  "crosschop": {
    "num": 238,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Cross Chop",
    "pp": 10,
    "priority": 0,
    "critRatio": 3,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user delivers a vicous chop with hands, blades,\nor the like. This has a 50% (+2) crit rate. Contact.",
    "shortDesc": "The user delivers a vicous chop with hands, blades,\nor the like. This has a 50% (+2) crit rate. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 140
    }
  },
  "twister": {
    "num": 239,
    "accuracy": true,
    "basePower": 50,
    "category": "Special",
    "name": "Twister",
    "pp": 15,
    "priority": 1,
    "critRatio": 1,
    "type": "Dragon",
    "target": "allAdjacentFoes",
    "desc": "The user quickly whips up a tornado fueled by\ndragon energy. This has +1 Priority, and can't miss.",
    "shortDesc": "The user quickly whips up a tornado fueled by\ndragon energy. This has +1 Priority, and can't miss.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "raindance": {
    "num": 240,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Rain Dance",
    "pp": 5,
    "priority": 4,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "The user summons rain that lasts for 5 turns.\nZ-Effect +2 Sp. Def.\nTHIS HAS +4 PRIORITY.",
    "shortDesc": "The user summons rain that lasts for 5 turns.\nZ-Effect +2 Sp. Def.\nTHIS HAS +4 PRIORITY.",
    "flags": {}
  },
  "sunnyday": {
    "num": 241,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Sunny Day",
    "pp": 5,
    "priority": 4,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The user summons sunlight that lasts for 5 turns.\nZ-Effect +2 Sp. Def.\nTHIS HAS +4 PRIORITY.",
    "shortDesc": "The user summons sunlight that lasts for 5 turns.\nZ-Effect +2 Sp. Def.\nTHIS HAS +4 PRIORITY.",
    "flags": {
      "defrost": 1
    }
  },
  "crunch": {
    "num": 242,
    "accuracy": 100,
    "basePower": 85,
    "category": "Physical",
    "name": "Crunch",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user crunches up the target with sharp fangs.\nThis lowers Defense 30% of the time. Contact.",
    "shortDesc": "The user crunches up the target with sharp fangs.\nThis lowers Defense 30% of the time. Contact.",
    "flags": {
      "bite": 1,
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 170
    },
    "secondaries": [
      {
        "chance": 30,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "mirrorcoat": {
    "num": 243,
    "accuracy": 100,
    "basePower": 1,
    "category": "Special",
    "name": "Mirror Coat",
    "pp": 20,
    "priority": -6,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "A retaliation move that counters any special attack,\ninflicting double the damage taken.",
    "shortDesc": "A retaliation move that counters any special attack,\ninflicting double the damage taken.",
    "flags": {
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    }
  },
  "psychup": {
    "num": 244,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Psych Up",
    "pp": 10,
    "priority": 4,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user hypnotizes itself into copying any stat\nchange made by the target. This has +4 Priority.\nZ-Effect heals user fully.",
    "shortDesc": "The user hypnotizes itself into copying any stat\nchange made by the target. This has +4 Priority.\nZ-Effect heals user fully.",
    "flags": {
      "bypasssub": 1
    }
  },
  "extremespeed": {
    "num": 245,
    "accuracy": true,
    "basePower": 80,
    "category": "Physical",
    "name": "Extreme Speed",
    "pp": 5,
    "priority": 3,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user charges the target at blinding speed.\nThis has +3 priority, and can't miss. Contact.",
    "shortDesc": "The user charges the target at blinding speed.\nThis has +3 priority, and can't miss. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    }
  },
  "ancientpower": {
    "num": 246,
    "accuracy": 100,
    "basePower": 60,
    "category": "Special",
    "name": "Ancient Power",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Rock",
    "target": "normal",
    "desc": "The user attacks with rocks imbued with a strange\nprimal energy. This ALWAYS lowers BOTH offensive\nstats of the opponent by 1.",
    "shortDesc": "The user attacks with rocks imbued with a strange\nprimal energy. This ALWAYS lowers BOTH offensive\nstats of the opponent by 1.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      }
    ]
  },
  "shadowball": {
    "num": 247,
    "accuracy": 100,
    "basePower": 90,
    "category": "Special",
    "name": "Shadow Ball",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "The user hurls a shadowy blob at the target.\nThis lowers the target's Sp. Def 20% of the time.",
    "shortDesc": "The user hurls a shadowy blob at the target.\nThis lowers the target's Sp. Def 20% of the time.",
    "flags": {
      "bullet": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 20,
        "boosts": {
          "spd": -1
        }
      }
    ]
  },
  "futuresight": {
    "num": 248,
    "accuracy": 100,
    "basePower": 160,
    "category": "Special",
    "name": "Future Sight",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user foresees a very powerful attack that will\nstrike the target 2 turns after this move is used.\nThis bypasses Protect, Substitute, and cannot miss.",
    "shortDesc": "The user foresees a very powerful attack that will\nstrike the target 2 turns after this move is used.\nThis bypasses Protect, Substitute, and cannot miss.",
    "flags": {
      "bypasssub": 1
    },
    "zMove": {
      "basePower": 220
    }
  },
  "boulderbash": {
    "num": 249,
    "accuracy": 100,
    "basePower": 90,
    "category": "Physical",
    "name": "Boulder Bash",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Rock",
    "target": "normal",
    "desc": "The user smashes the foe with a rock-shattering punch.\nThis ALWAYS drops the foe's Defense by 1. Contact.",
    "shortDesc": "The user smashes the foe with a rock-shattering punch.\nThis ALWAYS drops the foe's Defense by 1. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "whirlpool": {
    "num": 250,
    "accuracy": 85,
    "basePower": 130,
    "category": "Special",
    "name": "Whirlpool",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "The user traps the target in a violent swirling whirlpool\nthat traps foe for 6 turns, preventing switching\nand dealing 12% of the foe's max HP per turn.",
    "shortDesc": "The user traps the target in a violent swirling whirlpool\nthat traps foe for 6 turns, preventing switching\nand dealing 12% of the foe's max HP per turn.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 200
    }
  },
  "beatup": {
    "num": 251,
    "accuracy": true,
    "basePower": 1,
    "category": "Physical",
    "name": "Beat Up",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user gets all party Pokemon to attack the target.\nEach hit uses the user's Attack stat for damage. The\nmath for each hit's power is: base Attack/10, add 5.",
    "shortDesc": "The user gets all party Pokemon to attack the target.\nEach hit uses the user's Attack stat for damage. The\nmath for each hit's power is: base Attack/10, add 5.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": 6,
    "zMove": {
      "basePower": 175
    }
  },
  "fakeout": {
    "num": 252,
    "accuracy": true,
    "basePower": 45,
    "category": "Physical",
    "name": "Fake Out",
    "pp": 5,
    "priority": 5,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "A quick and unexpected strike fakes out the target.\nThis has +5 Priority & always flinches- but only works\nthe 1st turn in battle. Contact. BYPASSES PROTECT.",
    "shortDesc": "A quick and unexpected strike fakes out the target.\nThis has +5 Priority & always flinches- but only works\nthe 1st turn in battle. Contact. BYPASSES PROTECT.",
    "flags": {
      "contact": 1,
      "mirror": 1
    },
    "zMove": {
      "basePower": 90
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "flinch"
      }
    ]
  },
  "uproar": {
    "num": 253,
    "accuracy": 100,
    "basePower": 120,
    "category": "Special",
    "name": "Uproar",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "allAdjacentFoes",
    "desc": "The user attacks in an uproar for three turns.\nDuring that time, no Pokemon can fall asleep.",
    "shortDesc": "The user attacks in an uproar for three turns.\nDuring that time, no Pokemon can fall asleep.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "punch": 1
    },
    "zMove": {
      "basePower": 190
    }
  },
  "stockpile": {
    "num": 254,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Stockpile",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user charges up power and raises both its\nDefense and Sp. Def stats by 1. The move can be\nused three times. Z-Effect heals user fully.",
    "shortDesc": "The user charges up power and raises both its\nDefense and Sp. Def stats by 1. The move can be\nused three times. Z-Effect heals user fully.",
    "flags": {
      "dance": 1,
      "snatch": 1
    }
  },
  "spewout": {
    "num": 255,
    "accuracy": 100,
    "basePower": 1,
    "category": "Special",
    "name": "Spew Out",
    "pp": 15,
    "priority": 0,
    "critRatio": 7,
    "type": "Poison",
    "target": "normal",
    "desc": "The user upchucks its caustic stomach contents.\nFor every Stockpile use, this gains 100 BP, maxing at\n300 BP. ALWAYS crits & drops Sp. Def by 4.",
    "shortDesc": "The user upchucks its caustic stomach contents.\nFor every Stockpile use, this gains 100 BP, maxing at\n300 BP. ALWAYS crits & drops Sp. Def by 4.",
    "flags": {
      "protect": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 230
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spd": -4
        }
      }
    ]
  },
  "swallow": {
    "num": 256,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Swallow",
    "pp": 10,
    "priority": 4,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user heals 1/3 for 1 stockpile, 1/2 for 2, and full\nHP for 3 stockpiles. This now has +4 priority.\nZ-Move gives +1 all stats. (Doesn't work with Simple.)",
    "shortDesc": "The user heals 1/3 for 1 stockpile, 1/2 for 2, and full\nHP for 3 stockpiles. This now has +4 priority.\nZ-Move gives +1 all stats. (Doesn't work with Simple.)",
    "flags": {
      "snatch": 1
    }
  },
  "heatwave": {
    "num": 257,
    "accuracy": 100,
    "basePower": 65,
    "category": "Special",
    "name": "Heat Wave",
    "pp": 5,
    "priority": 0,
    "critRatio": 7,
    "type": "Fire",
    "target": "allAdjacentFoes",
    "desc": "The user blows a burning, abrasive wind at the foes.\nThis will ALWAYS result in a critical hit.",
    "shortDesc": "The user blows a burning, abrasive wind at the foes.\nThis will ALWAYS result in a critical hit.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 175
    }
  },
  "hail": {
    "num": 258,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Hail",
    "pp": 5,
    "priority": 4,
    "critRatio": 1,
    "type": "Ice",
    "target": "normal",
    "desc": "The user summons a hailstorm lasting five turns.\nZ-Effect +2 Defense.\nTHIS HAS +4 PRIORITY.",
    "shortDesc": "The user summons a hailstorm lasting five turns.\nZ-Effect +2 Defense.\nTHIS HAS +4 PRIORITY.",
    "flags": {}
  },
  "torment": {
    "num": 259,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Torment",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user torments and enrages the target, making it\nincapable of using the same move twice in a row.\nZ-Effect +2 Attack.",
    "shortDesc": "The user torments and enrages the target, making it\nincapable of using the same move twice in a row.\nZ-Effect +2 Attack.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "flatter": {
    "num": 260,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Flatter",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "Flattery is used to confuse the target for 4 turns.\nThis also raises the target’s Sp. Atk by 1.\nZ-Effect gives +3 Sp. Atk.",
    "shortDesc": "Flattery is used to confuse the target for 4 turns.\nThis also raises the target’s Sp. Atk by 1.\nZ-Effect gives +3 Sp. Atk.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spa": 1
        }
      }
    ]
  },
  "willowisp": {
    "num": 261,
    "accuracy": 90,
    "basePower": 0,
    "category": "Status",
    "name": "Will-O-Wisp",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The user shoots a sinister, bluish-white flame at the\ntarget to inflict a burn. Z-Effect +3 Accuracy.",
    "shortDesc": "The user shoots a sinister, bluish-white flame at the\ntarget to inflict a burn. Z-Effect +3 Accuracy.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "memento": {
    "num": 262,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Memento",
    "pp": 10,
    "priority": 4,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user faints when using this move. In return, this\nlowers the target's Sp. Atk and Attack by 2.\n+4 Priority. Z-Effect heals user's replacement fully.",
    "shortDesc": "The user faints when using this move. In return, this\nlowers the target's Sp. Atk and Attack by 2.\n+4 Priority. Z-Effect heals user's replacement fully.",
    "flags": {
      "mirror": 1,
      "protect": 1
    }
  },
  "facade": {
    "num": 263,
    "accuracy": 100,
    "basePower": 75,
    "category": "Physical",
    "name": "Facade",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "This attack's power is doubled if the user is\nburnt, poisoned or paralyzed. Contact.",
    "shortDesc": "This attack's power is doubled if the user is\nburnt, poisoned or paralyzed. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 150
    }
  },
  "focuspunch": {
    "num": 264,
    "accuracy": true,
    "basePower": 120,
    "category": "Physical",
    "name": "Focus Punch",
    "pp": 10,
    "priority": -5,
    "critRatio": 7,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user focuses its mind and fires a massive punch\nat the end of the turn if they weren't hit that turn.\nThis ALWAYS crits, and gives +1 Accuracy. Contact.",
    "shortDesc": "The user focuses its mind and fires a massive punch\nat the end of the turn if they weren't hit that turn.\nThis ALWAYS crits, and gives +1 Accuracy. Contact.",
    "flags": {
      "contact": 1,
      "protect": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 230
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "accuracy": 1
          }
        }
      }
    ]
  },
  "smellingsalts": {
    "num": 265,
    "accuracy": true,
    "basePower": 75,
    "category": "Physical",
    "name": "Smelling Salts",
    "pp": 1,
    "priority": 4,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user smacks the foe, resuscitating them. This has\n+4 Priority, and ALWAYS flinches the foe from shock.\nDoubles in power if the foe is paralyzed. Contact.",
    "shortDesc": "The user smacks the foe, resuscitating them. This has\n+4 Priority, and ALWAYS flinches the foe from shock.\nDoubles in power if the foe is paralyzed. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 150
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "flinch"
      }
    ]
  },
  "followme": {
    "num": 266,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Follow Me",
    "pp": 5,
    "priority": 6,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user draws attention to itself, making all targets\ntake aim only at the user. Z-Effect heals user fully.",
    "shortDesc": "The user draws attention to itself, making all targets\ntake aim only at the user. Z-Effect heals user fully.",
    "flags": {}
  },
  "naturepower": {
    "num": 267,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Nature Power",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user summons energy from the environment.\nThis changes into a move based on the terrain, like\nPsychic, Moonblast, Thunderbolt & Energy Ball.",
    "shortDesc": "The user summons energy from the environment.\nThis changes into a move based on the terrain, like\nPsychic, Moonblast, Thunderbolt & Energy Ball.",
    "flags": {}
  },
  "recharge": {
    "num": 268,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Recharge",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "self",
    "desc": "The user heals itself by 35% of it's max HP, and\nDOUBLES the power of it's next used Electric attack.\nZ-Effect +2 Sp. Def.",
    "shortDesc": "The user heals itself by 35% of it's max HP, and\nDOUBLES the power of it's next used Electric attack.\nZ-Effect +2 Sp. Def.",
    "flags": {
      "snatch": 1
    }
  },
  "taunt": {
    "num": 269,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Taunt",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The target is taunted into a rage that allows it to use\nonly attack moves for three turns. Z-Effect +2 Attack.",
    "shortDesc": "The target is taunted into a rage that allows it to use\nonly attack moves for three turns. Z-Effect +2 Attack.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "11"
      }
    ]
  },
  "helpinghand": {
    "num": 270,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Helping Hand",
    "pp": 20,
    "priority": 6,
    "critRatio": 1,
    "type": "Normal",
    "target": "adjacentAlly",
    "desc": "The user assists an ally by boosting the power of\nthat ally’s attack by 1.5x.\nThis has +6 Priority. Z-Effect heals the user fully.",
    "shortDesc": "The user assists an ally by boosting the power of\nthat ally’s attack by 1.5x.\nThis has +6 Priority. Z-Effect heals the user fully.",
    "flags": {
      "bypasssub": 1
    }
  },
  "trick": {
    "num": 271,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Trick",
    "pp": 1,
    "priority": 4,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user catches the target off guard and swaps its\nheld item with its own. Z-Effect +3 Speed.\n+4 Priority.",
    "shortDesc": "The user catches the target off guard and swaps its\nheld item with its own. Z-Effect +3 Speed.\n+4 Priority.",
    "flags": {
      "mirror": 1,
      "protect": 1
    }
  },
  "roleplay": {
    "num": 272,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Role Play",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user mimics the target completely, copying the\ntarget’s natural Ability. Z-Effect +3 Speed.",
    "shortDesc": "The user mimics the target completely, copying the\ntarget’s natural Ability. Z-Effect +3 Speed.",
    "flags": {
      "bypasssub": 1
    }
  },
  "wish": {
    "num": 273,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Wish",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "self",
    "desc": "One turn after this move is used, the user’s or its\nreplacement’s HP is restored by half the user’s\nmax HP. Z-Effect +2 Sp. Def.",
    "shortDesc": "One turn after this move is used, the user’s or its\nreplacement’s HP is restored by half the user’s\nmax HP. Z-Effect +2 Sp. Def.",
    "flags": {
      "snatch": 1,
      "sound": 1
    }
  },
  "assist": {
    "num": 274,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Assist",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user hurriedly and randomly uses a move among\nthose known by ally Pokemon.\nZ-Effect +1 all stats before attacking with a Z-Move.",
    "shortDesc": "The user hurriedly and randomly uses a move among\nthose known by ally Pokemon.\nZ-Effect +1 all stats before attacking with a Z-Move.",
    "flags": {}
  },
  "ingrain": {
    "num": 275,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Ingrain",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "self",
    "desc": "The user digs roots in the ground, locking itself on\nthe field, but heals 1/16 per turn. Gives -3 Speed\nfor +3 SP. ATK/SPDEF. Z-Effect gives +3 DEFENSE.",
    "shortDesc": "The user digs roots in the ground, locking itself on\nthe field, but heals 1/16 per turn. Gives -3 Speed\nfor +3 SP. ATK/SPDEF. Z-Effect gives +3 DEFENSE.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "21"
      },
      {
        "chance": 0,
        "boosts": {
          "spd": 3
        }
      },
      {
        "chance": 0,
        "boosts": {
          "spa": 3
        }
      },
      {
        "chance": 0,
        "boosts": {
          "spe": -3
        }
      }
    ]
  },
  "superpower": {
    "num": 276,
    "accuracy": 100,
    "basePower": 150,
    "category": "Physical",
    "name": "Superpower",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user attacks with overwhelming physical force.\nIn exchange, the user's Attack drops by 2 after use.\nContact.",
    "shortDesc": "The user attacks with overwhelming physical force.\nIn exchange, the user's Attack drops by 2 after use.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "atk": -2
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "magiccoat": {
    "num": 277,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Magic Coat",
    "pp": 15,
    "priority": 4,
    "critRatio": 1,
    "type": "Psychic",
    "target": "self",
    "desc": "A barrier reflects back to the target moves like\nLeech Seed and moves that damage status.\n+6 Priority. Z-Effect +3 Sp. Def.",
    "shortDesc": "A barrier reflects back to the target moves like\nLeech Seed and moves that damage status.\n+6 Priority. Z-Effect +3 Sp. Def.",
    "flags": {}
  },
  "recycle": {
    "num": 278,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Recycle",
    "pp": 10,
    "priority": 6,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user recycles a held item that has been used in\nbattle so it can be used again.\n+6 Priority. Z-Effect heals user fully.",
    "shortDesc": "The user recycles a held item that has been used in\nbattle so it can be used again.\n+6 Priority. Z-Effect heals user fully.",
    "flags": {
      "snatch": 1
    }
  },
  "ragingfury": {
    "num": 279,
    "accuracy": true,
    "basePower": 50,
    "category": "Physical",
    "name": "Raging Fury",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The user unleashes its burning rage onto the foe.\nRaises the user's Attack by 1 after use, & can't miss.\nIf the user was attacked this turn, the power DOUBLES.",
    "shortDesc": "The user unleashes its burning rage onto the foe.\nRaises the user's Attack by 1 after use, & can't miss.\nIf the user was attacked this turn, the power DOUBLES.",
    "flags": {
      "contact": 1,
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "atk": 1
          }
        }
      }
    ]
  },
  "brickbreak": {
    "num": 280,
    "accuracy": 100,
    "basePower": 85,
    "category": "Physical",
    "name": "Brick Break",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user attacks with a hard chop. It can also break\nbarriers, such as Light Screen and Reflect. Contact.",
    "shortDesc": "The user attacks with a hard chop. It can also break\nbarriers, such as Light Screen and Reflect. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 170
    }
  },
  "yawn": {
    "num": 281,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Yawn",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user lets loose a huge yawn that lulls the target\ninto falling asleep on the next turn.\nZ-Effect heals user fully.",
    "shortDesc": "The user lets loose a huge yawn that lulls the target\ninto falling asleep on the next turn.\nZ-Effect heals user fully.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "knockoff": {
    "num": 282,
    "accuracy": 100,
    "basePower": 60,
    "category": "Physical",
    "name": "Knock Off",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user hits the target’s held item off, and that\nitem can’t be used until the end of the battle. This\nmove's damage is 1.5x if it removes an item. Contact.",
    "shortDesc": "The user hits the target’s held item off, and that\nitem can’t be used until the end of the battle. This\nmove's damage is 1.5x if it removes an item. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    }
  },
  "endeavor": {
    "num": 283,
    "accuracy": true,
    "basePower": 1,
    "category": "Physical",
    "name": "Endeavor",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "This attack move cuts down the target’s HP to equal\nthe user’s current HP. Can't miss. Contact.",
    "shortDesc": "This attack move cuts down the target’s HP to equal\nthe user’s current HP. Can't miss. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    }
  },
  "eruption": {
    "num": 284,
    "accuracy": 100,
    "basePower": 150,
    "category": "Special",
    "name": "Eruption",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "allAdjacentFoes",
    "desc": "The user attacks opposing Pokemon with explosive\nfury. The lower the user’s HP, the lower the\nmove’s power.",
    "shortDesc": "The user attacks opposing Pokemon with explosive\nfury. The lower the user’s HP, the lower the\nmove’s power.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 210
    }
  },
  "skillswap": {
    "num": 285,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Skill Swap",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user employs its psychic power to exchange\nAbilities with the target. Z-Effect +3 Speed.",
    "shortDesc": "The user employs its psychic power to exchange\nAbilities with the target. Z-Effect +3 Speed.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1
    }
  },
  "imprison": {
    "num": 286,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Imprison",
    "pp": 10,
    "priority": 6,
    "critRatio": 1,
    "type": "Psychic",
    "target": "self",
    "desc": "The user prevents the foe from using any moves\nthat the user also currently knows.\nZ-Effect gives +1 to all stats. +6 Priority.",
    "shortDesc": "The user prevents the foe from using any moves\nthat the user also currently knows.\nZ-Effect gives +1 to all stats. +6 Priority.",
    "flags": {
      "bypasssub": 1,
      "snatch": 1
    }
  },
  "molt": {
    "num": 287,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Molt",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Bug",
    "target": "self",
    "desc": "The user sheds its skin or exoskeleton.\nThis heals the user by 50% of their max HP.\nZ-Effect gives the user +2 Speed.",
    "shortDesc": "The user sheds its skin or exoskeleton.\nThis heals the user by 50% of their max HP.\nZ-Effect gives the user +2 Speed.",
    "flags": {
      "snatch": 1
    }
  },
  "grudge": {
    "num": 288,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Grudge",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "Banette vindictively braces itself. If Banette faints,\nthe move that knocked it out will lost all PP.\n+4 Priority. Z-Effect gives Banette +1 all stats.",
    "shortDesc": "Banette vindictively braces itself. If Banette faints,\nthe move that knocked it out will lost all PP.\n+4 Priority. Z-Effect gives Banette +1 all stats.",
    "flags": {
      "bypasssub": 1
    }
  },
  "snatch": {
    "num": 289,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Snatch",
    "pp": 10,
    "priority": 6,
    "critRatio": 1,
    "type": "Dark",
    "target": "self",
    "desc": "The user steals the effects of any attempts to use a\nhealing, stat-changing or other similar moves.\n+6 Priority. Z-Effect gives +3 Speed.",
    "shortDesc": "The user steals the effects of any attempts to use a\nhealing, stat-changing or other similar moves.\n+6 Priority. Z-Effect gives +3 Speed.",
    "flags": {
      "bypasssub": 1
    }
  },
  "secretpower": {
    "num": 290,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Secret Power",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "This odd move has a 50% chance to do various things.\nThe effect changes based on your surroundings,\nincluding Psychic, Electric, Misty and Grassy Terrain.",
    "shortDesc": "This odd move has a 50% chance to do various things.\nThe effect changes based on your surroundings,\nincluding Psychic, Electric, Misty and Grassy Terrain.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    }
  },
  "dive": {
    "num": 291,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Dive",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "The user dives underwater, striking on the 2nd turn.\nThis boosts the user's Accuracy by 1 after use. Contact.\nBypasses protect.",
    "shortDesc": "The user dives underwater, striking on the 2nd turn.\nThis boosts the user's Accuracy by 1 after use. Contact.\nBypasses protect.",
    "flags": {
      "charge": 1,
      "contact": 1,
      "mirror": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "accuracy": 1
          }
        }
      }
    ]
  },
  "forcepalm": {
    "num": 292,
    "accuracy": 100,
    "basePower": 40,
    "category": "Physical",
    "name": "Force Palm",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user hits the foe hard with open palms, stunning\nthem with a small shockwave. This ALWAYS leaves the foe\nwith paralysis. Contact.",
    "shortDesc": "The user hits the foe hard with open palms, stunning\nthem with a small shockwave. This ALWAYS leaves the foe\nwith paralysis. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 80
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "par"
      }
    ]
  },
  "camouflage": {
    "num": 293,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Camouflage",
    "pp": 20,
    "priority": 4,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user’s type is changed depending on its\nenvironment, including terrains like Grassy or Misty.\nZ-Effect +1 all stats. +4 Priority.",
    "shortDesc": "The user’s type is changed depending on its\nenvironment, including terrains like Grassy or Misty.\nZ-Effect +1 all stats. +4 Priority.",
    "flags": {
      "snatch": 1
    }
  },
  "powerglow": {
    "num": 294,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Power Glow",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user flashes an organic light from its body.\nThis boosts the user's Sp. Atk stat by 3 stages.\nZ-Effect gives +2 Sp. Def.",
    "shortDesc": "The user flashes an organic light from its body.\nThis boosts the user's Sp. Atk stat by 3 stages.\nZ-Effect gives +2 Sp. Def.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spa": 3
        }
      }
    ]
  },
  "chloroblast": {
    "num": 295,
    "accuracy": 100,
    "basePower": 125,
    "category": "Special",
    "name": "Chloroblast",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user launches its amassed chlorophyll in a\npowerful blast of light. This deals 25% recoil damage.",
    "shortDesc": "The user launches its amassed chlorophyll in a\npowerful blast of light. This deals 25% recoil damage.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      1,
      4
    ],
    "zMove": {
      "basePower": 195
    }
  },
  "featherball": {
    "num": 296,
    "accuracy": 100,
    "basePower": 70,
    "category": "Special",
    "name": "Feather Ball",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "The user fires a concentrated ball of feathers & wind.\nThis ALWAYS drops the foe's attacking stats by 1.",
    "shortDesc": "The user fires a concentrated ball of feathers & wind.\nThis ALWAYS drops the foe's attacking stats by 1.",
    "flags": {
      "bullet": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 140
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      }
    ]
  },
  "featherdance": {
    "num": 297,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Feather Dance",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "The user performs a dance, covering the target with\nit's feathers, dropping their Attack by 2.\nZ-Effect +2 crit rate.",
    "shortDesc": "The user performs a dance, covering the target with\nit's feathers, dropping their Attack by 2.\nZ-Effect +2 crit rate.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "atk": -2
        }
      }
    ]
  },
  "teeterdance": {
    "num": 298,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Teeter Dance",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "allAdjacent",
    "desc": "The user performs a wobbly dance that confuses\nthe Pokemon around it for 4 turns.\nZ-Effect +2 Sp. Atk.",
    "shortDesc": "The user performs a wobbly dance that confuses\nthe Pokemon around it for 4 turns.\nZ-Effect +2 Sp. Atk.",
    "flags": {
      "mirror": 1,
      "protect": 1
    }
  },
  "blazekick": {
    "num": 299,
    "accuracy": 100,
    "basePower": 95,
    "category": "Physical",
    "name": "Blaze Kick",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The user launches a blazing kick at the target. This\nhas a 20% chance to burn the target. Contact.",
    "shortDesc": "The user launches a blazing kick at the target. This\nhas a 20% chance to burn the target. Contact.",
    "flags": {
      "contact": 1,
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 20,
        "status": "brn"
      },
      {
        "chance": 20,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "mudsport": {
    "num": 300,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Mud Sport",
    "pp": 15,
    "priority": 4,
    "critRatio": 1,
    "type": "Ground",
    "target": "normal",
    "desc": "The user kicks up mud on the battlefield. This\nweakens Electric-type moves for five turns.\nZ-Effect +3 Sp. Def. +4 Priority.",
    "shortDesc": "The user kicks up mud on the battlefield. This\nweakens Electric-type moves for five turns.\nZ-Effect +3 Sp. Def. +4 Priority.",
    "flags": {}
  },
  "iceball": {
    "num": 301,
    "accuracy": 90,
    "basePower": 30,
    "category": "Physical",
    "name": "Ice Ball",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ice",
    "target": "normal",
    "desc": "The user attacks the target for five turns.\nThe move’s power increases each time it hits. Contact.",
    "shortDesc": "The user attacks the target for five turns.\nThe move’s power increases each time it hits. Contact.",
    "flags": {
      "bullet": 1,
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "needlebash": {
    "num": 302,
    "accuracy": 100,
    "basePower": 95,
    "category": "Physical",
    "name": "Needle Bash",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user attacks by striking the foe with a spiked\nappendage. This flinches 30% of the time. Contact.",
    "shortDesc": "The user attacks by striking the foe with a spiked\nappendage. This flinches 30% of the time. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "slackoff": {
    "num": 303,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Slack Off",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user slacks off, restoring its own HP 50% of the\nuser's max HP. Z-Effect +2 Defense.",
    "shortDesc": "The user slacks off, restoring its own HP 50% of the\nuser's max HP. Z-Effect +2 Defense.",
    "flags": {
      "snatch": 1
    }
  },
  "hypervoice": {
    "num": 304,
    "accuracy": 100,
    "basePower": 95,
    "category": "Special",
    "name": "Hyper Voice",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "allAdjacentFoes",
    "desc": "The user lets loose a horribly echoing shout with\nthe power to inflict damage.",
    "shortDesc": "The user lets loose a horribly echoing shout with\nthe power to inflict damage.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "punch": 1
    },
    "zMove": {
      "basePower": 175
    }
  },
  "poisonfang": {
    "num": 305,
    "accuracy": 100,
    "basePower": 75,
    "category": "Physical",
    "name": "Poison Fang",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "The user bites the target with toxic fangs. This has a\n50% chance to badly poison the foe. Contact.",
    "shortDesc": "The user bites the target with toxic fangs. This has a\n50% chance to badly poison the foe. Contact.",
    "flags": {
      "bite": 1,
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 150
    },
    "secondaries": [
      {
        "chance": 50,
        "status": "psn"
      }
    ]
  },
  "jaggededge": {
    "num": 306,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Jagged Edge",
    "pp": 10,
    "priority": 0,
    "critRatio": 3,
    "type": "Rock",
    "target": "normal",
    "desc": "The target is slashed with jagged claws, blades, or\nthe like. This has a 50% (+2) crit rate. Contact.",
    "shortDesc": "The target is slashed with jagged claws, blades, or\nthe like. This has a 50% (+2) crit rate. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    }
  },
  "blastburn": {
    "num": 307,
    "accuracy": 100,
    "basePower": 150,
    "category": "Special",
    "name": "Blast Burn",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The target is razed by a fiery explosion. This drops\nthe user's Sp. Atk by 2 after use.",
    "shortDesc": "The target is razed by a fiery explosion. This drops\nthe user's Sp. Atk by 2 after use.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "spa": -2
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "hydrocannon": {
    "num": 308,
    "accuracy": 100,
    "basePower": 150,
    "category": "Special",
    "name": "Hydro Cannon",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "The target is hit with a watery blast. This drops\nthe user's Sp. Atk by 2 after use.",
    "shortDesc": "The target is hit with a watery blast. This drops\nthe user's Sp. Atk by 2 after use.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "spa": -2
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "meteormash": {
    "num": 309,
    "accuracy": 100,
    "basePower": 95,
    "category": "Physical",
    "name": "Meteor Mash",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The target is hit with a punch imbued with fairy\nenergy. This boosts the user's attack 25% of the time.\nContact.",
    "shortDesc": "The target is hit with a punch imbued with fairy\nenergy. This boosts the user's attack 25% of the time.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1,
      "sound": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 25,
        "self": {
          "boosts": {
            "atk": 1
          }
        }
      }
    ]
  },
  "spook": {
    "num": 310,
    "accuracy": true,
    "basePower": 45,
    "category": "Special",
    "name": "Spook",
    "pp": 20,
    "priority": 1,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "The user quickly jumpscares the target. This move\nhas +1 priority, and can't miss.",
    "shortDesc": "The user quickly jumpscares the target. This move\nhas +1 priority, and can't miss.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 90
    }
  },
  "weatherball": {
    "num": 311,
    "accuracy": 100,
    "basePower": 50,
    "category": "Special",
    "name": "Weather Ball",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user fires off a ball of energy that doubles in\npower and changes type depending on the weather.\nThis drops Sp. Def by one 50% of the time.",
    "shortDesc": "The user fires off a ball of energy that doubles in\npower and changes type depending on the weather.\nThis drops Sp. Def by one 50% of the time.",
    "flags": {
      "bullet": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 50,
        "boosts": {
          "spd": -1
        }
      }
    ]
  },
  "blossomdance": {
    "num": 312,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Blossom Dance",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "self",
    "desc": "The user performs a beautiful, elegant dance.\nThis boosts the user's Attack & Sp. Atk stats by 1,\nand boosts the user's Speed by 2. Z-Effect +2 Sp. Def.",
    "shortDesc": "The user performs a beautiful, elegant dance.\nThis boosts the user's Attack & Sp. Atk stats by 1,\nand boosts the user's Speed by 2. Z-Effect +2 Sp. Def.",
    "flags": {
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spa": 1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "atk": 1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spe": 2
        }
      }
    ]
  },
  "faketears": {
    "num": 313,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Fake Tears",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user feigns crying to fluster the target, lowering\nSp. Def by 2. Z-Effect +2 Sp. Atk.",
    "shortDesc": "The user feigns crying to fluster the target, lowering\nSp. Def by 2. Z-Effect +2 Sp. Atk.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "spd": -2
        }
      }
    ]
  },
  "aircutter": {
    "num": 314,
    "accuracy": 100,
    "basePower": 60,
    "category": "Special",
    "name": "Air Cutter",
    "pp": 20,
    "priority": 0,
    "critRatio": 2,
    "type": "Flying",
    "target": "allAdjacentFoes",
    "desc": "The user slashes the air, firing a blade of wind at\nthe foes. This flinches 25% of the time.\nThis also has a +1 (12%) critical hit rate.",
    "shortDesc": "The user slashes the air, firing a blade of wind at\nthe foes. This flinches 25% of the time.\nThis also has a +1 (12%) critical hit rate.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 25,
        "volatileStatus": "flinch"
      }
    ]
  },
  "overheat": {
    "num": 315,
    "accuracy": 100,
    "basePower": 125,
    "category": "Special",
    "name": "Overheat",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The user's excess body heat is fired off in a powerful\nattack. This hurts the user, dealing 25% recoil.\nThis has a 25% chance to burn the target.",
    "shortDesc": "The user's excess body heat is fired off in a powerful\nattack. This hurts the user, dealing 25% recoil.\nThis has a 25% chance to burn the target.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      1,
      4
    ],
    "zMove": {
      "basePower": 195
    },
    "secondaries": [
      {
        "chance": 25,
        "status": "brn"
      }
    ]
  },
  "odorsleuth": {
    "num": 316,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Odor Sleuth",
    "pp": 40,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user identifies the target, allowing Ghost types to\nbe hit with Normal/Fighting moves.\nZ-Effect gives user +2 Attack.",
    "shortDesc": "The user identifies the target, allowing Ghost types to\nbe hit with Normal/Fighting moves.\nZ-Effect gives user +2 Attack.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "rocktomb": {
    "num": 317,
    "accuracy": 100,
    "basePower": 60,
    "category": "Physical",
    "name": "Rock Tomb",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Rock",
    "target": "normal",
    "desc": "Rocks are hurled at the target, entrapping them. This\ndrops Speed by one 100% of the time.",
    "shortDesc": "Rocks are hurled at the target, entrapping them. This\ndrops Speed by one 100% of the time.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -1
        }
      }
    ]
  },
  "silvergale": {
    "num": 318,
    "accuracy": true,
    "basePower": 50,
    "category": "Special",
    "name": "Silver Gale",
    "pp": 15,
    "priority": 1,
    "critRatio": 1,
    "type": "Bug",
    "target": "normal",
    "desc": "The user rapidly blows powdery scales at the target.\nThis has +1 priority, and can't miss.",
    "shortDesc": "The user rapidly blows powdery scales at the target.\nThis has +1 priority, and can't miss.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "metalsound": {
    "num": 319,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Metal Sound",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "normal",
    "desc": "A horrible sound like scraping metal drops the foe's\nSp. Def by 2. Z-Effect +2 Sp. Atk.",
    "shortDesc": "A horrible sound like scraping metal drops the foe's\nSp. Def by 2. Z-Effect +2 Sp. Atk.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "spd": -2
        }
      }
    ]
  },
  "grasswhistle": {
    "num": 320,
    "accuracy": 80,
    "basePower": 0,
    "category": "Status",
    "name": "Grass Whistle",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user plays a pleasant melody that lulls the\ntarget into a deep sleep for 2 turns.\nZ-Effect +1 Speed.",
    "shortDesc": "The user plays a pleasant melody that lulls the\ntarget into a deep sleep for 2 turns.\nZ-Effect +1 Speed.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "tickle": {
    "num": 321,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Tickle",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user tickles the target into laughing, reducing its\nAttack and Defense stats by 1.\nZ-Effect +3 Accuracy.",
    "shortDesc": "The user tickles the target into laughing, reducing its\nAttack and Defense stats by 1.\nZ-Effect +3 Accuracy.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "atk": -1
        }
      },
      {
        "chance": 0,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "cosmicpower": {
    "num": 322,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Cosmic Power",
    "pp": 3,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "self",
    "desc": "The user absorbs a mystical power from space to\nraise its Defense and Sp. Def stats by 1.\nZ-Effect +3 Sp. Def.",
    "shortDesc": "The user absorbs a mystical power from space to\nraise its Defense and Sp. Def stats by 1.\nZ-Effect +3 Sp. Def.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "def": 1
        }
      },
      {
        "chance": 0,
        "boosts": {
          "spd": 1
        }
      }
    ]
  },
  "waterspout": {
    "num": 323,
    "accuracy": 100,
    "basePower": 150,
    "category": "Special",
    "name": "Water Spout",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "allAdjacentFoes",
    "desc": "The user spouts water to damage opposing\nPokemon. The lower the user’s HP, the lower the\nmove’s power.",
    "shortDesc": "The user spouts water to damage opposing\nPokemon. The lower the user’s HP, the lower the\nmove’s power.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 210
    }
  },
  "signalbeam": {
    "num": 324,
    "accuracy": 100,
    "basePower": 80,
    "category": "Special",
    "name": "Signal Beam",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Bug",
    "target": "normal",
    "desc": "The user attacks with a sinister beam of light.\nThis boosts your Sp. Atk 25% of the time.",
    "shortDesc": "The user attacks with a sinister beam of light.\nThis boosts your Sp. Atk 25% of the time.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 25,
        "self": {
          "boosts": {
            "spa": 1
          }
        }
      }
    ]
  },
  "shadowpunch": {
    "num": 325,
    "accuracy": true,
    "basePower": 80,
    "category": "Physical",
    "name": "Shadow Punch",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "The user throws a punch from the shadows.\nThis can't miss, and bypasses substitute. Contact.",
    "shortDesc": "The user throws a punch from the shadows.\nThis can't miss, and bypasses substitute. Contact.",
    "flags": {
      "bypasssub": 1,
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    }
  },
  "extrasensory": {
    "num": 326,
    "accuracy": 100,
    "basePower": 75,
    "category": "Special",
    "name": "Extrasensory",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user attacks with an odd, unseeable power.\nThis flinches the target 30% of\nthe time.",
    "shortDesc": "The user attacks with an odd, unseeable power.\nThis flinches the target 30% of\nthe time.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 150
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "skyuppercut": {
    "num": 327,
    "accuracy": 95,
    "basePower": 100,
    "category": "Physical",
    "name": "Sky Uppercut",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user attacks the target with an uppercut thrown\nskyward with force. This flinches 25% of the time.\nContact. Affected by Rapid Fire.",
    "shortDesc": "The user attacks the target with an uppercut thrown\nskyward with force. This flinches 25% of the time.\nContact. Affected by Rapid Fire.",
    "flags": {
      "contact": 1,
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    },
    "secondaries": [
      {
        "chance": 25,
        "volatileStatus": "flinch"
      }
    ]
  },
  "scorchingsands": {
    "num": 328,
    "accuracy": 100,
    "basePower": 75,
    "category": "Special",
    "name": "Scorching Sands",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "normal",
    "desc": "The user envelops the target with searing hot sands.\nThis burns the target 30% of the time.",
    "shortDesc": "The user envelops the target with searing hot sands.\nThis burns the target 30% of the time.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 150
    },
    "secondaries": [
      {
        "chance": 30,
        "status": "brn"
      }
    ]
  },
  "sheercold": {
    "num": 329,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Sheer Cold",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Ice",
    "target": "normal",
    "desc": "The target is fainted with absolute-zero cold.\nThis attack NEVER misses, but can only be used once.\nContact.",
    "shortDesc": "The target is fainted with absolute-zero cold.\nThis attack NEVER misses, but can only be used once.\nContact.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 255
    }
  },
  "muddywater": {
    "num": 330,
    "accuracy": 90,
    "basePower": 110,
    "category": "Special",
    "name": "Muddy Water",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "allAdjacentFoes",
    "desc": "The user swamps the field with muddy water.\nThis lowers the opponents Speed 100% of the time.",
    "shortDesc": "The user swamps the field with muddy water.\nThis lowers the opponents Speed 100% of the time.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 185
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -1
        }
      }
    ]
  },
  "bulletseed": {
    "num": 331,
    "accuracy": 100,
    "basePower": 25,
    "category": "Physical",
    "name": "Bullet Seed",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user forcefully shoots seeds at the target two\nto five times in a row.",
    "shortDesc": "The user forcefully shoots seeds at the target two\nto five times in a row.",
    "flags": {
      "bullet": 1,
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": [
      2,
      5
    ],
    "zMove": {
      "basePower": 140
    }
  },
  "aerialace": {
    "num": 332,
    "accuracy": true,
    "basePower": 55,
    "category": "Physical",
    "name": "Aerial Ace",
    "pp": 10,
    "priority": 2,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "The user confounds the target with speed, then\nslashes. This is +2 priority, and can't miss. Contact.",
    "shortDesc": "The user confounds the target with speed, then\nslashes. This is +2 priority, and can't miss. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 110
    }
  },
  "glacialbarrage": {
    "num": 333,
    "accuracy": 100,
    "basePower": 25,
    "category": "Physical",
    "name": "Glacial Barrage",
    "pp": 3,
    "priority": 0,
    "critRatio": 7,
    "type": "Ice",
    "target": "normal",
    "desc": "The user fires 3 icicles at the target's critical\nweak points with great force. This hits 3 times, and\nALWAYS results in a critical hit, ignores protect.",
    "shortDesc": "The user fires 3 icicles at the target's critical\nweak points with great force. This hits 3 times, and\nALWAYS results in a critical hit, ignores protect.",
    "flags": {
      "heal": 1,
      "mirror": 1
    },
    "willCrit": true,
    "multihit": 3,
    "zMove": {
      "basePower": 190
    }
  },
  "irondefense": {
    "num": 334,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Iron Defense",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "self",
    "desc": "The user hardens its body’s surface like iron,\nsharply raising its Defense stat.\nZ-Effect heals user fully.",
    "shortDesc": "The user hardens its body’s surface like iron,\nsharply raising its Defense stat.\nZ-Effect heals user fully.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "def": 2
        }
      }
    ]
  },
  "block": {
    "num": 335,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Block",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "Blocks the foe to prevent them from switching.\nZ-Effect +3 Defense.",
    "shortDesc": "Blocks the foe to prevent them from switching.\nZ-Effect +3 Defense.",
    "flags": {
      "mirror": 1,
      "reflectable": 1
    }
  },
  "howl": {
    "num": 336,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Howl",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user howls loudly to raise its spirit, which raises\nits Attack and Sp. Atk stats by 2 stages.\nZ-Effect gives +3 Accuracy.",
    "shortDesc": "The user howls loudly to raise its spirit, which raises\nits Attack and Sp. Atk stats by 2 stages.\nZ-Effect gives +3 Accuracy.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "atk": 2
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spa": 2
        }
      }
    ]
  },
  "dragonclaw": {
    "num": 337,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Dragon Claw",
    "pp": 10,
    "priority": 0,
    "critRatio": 3,
    "type": "Dragon",
    "target": "normal",
    "desc": "The user slashes the foe with claws or blades imbued\nwith dragon energy. This has a 50% (+2) crit rate.\nContact.",
    "shortDesc": "The user slashes the foe with claws or blades imbued\nwith dragon energy. This has a 50% (+2) crit rate.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    }
  },
  "frenzyplant": {
    "num": 338,
    "accuracy": 100,
    "basePower": 150,
    "category": "Physical",
    "name": "Frenzy Plant",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "In a frenzy, the user slams the foe with plant matter.\nThis drops the user's attack by 2 after use.",
    "shortDesc": "In a frenzy, the user slams the foe with plant matter.\nThis drops the user's attack by 2 after use.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "atk": -2
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "bulkup": {
    "num": 339,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Bulk Up",
    "pp": 3,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "self",
    "desc": "The user tenses its muscles to bulk up its body,\nraising both its Attack and Defense stats by 1.\nZ-Effect +2 crit rate.",
    "shortDesc": "The user tenses its muscles to bulk up its body,\nraising both its Attack and Defense stats by 1.\nZ-Effect +2 crit rate.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "atk": 1
        }
      },
      {
        "chance": 0,
        "boosts": {
          "def": 1
        }
      }
    ]
  },
  "bounce": {
    "num": 340,
    "accuracy": 100,
    "basePower": 75,
    "category": "Physical",
    "name": "Bounce",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "The user bounces up high, then drops on the target\non the second turn. This paralyzes the foe 30% of\nthe time. Contact. Bypasses Protect.",
    "shortDesc": "The user bounces up high, then drops on the target\non the second turn. This paralyzes the foe 30% of\nthe time. Contact. Bypasses Protect.",
    "flags": {
      "charge": 1,
      "contact": 1,
      "gravity": 1,
      "mirror": 1
    },
    "zMove": {
      "basePower": 150
    },
    "secondaries": [
      {
        "chance": 30,
        "status": "par"
      }
    ]
  },
  "mudshot": {
    "num": 341,
    "accuracy": true,
    "basePower": 45,
    "category": "Special",
    "name": "Mud Shot",
    "pp": 20,
    "priority": 1,
    "critRatio": 1,
    "type": "Ground",
    "target": "normal",
    "desc": "The user quickly shoots mud at the target.\nThis has +1 priority, and can't miss.",
    "shortDesc": "The user quickly shoots mud at the target.\nThis has +1 priority, and can't miss.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 90
    }
  },
  "poisontail": {
    "num": 342,
    "accuracy": 100,
    "basePower": 95,
    "category": "Physical",
    "name": "Poison Tail",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "The user pummels the target with a tail steeped in\npoison. This poisons 30% of the time, and has a\n30% flinch rate. Contact.",
    "shortDesc": "The user pummels the target with a tail steeped in\npoison. This poisons 30% of the time, and has a\n30% flinch rate. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 30,
        "status": "psn"
      },
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "covet": {
    "num": 343,
    "accuracy": 100,
    "basePower": 60,
    "category": "Physical",
    "name": "Covet",
    "pp": 25,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user endearingly approaches the target, then\nsteals the target's held item. The user can't steal\nan item if it already holds one. Contact.",
    "shortDesc": "The user endearingly approaches the target, then\nsteals the target's held item. The user can't steal\nan item if it already holds one. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1,
      "sound": 1
    },
    "zMove": {
      "basePower": 120
    }
  },
  "volttackle": {
    "num": 344,
    "accuracy": 100,
    "basePower": 125,
    "category": "Physical",
    "name": "Volt Tackle",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "The user electrifies itself and charges the target\naggressively. This deals 25% recoil to the user.\nThis paralyzes the foe 25% of the time. Contact.",
    "shortDesc": "The user electrifies itself and charges the target\naggressively. This deals 25% recoil to the user.\nThis paralyzes the foe 25% of the time. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      1,
      4
    ],
    "zMove": {
      "basePower": 195
    },
    "secondaries": [
      {
        "chance": 25,
        "status": "par"
      }
    ]
  },
  "magicalleaf": {
    "num": 345,
    "accuracy": 100,
    "basePower": 60,
    "category": "Special",
    "name": "Magical Leaf",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user scatters magical, curious leaves at the foe.\nThis ALWAYS raises the user's Sp. Def by 1 after use.",
    "shortDesc": "The user scatters magical, curious leaves at the foe.\nThis ALWAYS raises the user's Sp. Def by 1 after use.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "spd": 1
          }
        }
      }
    ]
  },
  "watersport": {
    "num": 346,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Water Sport",
    "pp": 15,
    "priority": 4,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "The user soaks the battlefield with water. This\nweakens Fire-type moves for five turns.\nZ-Effect +3 Sp. Def. +4 Priority.",
    "shortDesc": "The user soaks the battlefield with water. This\nweakens Fire-type moves for five turns.\nZ-Effect +3 Sp. Def. +4 Priority.",
    "flags": {}
  },
  "calmmind": {
    "num": 347,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Calm Mind",
    "pp": 3,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "self",
    "desc": "The user quietly focuses its mind and calms its\nspirit to raise its Sp. Atk and Sp. Def stats by 1.\nZ-Effect +2 crit rate.",
    "shortDesc": "The user quietly focuses its mind and calms its\nspirit to raise its Sp. Atk and Sp. Def stats by 1.\nZ-Effect +2 crit rate.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "spa": 1
        }
      },
      {
        "chance": 0,
        "boosts": {
          "spd": 1
        }
      }
    ]
  },
  "leafblade": {
    "num": 348,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Leaf Blade",
    "pp": 10,
    "priority": 0,
    "critRatio": 3,
    "type": "Grass",
    "target": "normal",
    "desc": "The user slashes the foe with a blade made of a leaf.\nThis has a 50% (+2) crit rate. Contact.",
    "shortDesc": "The user slashes the foe with a blade made of a leaf.\nThis has a 50% (+2) crit rate. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    }
  },
  "dragondance": {
    "num": 349,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Dragon Dance",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Dragon",
    "target": "self",
    "desc": "The user vigorously performs a mystic, powerful\ndance that raises its Attack and Speed stats by 1.\nZ-Effect crit rate +2.",
    "shortDesc": "The user vigorously performs a mystic, powerful\ndance that raises its Attack and Speed stats by 1.\nZ-Effect crit rate +2.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "atk": 1
        }
      },
      {
        "chance": 0,
        "boosts": {
          "spe": 1
        }
      }
    ]
  },
  "rockblast": {
    "num": 350,
    "accuracy": 100,
    "basePower": 25,
    "category": "Physical",
    "name": "Rock Blast",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Rock",
    "target": "normal",
    "desc": "The user hurls hard rocks at the target. Two to five\nrocks are launched in a row.",
    "shortDesc": "The user hurls hard rocks at the target. Two to five\nrocks are launched in a row.",
    "flags": {
      "bullet": 1,
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": [
      2,
      5
    ],
    "zMove": {
      "basePower": 140
    }
  },
  "shockwave": {
    "num": 351,
    "accuracy": true,
    "basePower": 55,
    "category": "Special",
    "name": "Shock Wave",
    "pp": 10,
    "priority": 2,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "The user strikes the target with a rapid wave of\nelectricity. This has +2 priority, and can't miss.",
    "shortDesc": "The user strikes the target with a rapid wave of\nelectricity. This has +2 priority, and can't miss.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 110
    }
  },
  "waterpulse": {
    "num": 352,
    "accuracy": 100,
    "basePower": 60,
    "category": "Special",
    "name": "Water Pulse",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "The user attacks the foe with a beautiful pulse of\nwater. This ALWAYS drops BOTH of the foe's offensive\nstats by 1 after use.",
    "shortDesc": "The user attacks the foe with a beautiful pulse of\nwater. This ALWAYS drops BOTH of the foe's offensive\nstats by 1 after use.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "pulse": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      }
    ]
  },
  "doomdesire": {
    "num": 353,
    "accuracy": 100,
    "basePower": 160,
    "category": "Special",
    "name": "Doom Desire",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user foresees the target's demise. 2 turns after\nthis move is used, the target is hit with an immense\nblast of dark energy. Bypasses Protect and Substitute.",
    "shortDesc": "The user foresees the target's demise. 2 turns after\nthis move is used, the target is hit with an immense\nblast of dark energy. Bypasses Protect and Substitute.",
    "flags": {
      "bypasssub": 1
    },
    "zMove": {
      "basePower": 220
    }
  },
  "psychoboost": {
    "num": 354,
    "accuracy": 100,
    "basePower": 150,
    "category": "Special",
    "name": "Psycho Boost",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user unleashes a massive blast of psychic energy.\nThis drops the user's Sp. Atk by 2 after use.",
    "shortDesc": "The user unleashes a massive blast of psychic energy.\nThis drops the user's Sp. Atk by 2 after use.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "spa": -2
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "roost": {
    "num": 355,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Roost",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Flying",
    "target": "self",
    "desc": "The user lands and rests its body. It restores the\nuser’s HP by 50% of the user's max HP.\nZ-Effect +2 Defense. Removes Flying type for the turn.",
    "shortDesc": "The user lands and rests its body. It restores the\nuser’s HP by 50% of the user's max HP.\nZ-Effect +2 Defense. Removes Flying type for the turn.",
    "flags": {
      "snatch": 1
    }
  },
  "gravity": {
    "num": 356,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Gravity",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "Enables Flying-type Pokemon or Pokemon with the\nLevitate Ability to be hit by Ground-type moves.\nFlying moves can’t be used. Z-Effect +2 Sp. Atk.",
    "shortDesc": "Enables Flying-type Pokemon or Pokemon with the\nLevitate Ability to be hit by Ground-type moves.\nFlying moves can’t be used. Z-Effect +2 Sp. Atk.",
    "flags": {}
  },
  "miracleeye": {
    "num": 357,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Miracle Eye",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "Enables the user to hit Dark-types with Psychic moves.\nAlso makes it so no attacks will miss the foe.\nZ-Effect gives +1 to all stats.",
    "shortDesc": "Enables the user to hit Dark-types with Psychic moves.\nAlso makes it so no attacks will miss the foe.\nZ-Effect gives +1 to all stats.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "wakeupslap": {
    "num": 358,
    "accuracy": true,
    "basePower": 70,
    "category": "Physical",
    "name": "Wake-Up Slap",
    "pp": 1,
    "priority": 4,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user slaps the foe, startling them. This has\n+4 Priority, and ALWAYS flinches the foe from shock.\nDoubles in power if the foe is asleep. Contact.",
    "shortDesc": "The user slaps the foe, startling them. This has\n+4 Priority, and ALWAYS flinches the foe from shock.\nDoubles in power if the foe is asleep. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 140
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "flinch"
      }
    ]
  },
  "hammerarm": {
    "num": 359,
    "accuracy": 100,
    "basePower": 120,
    "category": "Physical",
    "name": "Hammer Arm",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user slams its heavy arm or fist onto the foe.\nThis always lowers the user's Speed by 1. Contact.",
    "shortDesc": "The user slams its heavy arm or fist onto the foe.\nThis always lowers the user's Speed by 1. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "spe": -1
      }
    },
    "zMove": {
      "basePower": 190
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "25"
      },
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "gyroball": {
    "num": 360,
    "accuracy": 100,
    "basePower": 1,
    "category": "Physical",
    "name": "Gyro Ball",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "normal",
    "desc": "The user tackles the target while spinning.\nThis gains power the faster the foe is than the user.\nAfter use, the user's Speed drops by 2. Contact.",
    "shortDesc": "The user tackles the target while spinning.\nThis gains power the faster the foe is than the user.\nAfter use, the user's Speed drops by 2. Contact.",
    "flags": {
      "bullet": 1,
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "spe": -2
      }
    },
    "zMove": {
      "basePower": 170
    }
  },
  "healingwish": {
    "num": 361,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Healing Wish",
    "pp": 5,
    "priority": 6,
    "critRatio": 1,
    "type": "Fairy",
    "target": "self",
    "desc": "The user faints. In return, the Pokemon taking its\nplace will have its HP restored and status\nconditions cured. This has +6 Priority.",
    "shortDesc": "The user faints. In return, the Pokemon taking its\nplace will have its HP restored and status\nconditions cured. This has +6 Priority.",
    "flags": {
      "snatch": 1,
      "sound": 1
    }
  },
  "brine": {
    "num": 362,
    "accuracy": 100,
    "basePower": 75,
    "category": "Special",
    "name": "Brine",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "The user douses the foe in water.\nIf the target’s HP is 50% or less, this attack will hit\nwith double the power.",
    "shortDesc": "The user douses the foe in water.\nIf the target’s HP is 50% or less, this attack will hit\nwith double the power.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 150
    }
  },
  "naturalgift": {
    "num": 363,
    "accuracy": 100,
    "basePower": 1,
    "category": "Special",
    "name": "Natural Gift",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user draws power to attack by using its held\nBerry. Super effective weakening berries become 110\nBase Power moves of their respective type.",
    "shortDesc": "The user draws power to attack by using its held\nBerry. Super effective weakening berries become 110\nBase Power moves of their respective type.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 185
    }
  },
  "thinkfast": {
    "num": 364,
    "accuracy": true,
    "basePower": 55,
    "category": "Physical",
    "name": "Think Fast",
    "pp": 10,
    "priority": 2,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user uses its intelligence to outmaneuver the foe,\nthrowing a quick punch. This has +2 Priority, and\nbypasses protect, lifting the effects. Can't miss.",
    "shortDesc": "The user uses its intelligence to outmaneuver the foe,\nthrowing a quick punch. This has +2 Priority, and\nbypasses protect, lifting the effects. Can't miss.",
    "flags": {
      "contact": 1,
      "mirror": 1
    },
    "zMove": {
      "basePower": 110
    }
  },
  "pluck": {
    "num": 365,
    "accuracy": 100,
    "basePower": 65,
    "category": "Physical",
    "name": "Pluck",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "The user pecks the target. If the target is holding a\nBerry, the user eats it and gains its effect. Contact.",
    "shortDesc": "The user pecks the target. If the target is holding a\nBerry, the user eats it and gains its effect. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 130
    }
  },
  "tailwind": {
    "num": 366,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Tailwind",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "The user whips up a turbulent whirlwind that doubles\nthe Speed stat of the user and its allies for\nfour turns. Z-Effect +2 crit rate.",
    "shortDesc": "The user whips up a turbulent whirlwind that doubles\nthe Speed stat of the user and its allies for\nfour turns. Z-Effect +2 crit rate.",
    "flags": {
      "snatch": 1
    }
  },
  "acupressure": {
    "num": 367,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Acupressure",
    "pp": 3,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "adjacentAlly",
    "desc": "The user applies pressure to stress points, sharply\nboosting one of its or its allies’ stats by 2.\nZ-Effect +2 crit rate.",
    "shortDesc": "The user applies pressure to stress points, sharply\nboosting one of its or its allies’ stats by 2.\nZ-Effect +2 crit rate.",
    "flags": {}
  },
  "metalburst": {
    "num": 368,
    "accuracy": 100,
    "basePower": 1,
    "category": "Physical",
    "name": "Metal Burst",
    "pp": 10,
    "priority": -6,
    "critRatio": 1,
    "type": "Steel",
    "target": "normal",
    "desc": "The user takes any attack and delivers 50% of\ndamage taken back at the foe at the end of the turn.",
    "shortDesc": "The user takes any attack and delivers 50% of\ndamage taken back at the foe at the end of the turn.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    }
  },
  "uturn": {
    "num": 369,
    "accuracy": true,
    "basePower": 75,
    "category": "Physical",
    "name": "U-turn",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Bug",
    "target": "normal",
    "desc": "After making its attack, the user rushes back to\nswitch places with a party Pokemon in waiting.\nThis attack cannot miss. Contact.",
    "shortDesc": "After making its attack, the user rushes back to\nswitch places with a party Pokemon in waiting.\nThis attack cannot miss. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 150
    }
  },
  "closecombat": {
    "num": 370,
    "accuracy": 100,
    "basePower": 120,
    "category": "Physical",
    "name": "Close Combat",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user fights the target up close without guarding\nitself. This also lowers the user’s Defense and\nSp. Def stats by 1. Contact.",
    "shortDesc": "The user fights the target up close without guarding\nitself. This also lowers the user’s Defense and\nSp. Def stats by 1. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "def": -1,
        "spd": -1
      }
    },
    "zMove": {
      "basePower": 195
    }
  },
  "payback": {
    "num": 371,
    "accuracy": true,
    "basePower": 60,
    "category": "Physical",
    "name": "Payback",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user violently retaliates at the foe.\nThis doubles in power if you move after the target.\nContact. Can't miss. Neutral Priority.",
    "shortDesc": "The user violently retaliates at the foe.\nThis doubles in power if you move after the target.\nContact. Can't miss. Neutral Priority.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 190
    }
  },
  "assurance": {
    "num": 372,
    "accuracy": 100,
    "basePower": 75,
    "category": "Physical",
    "name": "Assurance",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "If the foe's taken damage this turn, the power of this\nattack doubles. This includes damage from life orb,\nentry hazards, confusion, and recoil damage. Contact.",
    "shortDesc": "If the foe's taken damage this turn, the power of this\nattack doubles. This includes damage from life orb,\nentry hazards, confusion, and recoil damage. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 150
    }
  },
  "embargo": {
    "num": 373,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Embargo",
    "pp": 15,
    "priority": 4,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "This move prevents the target from using its held\nitem for 15 turns. Z-Effect +2 Attack.\nThis has +4 priority.",
    "shortDesc": "This move prevents the target from using its held\nitem for 15 turns. Z-Effect +2 Attack.\nThis has +4 priority.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "fling": {
    "num": 374,
    "accuracy": true,
    "basePower": 1,
    "category": "Physical",
    "name": "Fling",
    "pp": 3,
    "priority": 4,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user quickly throws its held item. +4 Priority.\nZap Plate paralyzes, Flame Plate burns, & Toxic Plate\nbadly poisons. Plates do 100 BP. King's Rock flinches.",
    "shortDesc": "The user quickly throws its held item. +4 Priority.\nZap Plate paralyzes, Flame Plate burns, & Toxic Plate\nbadly poisons. Plates do 100 BP. King's Rock flinches.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    }
  },
  "psychoshift": {
    "num": 375,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Psycho Shift",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "Using its psychic power of suggestion, the user\ntransfers its status conditions to the target.\nZ-Effect +1 All Stats.",
    "shortDesc": "Using its psychic power of suggestion, the user\ntransfers its status conditions to the target.\nZ-Effect +1 All Stats.",
    "flags": {
      "mirror": 1,
      "protect": 1
    }
  },
  "hocuspocus": {
    "num": 376,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Hocus-Pocus",
    "pp": 1,
    "priority": 2,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user performs an astonishing magic trick.\nThis can only fool the foe once, but ALWAYS flinches.\nThis has +2 Priority, and is 200 Base Power.",
    "shortDesc": "The user performs an astonishing magic trick.\nThis can only fool the foe once, but ALWAYS flinches.\nThis has +2 Priority, and is 200 Base Power.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 250
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "flinch"
      }
    ]
  },
  "healblock": {
    "num": 377,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Heal Block",
    "pp": 15,
    "priority": 4,
    "critRatio": 1,
    "type": "Psychic",
    "target": "allAdjacentFoes",
    "desc": "For 15 turns, the foe's team is prevented from using\nany moves, Abilities, or held items that recover HP.\nZ-Effect +2 Sp. Atk. +4 Priority.",
    "shortDesc": "For 15 turns, the foe's team is prevented from using\nany moves, Abilities, or held items that recover HP.\nZ-Effect +2 Sp. Atk. +4 Priority.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "chromosomecrush": {
    "num": 378,
    "accuracy": 100,
    "basePower": 1,
    "category": "Special",
    "name": "Chromosome Crush",
    "pp": 5,
    "priority": 0,
    "critRatio": 7,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user mangles the opponent's DNA. This deals more\ndamage depending how much HP the target has left.\nMax of 120 BP. ALWAYS crits. MEW HAS SIGNATURE Z-MOVE.",
    "shortDesc": "The user mangles the opponent's DNA. This deals more\ndamage depending how much HP the target has left.\nMax of 120 BP. ALWAYS crits. MEW HAS SIGNATURE Z-MOVE.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 250
    }
  },
  "powertrick": {
    "num": 379,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Power Trick",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "self",
    "desc": "The user employs its psychic power to switch its\nAttack stat with its Defense stat.\nZ-Effect +2 Attack.",
    "shortDesc": "The user employs its psychic power to switch its\nAttack stat with its Defense stat.\nZ-Effect +2 Attack.",
    "flags": {
      "snatch": 1
    }
  },
  "acidreflux": {
    "num": 380,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Acid Reflux",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "The user hurls stomach acid at the foe, dropping their\nSp. Def stat by 4 in addition to poisoning them.\nZ-Effect heals the user fully.",
    "shortDesc": "The user hurls stomach acid at the foe, dropping their\nSp. Def stat by 4 in addition to poisoning them.\nZ-Effect heals the user fully.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "psn"
      },
      {
        "chance": 100,
        "boosts": {
          "spd": -4
        }
      }
    ]
  },
  "luckychant": {
    "num": 381,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Lucky Chant",
    "pp": 30,
    "priority": 4,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user chants an incantation toward the sky,\npreventing opposing Pokemon from landing\ncrits for 5 turns. +4 Priority. Z-Effect +3 Sp. Def.",
    "shortDesc": "The user chants an incantation toward the sky,\npreventing opposing Pokemon from landing\ncrits for 5 turns. +4 Priority. Z-Effect +3 Sp. Def.",
    "flags": {
      "snatch": 1
    }
  },
  "mefirst": {
    "num": 382,
    "accuracy": true,
    "basePower": 1,
    "category": "Status",
    "name": "Me First",
    "pp": 5,
    "priority": 6,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user cuts ahead of the target to copy and use\nthe target’s intended move with greater power.\nZ-Effect +2 Attack. +6 Priority.",
    "shortDesc": "The user cuts ahead of the target to copy and use\nthe target’s intended move with greater power.\nZ-Effect +2 Attack. +6 Priority.",
    "flags": {
      "bypasssub": 1,
      "protect": 1
    }
  },
  "copycat": {
    "num": 383,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Copycat",
    "pp": 5,
    "priority": 6,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user mimics the move used immediately before\nit. The move fails if no other move has been\nused yet. Z-Effect +2 Attack. +6 Priority.",
    "shortDesc": "The user mimics the move used immediately before\nit. The move fails if no other move has been\nused yet. Z-Effect +2 Attack. +6 Priority.",
    "flags": {}
  },
  "powerswap": {
    "num": 384,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Power Swap",
    "pp": 10,
    "priority": 4,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user employs its psychic power to switch\nchanges to its Attack and Sp. Atk stats with\nthe foe. +4 Priority. Z-Effect +3 Speed.",
    "shortDesc": "The user employs its psychic power to switch\nchanges to its Attack and Sp. Atk stats with\nthe foe. +4 Priority. Z-Effect +3 Speed.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1
    }
  },
  "guardswap": {
    "num": 385,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Guard Swap",
    "pp": 10,
    "priority": 4,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user employs its psychic power to switch\nchanges to its Defense and Sp. Def stats with\nthe foe. +4 Priority. Z-Effect +3 Speed.",
    "shortDesc": "The user employs its psychic power to switch\nchanges to its Defense and Sp. Def stats with\nthe foe. +4 Priority. Z-Effect +3 Speed.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1
    }
  },
  "punishment": {
    "num": 386,
    "accuracy": true,
    "basePower": 1,
    "category": "Physical",
    "name": "Punishment",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user punishes the opponent for boosting stats.\nThe base power increases by 20 for every stat boost,\nbeginning at 60 BP. Can't miss,",
    "shortDesc": "The user punishes the opponent for boosting stats.\nThe base power increases by 20 for every stat boost,\nbeginning at 60 BP. Can't miss,",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    }
  },
  "lastresort": {
    "num": 387,
    "accuracy": true,
    "basePower": 140,
    "category": "Physical",
    "name": "Last Resort",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "This powerful, desperate attack can only be used\nafter the user has exhausted all other options.\nThis can't miss.",
    "shortDesc": "This powerful, desperate attack can only be used\nafter the user has exhausted all other options.\nThis can't miss.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 205
    }
  },
  "worryseed": {
    "num": 388,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Worry Seed",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "A seed that causes worry is planted on the target.\nIt prevents sleep by making the target’s\nAbility Insomnia. Z-Effect +2 Sp. Atk.",
    "shortDesc": "A seed that causes worry is planted on the target.\nIt prevents sleep by making the target’s\nAbility Insomnia. Z-Effect +2 Sp. Atk.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "suckerpunch": {
    "num": 389,
    "accuracy": true,
    "basePower": 70,
    "category": "Physical",
    "name": "Sucker Punch",
    "pp": 5,
    "priority": 2,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "This user sucker punches the foe. This fails if the\ntarget isn't using an attacking move that turn. This\nhas +2 priority and can't miss. Contact.",
    "shortDesc": "This user sucker punches the foe. This fails if the\ntarget isn't using an attacking move that turn. This\nhas +2 priority and can't miss. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 140
    }
  },
  "toxicspikes": {
    "num": 390,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Toxic Spikes",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "The user lays a trap of toxic spikes on the opponent's\nside. One layer poisons, two layers badly poison.\nZ-Effect +3 Defense.",
    "shortDesc": "The user lays a trap of toxic spikes on the opponent's\nside. One layer poisons, two layers badly poison.\nZ-Effect +3 Defense.",
    "flags": {
      "reflectable": 1
    }
  },
  "heartswap": {
    "num": 391,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Heart Swap",
    "pp": 1,
    "priority": 4,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user instantly switches stat changes with the foe.\nThis has +4 Priority. Z-Effect heals the user fully.",
    "shortDesc": "The user instantly switches stat changes with the foe.\nThis has +4 Priority. Z-Effect heals the user fully.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1
    }
  },
  "rehydrate": {
    "num": 392,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Rehydrate",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "self",
    "desc": "The user envelops itself in a veil made of water.\nThis recovers 50% of the user's max HP.\nZ-Effect +2 Sp. Def.",
    "shortDesc": "The user envelops itself in a veil made of water.\nThis recovers 50% of the user's max HP.\nZ-Effect +2 Sp. Def.",
    "flags": {
      "snatch": 1
    }
  },
  "magnetrise": {
    "num": 393,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Magnet Rise",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "self",
    "desc": "The user levitates using electrically generated\nmagnetism for five turns. Z-Effect +2 Speed.",
    "shortDesc": "The user levitates using electrically generated\nmagnetism for five turns. Z-Effect +2 Speed.",
    "flags": {
      "gravity": 1,
      "snatch": 1
    }
  },
  "flareblitz": {
    "num": 394,
    "accuracy": 100,
    "basePower": 125,
    "category": "Physical",
    "name": "Flare Blitz",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The user cloaks itself in fire and charges the target.\nThis has 25% recoil, and a 25% chance to burn the foe.\nContact.",
    "shortDesc": "The user cloaks itself in fire and charges the target.\nThis has 25% recoil, and a 25% chance to burn the foe.\nContact.",
    "flags": {
      "contact": 1,
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      1,
      4
    ],
    "zMove": {
      "basePower": 195
    },
    "secondaries": [
      {
        "chance": 25,
        "status": "brn"
      }
    ]
  },
  "forcewaves": {
    "num": 395,
    "accuracy": 100,
    "basePower": 40,
    "category": "Special",
    "name": "Force Waves",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user creates 2 shock waves with it's palms. This\nhits twice. Each hit has a\n30% chance to paralyze, for a total chance of 51%.",
    "shortDesc": "The user creates 2 shock waves with it's palms. This\nhits twice. Each hit has a\n30% chance to paralyze, for a total chance of 51%.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "multihit": 2,
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 30,
        "status": "par"
      }
    ]
  },
  "aurasphere": {
    "num": 396,
    "accuracy": true,
    "basePower": 90,
    "category": "Special",
    "name": "Aura Sphere",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user lets loose a blast of aura power from deep\nwithin itself. This has a 20% chance to drop\nSp. Def by 1, and can't miss.",
    "shortDesc": "The user lets loose a blast of aura power from deep\nwithin itself. This has a 20% chance to drop\nSp. Def by 1, and can't miss.",
    "flags": {
      "bullet": 1,
      "mirror": 1,
      "protect": 1,
      "pulse": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 20,
        "boosts": {
          "spd": -1
        }
      }
    ]
  },
  "rockpolish": {
    "num": 397,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Rock Polish",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Rock",
    "target": "self",
    "desc": "The user polishes its body to reduce drag.\nThis raises the user's Speed by 2 and Accuracy by 1.\nZ-Effect +2 crit rate.",
    "shortDesc": "The user polishes its body to reduce drag.\nThis raises the user's Speed by 2 and Accuracy by 1.\nZ-Effect +2 crit rate.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "spe": 2
        }
      },
      {
        "chance": 0,
        "boosts": {
          "accuracy": 1
        }
      }
    ]
  },
  "poisonjab": {
    "num": 398,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Poison Jab",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "The target is stabbed with a tentacle or arm steeped\nin poison. This poisons the foe 30% of the time.\nContact.",
    "shortDesc": "The target is stabbed with a tentacle or arm steeped\nin poison. This poisons the foe 30% of the time.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 30,
        "status": "psn"
      }
    ]
  },
  "darkpulse": {
    "num": 399,
    "accuracy": 100,
    "basePower": 85,
    "category": "Special",
    "name": "Dark Pulse",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user releases a horrible aura imbued with dark\nenergy. This flinches 20% of the time, and afflicts\na sleeping target with a horrible nightmare.",
    "shortDesc": "The user releases a horrible aura imbued with dark\nenergy. This flinches 20% of the time, and afflicts\na sleeping target with a horrible nightmare.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "pulse": 1
    },
    "zMove": {
      "basePower": 170
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "9"
      },
      {
        "chance": 20,
        "volatileStatus": "flinch"
      }
    ]
  },
  "nightslash": {
    "num": 400,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Night Slash",
    "pp": 10,
    "priority": 0,
    "critRatio": 3,
    "type": "Dark",
    "target": "normal",
    "desc": "The user slashes the target the instant an\nopportunity arises. This has a 50% (+2) crit rate.\nContact.",
    "shortDesc": "The user slashes the target the instant an\nopportunity arises. This has a 50% (+2) crit rate.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    }
  },
  "aquatail": {
    "num": 401,
    "accuracy": 100,
    "basePower": 100,
    "category": "Physical",
    "name": "Aqua Tail",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "The user attacks by swinging its tail as if it were a\nvicious wave in a raging storm. This has a 30%\nchance to drop Defense. Contact.",
    "shortDesc": "The user attacks by swinging its tail as if it were a\nvicious wave in a raging storm. This has a 30%\nchance to drop Defense. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    },
    "secondaries": [
      {
        "chance": 30,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "seedbomb": {
    "num": 402,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Seed Bomb",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user slams a barrage of hard-shelled seeds\ndown on the target from above. This flinches the\ntarget 20% of the time.",
    "shortDesc": "The user slams a barrage of hard-shelled seeds\ndown on the target from above. This flinches the\ntarget 20% of the time.",
    "flags": {
      "bullet": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 20,
        "volatileStatus": "flinch"
      }
    ]
  },
  "airslash": {
    "num": 403,
    "accuracy": 100,
    "basePower": 80,
    "category": "Special",
    "name": "Air Slash",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "The user attacks with a blade of air that slices even\nthe sky. This flinches the target 30% of the time.",
    "shortDesc": "The user attacks with a blade of air that slices even\nthe sky. This flinches the target 30% of the time.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 170
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "xscissor": {
    "num": 404,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "X-Scissor",
    "pp": 10,
    "priority": 0,
    "critRatio": 3,
    "type": "Bug",
    "target": "normal",
    "desc": "The user slashes at the target by crossing its\nscythes or claws as if they were a pair of scissors.\nThis has a 50% (+2) crit rate. Contact.",
    "shortDesc": "The user slashes at the target by crossing its\nscythes or claws as if they were a pair of scissors.\nThis has a 50% (+2) crit rate. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    }
  },
  "bugbuzz": {
    "num": 405,
    "accuracy": 100,
    "basePower": 95,
    "category": "Special",
    "name": "Bug Buzz",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Bug",
    "target": "allAdjacentFoes",
    "desc": "The user generates a devastating sound wave with\nvibration. This flinches the targets 30% of the time.",
    "shortDesc": "The user generates a devastating sound wave with\nvibration. This flinches the targets 30% of the time.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "punch": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "dragonpulse": {
    "num": 406,
    "accuracy": 100,
    "basePower": 100,
    "category": "Special",
    "name": "Dragon Pulse",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Dragon",
    "target": "normal",
    "desc": "The target is attacked with a shock wave generated\nby the user’s gaping mouth. This leaves the target\nwith paralysis 30% of the time.",
    "shortDesc": "The target is attacked with a shock wave generated\nby the user’s gaping mouth. This leaves the target\nwith paralysis 30% of the time.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "pulse": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 30,
        "status": "par"
      }
    ]
  },
  "dragonrush": {
    "num": 407,
    "accuracy": 100,
    "basePower": 120,
    "category": "Physical",
    "name": "Dragon Rush",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Dragon",
    "target": "normal",
    "desc": "The user tackles the target while exhibiting\noverwhelming menace. This drops the user's Defensive\nstats by 1 after use. 30% flinch rate. Contact.",
    "shortDesc": "The user tackles the target while exhibiting\noverwhelming menace. This drops the user's Defensive\nstats by 1 after use. 30% flinch rate. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "def": -1,
        "spd": -1
      }
    },
    "zMove": {
      "basePower": 190
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "powergem": {
    "num": 408,
    "accuracy": 100,
    "basePower": 95,
    "category": "Special",
    "name": "Power Gem",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Rock",
    "target": "normal",
    "desc": "The user attacks with a ray of light that sparkles as\nif it were made of gemstones. This raises the user's\nSp. Atk by one 25% of the time.",
    "shortDesc": "The user attacks with a ray of light that sparkles as\nif it were made of gemstones. This raises the user's\nSp. Atk by one 25% of the time.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 25,
        "self": {
          "boosts": {
            "spa": 1
          }
        }
      }
    ]
  },
  "drainpunch": {
    "num": 409,
    "accuracy": 100,
    "basePower": 75,
    "category": "Physical",
    "name": "Drain Punch",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "An energy-draining punch. The user’s HP is restored\nby half the damage taken by the target. Contact.",
    "shortDesc": "An energy-draining punch. The user’s HP is restored\nby half the damage taken by the target. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "drain": [
      1,
      2
    ],
    "zMove": {
      "basePower": 150
    }
  },
  "vacuumwave": {
    "num": 410,
    "accuracy": true,
    "basePower": 55,
    "category": "Special",
    "name": "Vacuum Wave",
    "pp": 15,
    "priority": 2,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user sends a wave of pure vacuum at the target.\nThis has +2 priority, and can't miss.",
    "shortDesc": "The user sends a wave of pure vacuum at the target.\nThis has +2 priority, and can't miss.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 110
    }
  },
  "focusblast": {
    "num": 411,
    "accuracy": 85,
    "basePower": 130,
    "category": "Special",
    "name": "Focus Blast",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user heightens its mental focus and unleashes\nmassive power. This lowers Sp. Def 30% of the time.",
    "shortDesc": "The user heightens its mental focus and unleashes\nmassive power. This lowers Sp. Def 30% of the time.",
    "flags": {
      "bullet": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 205
    },
    "secondaries": [
      {
        "chance": 30,
        "boosts": {
          "spd": -1
        }
      }
    ]
  },
  "energyball": {
    "num": 412,
    "accuracy": 100,
    "basePower": 95,
    "category": "Special",
    "name": "Energy Ball",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user draws power from nature and fires it at the\ntarget. This lowers Sp. Def 25% of the time.",
    "shortDesc": "The user draws power from nature and fires it at the\ntarget. This lowers Sp. Def 25% of the time.",
    "flags": {
      "bullet": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 25,
        "boosts": {
          "spd": -1
        }
      }
    ]
  },
  "bravebird": {
    "num": 413,
    "accuracy": 100,
    "basePower": 125,
    "category": "Physical",
    "name": "Brave Bird",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "The user tucks in its wings and charges from a low\naltitude. This deals 25% recoil, and has a 30%\nchance to drop the foe's Defense. Contact.",
    "shortDesc": "The user tucks in its wings and charges from a low\naltitude. This deals 25% recoil, and has a 30%\nchance to drop the foe's Defense. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      1,
      4
    ],
    "zMove": {
      "basePower": 195
    },
    "secondaries": [
      {
        "chance": 30,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "earthpower": {
    "num": 414,
    "accuracy": 100,
    "basePower": 90,
    "category": "Special",
    "name": "Earth Power",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "normal",
    "desc": "The user makes the ground under the target erupt\nwith power. This drops Sp. Def by one 20% of the time.",
    "shortDesc": "The user makes the ground under the target erupt\nwith power. This drops Sp. Def by one 20% of the time.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 20,
        "boosts": {
          "spd": -1
        }
      }
    ]
  },
  "switcheroo": {
    "num": 415,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Switcheroo",
    "pp": 1,
    "priority": 4,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user trades held items with the target faster\nthan the eye can follow. Z-Effect +3 Speed. +4 Priority.",
    "shortDesc": "The user trades held items with the target faster\nthan the eye can follow. Z-Effect +3 Speed. +4 Priority.",
    "flags": {
      "mirror": 1,
      "protect": 1
    }
  },
  "gigaimpact": {
    "num": 416,
    "accuracy": 100,
    "basePower": 160,
    "category": "Physical",
    "name": "Giga Impact",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user charges at the target using every bit of its\npower. This drops the user's Attack by 2. Contact.",
    "shortDesc": "The user charges at the target using every bit of its\npower. This drops the user's Attack by 2. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "atk": -2
      }
    },
    "zMove": {
      "basePower": 220
    }
  },
  "nastyplot": {
    "num": 417,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Nasty Plot",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "self",
    "desc": "The user stimulates its brain by thinking bad\nthoughts. This raises the user's Sp. Atk by 2.\nZ-Effect +2 crit rate.",
    "shortDesc": "The user stimulates its brain by thinking bad\nthoughts. This raises the user's Sp. Atk by 2.\nZ-Effect +2 crit rate.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "spa": 2
        }
      }
    ]
  },
  "bulletpunch": {
    "num": 418,
    "accuracy": true,
    "basePower": 50,
    "category": "Physical",
    "name": "Bullet Punch",
    "pp": 15,
    "priority": 1,
    "critRatio": 1,
    "type": "Steel",
    "target": "normal",
    "desc": "The user strikes the target with hard punches as\nfast as bullets. This has +1 priority, and can't miss.\nContact.",
    "shortDesc": "The user strikes the target with hard punches as\nfast as bullets. This has +1 priority, and can't miss.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "avalanche": {
    "num": 419,
    "accuracy": true,
    "basePower": 70,
    "category": "Physical",
    "name": "Avalanche",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ice",
    "target": "normal",
    "desc": "The user summons a devastating avalanche.\nThis now has NEUTRAL priority, can't miss, & doubles\nin power if you move last. 30% Flinch rate.",
    "shortDesc": "The user summons a devastating avalanche.\nThis now has NEUTRAL priority, can't miss, & doubles\nin power if you move last. 30% Flinch rate.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 200
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "iceshard": {
    "num": 420,
    "accuracy": true,
    "basePower": 45,
    "category": "Physical",
    "name": "Ice Shard",
    "pp": 20,
    "priority": 1,
    "critRatio": 1,
    "type": "Ice",
    "target": "normal",
    "desc": "The user flash-freezes chunks of ice and hurls them\nat the target. This has +1 priority and can't miss.",
    "shortDesc": "The user flash-freezes chunks of ice and hurls them\nat the target. This has +1 priority and can't miss.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 90
    }
  },
  "shadowclaw": {
    "num": 421,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Shadow Claw",
    "pp": 10,
    "priority": 0,
    "critRatio": 3,
    "type": "Ghost",
    "target": "normal",
    "desc": "The user slashes with shadowy claws or blades.\nThis has a 50% (+2) critical hit rate.\nContact.",
    "shortDesc": "The user slashes with shadowy claws or blades.\nThis has a 50% (+2) critical hit rate.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    }
  },
  "thunderfang": {
    "num": 422,
    "accuracy": 100,
    "basePower": 75,
    "category": "Physical",
    "name": "Thunder Fang",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "The user bites with electrified fangs. This has a 20%\nchance to flinch, and a 10% chance to paralyze.\nContact.",
    "shortDesc": "The user bites with electrified fangs. This has a 20%\nchance to flinch, and a 10% chance to paralyze.\nContact.",
    "flags": {
      "bite": 1,
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 150
    },
    "secondaries": [
      {
        "chance": 10,
        "status": "par"
      },
      {
        "chance": 25,
        "volatileStatus": "flinch"
      }
    ]
  },
  "icefang": {
    "num": 423,
    "accuracy": 100,
    "basePower": 75,
    "category": "Physical",
    "name": "Ice Fang",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Ice",
    "target": "normal",
    "desc": "The user bites with ice-infused fangs. This has a 20%\nchance to flinch, and a 10% chance to freeze.\nContact.",
    "shortDesc": "The user bites with ice-infused fangs. This has a 20%\nchance to flinch, and a 10% chance to freeze.\nContact.",
    "flags": {
      "bite": 1,
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 150
    },
    "secondaries": [
      {
        "chance": 10,
        "status": "frz"
      },
      {
        "chance": 25,
        "volatileStatus": "flinch"
      }
    ]
  },
  "firefang": {
    "num": 424,
    "accuracy": 100,
    "basePower": 75,
    "category": "Physical",
    "name": "Fire Fang",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The user bites with flame-cloaked fangs. This has a\n20% chance to flinch, and a 10% chance to burn.\nContact.",
    "shortDesc": "The user bites with flame-cloaked fangs. This has a\n20% chance to flinch, and a 10% chance to burn.\nContact.",
    "flags": {
      "bite": 1,
      "contact": 1,
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 150
    },
    "secondaries": [
      {
        "chance": 10,
        "status": "brn"
      },
      {
        "chance": 25,
        "volatileStatus": "flinch"
      }
    ]
  },
  "shadowsneak": {
    "num": 425,
    "accuracy": true,
    "basePower": 50,
    "category": "Physical",
    "name": "Shadow Sneak",
    "pp": 15,
    "priority": 1,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "The user sneaks behind the foe and strikes from the\nshadows. This has +1 priority.\nThis also can't miss, and ignores substitutes. Contact.",
    "shortDesc": "The user sneaks behind the foe and strikes from the\nshadows. This has +1 priority.\nThis also can't miss, and ignores substitutes. Contact.",
    "flags": {
      "bypasssub": 1,
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "mudbomb": {
    "num": 426,
    "accuracy": 90,
    "basePower": 110,
    "category": "Special",
    "name": "Mud Bomb",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "normal",
    "desc": "The user launches a mud ball that explodes on impact.\nThis drops the foe's Speed by one 100% of the time.",
    "shortDesc": "The user launches a mud ball that explodes on impact.\nThis drops the foe's Speed by one 100% of the time.",
    "flags": {
      "bullet": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 185
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -1
        }
      }
    ]
  },
  "psychocut": {
    "num": 427,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Psycho Cut",
    "pp": 10,
    "priority": 0,
    "critRatio": 3,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user tears at the target with blades formed by\npsychic power. This has a 50% (+2) crit rate.",
    "shortDesc": "The user tears at the target with blades formed by\npsychic power. This has a 50% (+2) crit rate.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    }
  },
  "zenheadbutt": {
    "num": 428,
    "accuracy": 100,
    "basePower": 100,
    "category": "Physical",
    "name": "Zen Headbutt",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user focuses its willpower to its head and\nattacks the target. This flinches the foe 25% the\ntime. Contact.",
    "shortDesc": "The user focuses its willpower to its head and\nattacks the target. This flinches the foe 25% the\ntime. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    },
    "secondaries": [
      {
        "chance": 25,
        "volatileStatus": "flinch"
      }
    ]
  },
  "mirrorshot": {
    "num": 429,
    "accuracy": 100,
    "basePower": 95,
    "category": "Special",
    "name": "Mirror Shot",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "normal",
    "desc": "The user lets loose a flash of energy at the target\nfrom its body. This boosts the user's Sp. Atk 25% of\nthe time.",
    "shortDesc": "The user lets loose a flash of energy at the target\nfrom its body. This boosts the user's Sp. Atk 25% of\nthe time.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 25,
        "self": {
          "boosts": {
            "spa": 1
          }
        }
      }
    ]
  },
  "flashcannon": {
    "num": 430,
    "accuracy": 100,
    "basePower": 125,
    "category": "Special",
    "name": "Flash Cannon",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "normal",
    "desc": "The user gathers all its light energy and releases it\nall at once. This drops Sp. Def 50% of the time.\nThis deals 25% recoil damage to user.",
    "shortDesc": "The user gathers all its light energy and releases it\nall at once. This drops Sp. Def 50% of the time.\nThis deals 25% recoil damage to user.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      1,
      4
    ],
    "zMove": {
      "basePower": 195
    },
    "secondaries": [
      {
        "chance": 50,
        "boosts": {
          "spd": -1
        }
      }
    ]
  },
  "rockclimb": {
    "num": 431,
    "accuracy": 100,
    "basePower": 110,
    "category": "Physical",
    "name": "Rock Climb",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Rock",
    "target": "normal",
    "desc": "The user attacks the target by smashing into it with\nincredible force. This deals 20% recoil to the user.\nThis also has a 30% chance to drop Defense. Contact.",
    "shortDesc": "The user attacks the target by smashing into it with\nincredible force. This deals 20% recoil to the user.\nThis also has a 30% chance to drop Defense. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      20,
      100
    ],
    "zMove": {
      "basePower": 185
    },
    "secondaries": [
      {
        "chance": 30,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "defog": {
    "num": 432,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Defog",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "A strong wind blows away the target’s barriers such\nas Reflect or Light Screen. This also lowers the\ntarget’s evasiveness. Z-Effect +2 crit rate.",
    "shortDesc": "A strong wind blows away the target’s barriers such\nas Reflect or Light Screen. This also lowers the\ntarget’s evasiveness. Z-Effect +2 crit rate.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "trickroom": {
    "num": 433,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Trick Room",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user creates a bizarre area in which slower\nPokemon get to move first for five turns.\nZ-Effect +2 Sp. Def. This now has NEUTRAL priority.",
    "shortDesc": "The user creates a bizarre area in which slower\nPokemon get to move first for five turns.\nZ-Effect +2 Sp. Def. This now has NEUTRAL priority.",
    "flags": {
      "mirror": 1
    }
  },
  "dracometeor": {
    "num": 434,
    "accuracy": 100,
    "basePower": 150,
    "category": "Special",
    "name": "Draco Meteor",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Dragon",
    "target": "normal",
    "desc": "Comets are summoned down from the sky onto the\ntarget. This drops the user's Sp. Atk by 2 after use.",
    "shortDesc": "Comets are summoned down from the sky onto the\ntarget. This drops the user's Sp. Atk by 2 after use.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "spa": -2
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "discharge": {
    "num": 435,
    "accuracy": 100,
    "basePower": 85,
    "category": "Special",
    "name": "Discharge",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "allAdjacent",
    "desc": "The user strikes everything around it by letting loose\na flare of electricity. This paralyzes the target 30%\nof the time.",
    "shortDesc": "The user strikes everything around it by letting loose\na flare of electricity. This paralyzes the target 30%\nof the time.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 170
    },
    "secondaries": [
      {
        "chance": 30,
        "status": "par"
      }
    ]
  },
  "pyroplume": {
    "num": 436,
    "accuracy": 100,
    "basePower": 85,
    "category": "Special",
    "name": "Pyro Plume",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "allAdjacent",
    "desc": "The user torches everything around it in an inferno\nof scarlet flames. This burns the foe 30% of the time.",
    "shortDesc": "The user torches everything around it in an inferno\nof scarlet flames. This burns the foe 30% of the time.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 170
    },
    "secondaries": [
      {
        "chance": 30,
        "status": "brn"
      }
    ]
  },
  "leafstorm": {
    "num": 437,
    "accuracy": 100,
    "basePower": 150,
    "category": "Special",
    "name": "Leaf Storm",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user whips up a storm of leaves around the\ntarget. This drops the user's Sp. Atk by 2 after use.",
    "shortDesc": "The user whips up a storm of leaves around the\ntarget. This drops the user's Sp. Atk by 2 after use.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "spa": -2
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "powerwhip": {
    "num": 438,
    "accuracy": 90,
    "basePower": 120,
    "category": "Physical",
    "name": "Power Whip",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user violently whirls its vines, tentacles, or the\nlike to harshly lash the target. This lowers the foe's\nDefense 30% of the time. Contact.",
    "shortDesc": "The user violently whirls its vines, tentacles, or the\nlike to harshly lash the target. This lowers the foe's\nDefense 30% of the time. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 190
    },
    "secondaries": [
      {
        "chance": 30,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "rockwrecker": {
    "num": 439,
    "accuracy": 100,
    "basePower": 150,
    "category": "Physical",
    "name": "Rock Wrecker",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Rock",
    "target": "normal",
    "desc": "The user hurls a massive boulder with full force.\nThis lowers the user's Attack by 2 after use.",
    "shortDesc": "The user hurls a massive boulder with full force.\nThis lowers the user's Attack by 2 after use.",
    "flags": {
      "bullet": 1,
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "atk": -2
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "crosspoison": {
    "num": 440,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Cross Poison",
    "pp": 10,
    "priority": 0,
    "critRatio": 3,
    "type": "Poison",
    "target": "normal",
    "desc": "A slashing attack with a poisonous blade that poisons\n20% of the time. This has a 50% (+2) crit rate.\nContact.",
    "shortDesc": "A slashing attack with a poisonous blade that poisons\n20% of the time. This has a 50% (+2) crit rate.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 20,
        "status": "psn"
      }
    ]
  },
  "gunkshot": {
    "num": 441,
    "accuracy": 90,
    "basePower": 120,
    "category": "Physical",
    "name": "Gunk Shot",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "The user shoots filthy, dense gunk at the target.\nThis has a 50% chance to poison the target.",
    "shortDesc": "The user shoots filthy, dense gunk at the target.\nThis has a 50% chance to poison the target.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 190
    },
    "secondaries": [
      {
        "chance": 50,
        "status": "psn"
      }
    ]
  },
  "ironhead": {
    "num": 442,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Iron Head",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "normal",
    "desc": "The user slams the target with its steel-hard head.\nThis flinches the target 30% of the time. Contact.",
    "shortDesc": "The user slams the target with its steel-hard head.\nThis flinches the target 30% of the time. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "magneticburst": {
    "num": 443,
    "accuracy": true,
    "basePower": 50,
    "category": "Special",
    "name": "Magnetic Burst",
    "pp": 10,
    "priority": 1,
    "critRatio": 1,
    "type": "Steel",
    "target": "normal",
    "desc": "The user rapidly releases a burst of magnetic bombs.\nThis has +1 priority, and can't miss.",
    "shortDesc": "The user rapidly releases a burst of magnetic bombs.\nThis has +1 priority, and can't miss.",
    "flags": {
      "bullet": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "stoneedge": {
    "num": 444,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Stone Edge",
    "pp": 3,
    "priority": 0,
    "critRatio": 7,
    "type": "Rock",
    "target": "normal",
    "desc": "The user stabs the target from below with jagged\nstones. This ALWAYS results in a critical hit.\nBypasses Protect.",
    "shortDesc": "The user stabs the target from below with jagged\nstones. This ALWAYS results in a critical hit.\nBypasses Protect.",
    "flags": {
      "mirror": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 190
    }
  },
  "captivate": {
    "num": 445,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Captivate",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "allAdjacentFoes",
    "desc": "If any opposing Pokemon is the opposite gender of\nthe user, it is charmed, which lowers it's Attack and\nSp. Atk by 2. Z-Effect +2 Sp. Def.",
    "shortDesc": "If any opposing Pokemon is the opposite gender of\nthe user, it is charmed, which lowers it's Attack and\nSp. Atk by 2. Z-Effect +2 Sp. Def.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1,
      "sound": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "spa": -2
        }
      },
      {
        "chance": 0,
        "boosts": {
          "atk": -2
        }
      }
    ]
  },
  "stealthrock": {
    "num": 446,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Stealth Rock",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Rock",
    "target": "normal",
    "desc": "Lays a trap of levitating stones around the opponent's\nside, damaging foes that switch in based on their\nweakness to Rock. Z-Effect +2 Defense.",
    "shortDesc": "Lays a trap of levitating stones around the opponent's\nside, damaging foes that switch in based on their\nweakness to Rock. Z-Effect +2 Defense.",
    "flags": {
      "reflectable": 1
    }
  },
  "grassknot": {
    "num": 447,
    "accuracy": 100,
    "basePower": 1,
    "category": "Physical",
    "name": "Grass Knot",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user snares the target with grass and trips it.\nThe heavier the target, the stronger this becomes.\nThis ALWAYS lowers the foe's Speed by 1. Contact.",
    "shortDesc": "The user snares the target with grass and trips it.\nThe heavier the target, the stronger this becomes.\nThis ALWAYS lowers the foe's Speed by 1. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -1
        }
      }
    ]
  },
  "commotion": {
    "num": 448,
    "accuracy": 100,
    "basePower": 85,
    "category": "Special",
    "name": "Commotion",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "allAdjacentFoes",
    "desc": "The user attacks the target with sound waves of\ndeafening chatter. This confuses the target for 4\nturns 100% of the time.",
    "shortDesc": "The user attacks the target with sound waves of\ndeafening chatter. This confuses the target for 4\nturns 100% of the time.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "punch": 1
    },
    "zMove": {
      "basePower": 170
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "tox"
      }
    ]
  },
  "ancientforce": {
    "num": 449,
    "accuracy": 100,
    "basePower": 100,
    "category": "Special",
    "name": "Ancient Force",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user taps into a chaotic, ancient force.\nThis changes type in accordance with a held Plate,\nand becomes 20% stronger with a Plate equipped.",
    "shortDesc": "The user taps into a chaotic, ancient force.\nThis changes type in accordance with a held Plate,\nand becomes 20% stronger with a Plate equipped.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    }
  },
  "bugbiting": {
    "num": 450,
    "accuracy": 100,
    "basePower": 35,
    "category": "Physical",
    "name": "Bug Biting",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Bug",
    "target": "normal",
    "desc": "The user bites the foe TWICE. If the foe is holding a\nBerry, the user eats it and gains its effect. Contact.\nThis has a 15% flinch rate per hit.",
    "shortDesc": "The user bites the foe TWICE. If the foe is holding a\nBerry, the user eats it and gains its effect. Contact.\nThis has a 15% flinch rate per hit.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": 2,
    "zMove": {
      "basePower": 140
    },
    "secondaries": [
      {
        "chance": 15,
        "volatileStatus": "flinch"
      }
    ]
  },
  "chargebeam": {
    "num": 451,
    "accuracy": 100,
    "basePower": 50,
    "category": "Special",
    "name": "Charge Beam",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "The user fires off a weak beam of electricity that\nboosts the user's Sp. Atk by 1 after each use.",
    "shortDesc": "The user fires off a weak beam of electricity that\nboosts the user's Sp. Atk by 1 after each use.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "spa": 1
          }
        }
      }
    ]
  },
  "woodhammer": {
    "num": 452,
    "accuracy": 100,
    "basePower": 125,
    "category": "Physical",
    "name": "Wood Hammer",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user powerfully slams the target with a tree.\nThis deals 25% recoil to the user, and drops\nDefense 30% of the time. Contact.",
    "shortDesc": "The user powerfully slams the target with a tree.\nThis deals 25% recoil to the user, and drops\nDefense 30% of the time. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      1,
      4
    ],
    "zMove": {
      "basePower": 195
    },
    "secondaries": [
      {
        "chance": 30,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "aquajet": {
    "num": 453,
    "accuracy": true,
    "basePower": 50,
    "category": "Physical",
    "name": "Aqua Jet",
    "pp": 15,
    "priority": 1,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "The user quickly surges at the target. This attack\nhas +1 priority, and can't miss. Contact.",
    "shortDesc": "The user quickly surges at the target. This attack\nhas +1 priority, and can't miss. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "attackorder": {
    "num": 454,
    "accuracy": true,
    "basePower": 90,
    "category": "Physical",
    "name": "Attack Order",
    "pp": 5,
    "priority": 0,
    "critRatio": 7,
    "type": "Bug",
    "target": "normal",
    "desc": "Vespiquen orders its underlings to assault the foe.\nThis ALWAYS results in a critical hit, and can't miss.",
    "shortDesc": "Vespiquen orders its underlings to assault the foe.\nThis ALWAYS results in a critical hit, and can't miss.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 195
    }
  },
  "defendorder": {
    "num": 455,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Defend Order",
    "pp": 2,
    "priority": 4,
    "critRatio": 1,
    "type": "Bug",
    "target": "self",
    "desc": "Vespiquen orders its underlings to shield its body.\nThis raises Vespiquen's Defense and Sp. Def by 1.\nThis has +4 Priority. Z-Effect +2 crit rate.",
    "shortDesc": "Vespiquen orders its underlings to shield its body.\nThis raises Vespiquen's Defense and Sp. Def by 1.\nThis has +4 Priority. Z-Effect +2 crit rate.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "def": 1
        }
      },
      {
        "chance": 0,
        "boosts": {
          "spd": 1
        }
      }
    ]
  },
  "healorder": {
    "num": 456,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Heal Order",
    "pp": 5,
    "priority": 4,
    "critRatio": 1,
    "type": "Bug",
    "target": "self",
    "desc": "Vespiquen orders its underlings to heal itself.\nThis heals Vespiquen by 50% of it's max HP.\nThis has +4 priority. Z-Effect heals user fully.",
    "shortDesc": "Vespiquen orders its underlings to heal itself.\nThis heals Vespiquen by 50% of it's max HP.\nThis has +4 priority. Z-Effect heals user fully.",
    "flags": {
      "heal": 1,
      "snatch": 1
    }
  },
  "headsmash": {
    "num": 457,
    "accuracy": 100,
    "basePower": 150,
    "category": "Physical",
    "name": "Head Smash",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Rock",
    "target": "normal",
    "desc": "The user attacks the target with a hazardous,\nfull-power headbutt. This has 50% recoil, and drops\nthe user's Defense and Sp. Def by 1. Contact.",
    "shortDesc": "The user attacks the target with a hazardous,\nfull-power headbutt. This has 50% recoil, and drops\nthe user's Defense and Sp. Def by 1. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      1,
      2
    ],
    "self": {
      "boosts": {
        "def": -1,
        "spd": -1
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "breakingswipe": {
    "num": 458,
    "accuracy": 100,
    "basePower": 70,
    "category": "Physical",
    "name": "Breaking Swipe",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Dragon",
    "target": "allAdjacentFoes",
    "desc": "The user widely swipes at the foes with great force.\nThis ALWAYS drops the foe's attacking stats by 1.\nContact.",
    "shortDesc": "The user widely swipes at the foes with great force.\nThis ALWAYS drops the foe's attacking stats by 1.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 140
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      }
    ]
  },
  "drakonicbeam": {
    "num": 459,
    "accuracy": 100,
    "basePower": 180,
    "category": "Special",
    "name": "Drakonic Beam",
    "pp": 3,
    "priority": 0,
    "critRatio": 1,
    "type": "Dragon",
    "target": "normal",
    "desc": "The user unleashes a destructive beam of dragon\nenergy at the foe. This lowers the user's Sp. Atk\nstat by 4 (-2/3) after use in exchange for high power.",
    "shortDesc": "The user unleashes a destructive beam of dragon\nenergy at the foe. This lowers the user's Sp. Atk\nstat by 4 (-2/3) after use in exchange for high power.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "spa": -4
      }
    },
    "zMove": {
      "basePower": 230
    }
  },
  "subspacetear": {
    "num": 460,
    "accuracy": 100,
    "basePower": 80,
    "category": "Special",
    "name": "Subspace Tear",
    "pp": 3,
    "priority": 0,
    "critRatio": 7,
    "type": "Psychic",
    "target": "normal",
    "desc": "Using psychic powers, the user tears the space\naround the foe. This ALWAYS results in a critical hit.\nBypasses Protect.",
    "shortDesc": "Using psychic powers, the user tears the space\naround the foe. This ALWAYS results in a critical hit.\nBypasses Protect.",
    "flags": {
      "mirror": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 190
    }
  },
  "lunardance": {
    "num": 461,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Lunar Dance",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "self",
    "desc": "The user absorbs energy from the moon and performs\na mystic dance. This boosts the user's Sp. Atk,\nSp. Def and Speed by 1. Z-Effect heals the user fully.",
    "shortDesc": "The user absorbs energy from the moon and performs\na mystic dance. This boosts the user's Sp. Atk,\nSp. Def and Speed by 1. Z-Effect heals the user fully.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spa": 1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spd": 1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spe": 1
        }
      }
    ]
  },
  "crushgrip": {
    "num": 462,
    "accuracy": 100,
    "basePower": 1,
    "category": "Physical",
    "name": "Crush Grip",
    "pp": 5,
    "priority": 0,
    "critRatio": 7,
    "type": "Ground",
    "target": "normal",
    "desc": "Regigias grips the foe with immense force. This ALWAYS\ncrits. Z-MOVE is 250 BP, AND gives +1 to all stats.\n120 BP without crit if target is full HP. Contact.",
    "shortDesc": "Regigias grips the foe with immense force. This ALWAYS\ncrits. Z-MOVE is 250 BP, AND gives +1 to all stats.\n120 BP without crit if target is full HP. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 250
    }
  },
  "firevortex": {
    "num": 463,
    "accuracy": 85,
    "basePower": 130,
    "category": "Special",
    "name": "Fire Vortex",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The target becomes trapped within a maelstrom of\nfire that traps foe for 12 turns, preventing switching\nand dealing 12% of the foe's max HP per turn.",
    "shortDesc": "The target becomes trapped within a maelstrom of\nfire that traps foe for 12 turns, preventing switching\nand dealing 12% of the foe's max HP per turn.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 200
    }
  },
  "darkvoid": {
    "num": 464,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Dark Void",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "allAdjacentFoes",
    "desc": "Darkai drags the foes into a world of darkness,\nputting them to sleep for three guaranteed turns.\nZ-Effect gives +3 Speed.",
    "shortDesc": "Darkai drags the foes into a world of darkness,\nputting them to sleep for three guaranteed turns.\nZ-Effect gives +3 Speed.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "seedflare": {
    "num": 465,
    "accuracy": 85,
    "basePower": 120,
    "category": "Special",
    "name": "Seed Flare",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user emits a destructive blast from within itself.\nThis has a 50% chance to drop the foe's Sp. Def by 2.",
    "shortDesc": "The user emits a destructive blast from within itself.\nThis has a 50% chance to drop the foe's Sp. Def by 2.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 195
    },
    "secondaries": [
      {
        "chance": 50,
        "boosts": {
          "spd": -2
        }
      }
    ]
  },
  "ominouswind": {
    "num": 466,
    "accuracy": 100,
    "basePower": 60,
    "category": "Special",
    "name": "Ominous Wind",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "allAdjacentFoes",
    "desc": "The user blasts the target with a gust of dismal wind.\nThis ALWAYS drops the foe's offensive stats by 1.",
    "shortDesc": "The user blasts the target with a gust of dismal wind.\nThis ALWAYS drops the foe's offensive stats by 1.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      }
    ]
  },
  "shadowforce": {
    "num": 467,
    "accuracy": true,
    "basePower": 120,
    "category": "Physical",
    "name": "Shadow Force",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "The user disappears, then strikes powerfully on the\nnext turn. This lowers the user's Defense stat by 2\nafter use. Ignores Protect & Substitute. Contact.",
    "shortDesc": "The user disappears, then strikes powerfully on the\nnext turn. This lowers the user's Defense stat by 2\nafter use. Ignores Protect & Substitute. Contact.",
    "flags": {
      "bypasssub": 1,
      "charge": 1,
      "mirror": 1
    },
    "self": {
      "boosts": {
        "def": -2
      }
    },
    "zMove": {
      "basePower": 190
    }
  },
  "honeclaws": {
    "num": 468,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Hone Claws",
    "pp": 3,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "self",
    "desc": "The user sharpens its claws to boost its Attack stat\nby 1, and Accuracy by 2. Z-Effect +2 crit rate.",
    "shortDesc": "The user sharpens its claws to boost its Attack stat\nby 1, and Accuracy by 2. Z-Effect +2 crit rate.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "atk": 1
        }
      },
      {
        "chance": 0,
        "boosts": {
          "accuracy": 2
        }
      }
    ]
  },
  "wideguard": {
    "num": 469,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Wide Guard",
    "pp": 20,
    "priority": 6,
    "critRatio": 1,
    "type": "Rock",
    "target": "normal",
    "desc": "The user protects its side of the field from spread\nmoves & Z-Moves, even in single battles. This can be\nused in succession without fail. Z-Effect +3 Defense.",
    "shortDesc": "The user protects its side of the field from spread\nmoves & Z-Moves, even in single battles. This can be\nused in succession without fail. Z-Effect +3 Defense.",
    "flags": {
      "snatch": 1
    }
  },
  "guardsplit": {
    "num": 470,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Guard Split",
    "pp": 10,
    "priority": 4,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user employs its psychic power to average its\nDefense and Sp. Def stats with those of the target.\nZ-Effect +2 Sp. Atk. +4 Priority.",
    "shortDesc": "The user employs its psychic power to average its\nDefense and Sp. Def stats with those of the target.\nZ-Effect +2 Sp. Atk. +4 Priority.",
    "flags": {
      "protect": 1
    }
  },
  "powersplit": {
    "num": 471,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Power Split",
    "pp": 10,
    "priority": 4,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user employs its psychic power to average its\nAttack and Sp. Atk stats with those of the target.\nZ-Effect +2 Sp. Atk. +4 Priority.",
    "shortDesc": "The user employs its psychic power to average its\nAttack and Sp. Atk stats with those of the target.\nZ-Effect +2 Sp. Atk. +4 Priority.",
    "flags": {
      "protect": 1
    }
  },
  "wonderroom": {
    "num": 472,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Wonder Room",
    "pp": 10,
    "priority": 6,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user creates a bizarre area in which Pokemon’s\nDefense and Sp. Def stats are swapped for\nfive turns. Z-Effect +2 Sp. Atk. +6 Priority.",
    "shortDesc": "The user creates a bizarre area in which Pokemon’s\nDefense and Sp. Def stats are swapped for\nfive turns. Z-Effect +2 Sp. Atk. +6 Priority.",
    "flags": {
      "mirror": 1
    }
  },
  "psyshock": {
    "num": 473,
    "accuracy": 100,
    "basePower": 95,
    "category": "Special",
    "name": "Psyshock",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user materializes an odd psychic blast to attack.\nThis move deals Physical damage to the target.",
    "shortDesc": "The user materializes an odd psychic blast to attack.\nThis move deals Physical damage to the target.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    }
  },
  "venoshock": {
    "num": 474,
    "accuracy": 100,
    "basePower": 70,
    "category": "Special",
    "name": "Venoshock",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "The user drenches the target in a special poisonous\nliquid. This move's power is doubled if the target\nis poisoned.",
    "shortDesc": "The user drenches the target in a special poisonous\nliquid. This move's power is doubled if the target\nis poisoned.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 140
    }
  },
  "autotomize": {
    "num": 475,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Autotomize",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "self",
    "desc": "The user sheds part of its body to make itself lighter\nand maximize its Speed stat to +5. In exchange, the\nuser's defense stats drop by 1. Z-Effect +2 crit rate.",
    "shortDesc": "The user sheds part of its body to make itself lighter\nand maximize its Speed stat to +5. In exchange, the\nuser's defense stats drop by 1. Z-Effect +2 crit rate.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "spe": 5
        }
      },
      {
        "chance": 0,
        "boosts": {
          "def": -1
        }
      },
      {
        "chance": 0,
        "boosts": {
          "spd": -1
        }
      }
    ]
  },
  "ragepowder": {
    "num": 476,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Rage Powder",
    "pp": 5,
    "priority": 2,
    "critRatio": 1,
    "type": "Bug",
    "target": "self",
    "desc": "The user scatters a cloud of irritating powder to\ndraw attention to itself. Opponents aim only at\nthe user.",
    "shortDesc": "The user scatters a cloud of irritating powder to\ndraw attention to itself. Opponents aim only at\nthe user.",
    "flags": {}
  },
  "telekinesis": {
    "num": 477,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Telekinesis",
    "pp": 15,
    "priority": 4,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user makes the target float with telekinesis.\nIn addition to levitating, no attacks will miss the\nfoe for 15 turns. +4 Priority. Z-Effect +2 Sp. Atk.",
    "shortDesc": "The user makes the target float with telekinesis.\nIn addition to levitating, no attacks will miss the\nfoe for 15 turns. +4 Priority. Z-Effect +2 Sp. Atk.",
    "flags": {
      "gravity": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "magicroom": {
    "num": 478,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Magic Room",
    "pp": 10,
    "priority": 6,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user creates a bizarre area in which Pokemon’s\nheld items lose their effects for five turns.\nZ-Effect +2 Sp. Atk. +6 Priority.",
    "shortDesc": "The user creates a bizarre area in which Pokemon’s\nheld items lose their effects for five turns.\nZ-Effect +2 Sp. Atk. +6 Priority.",
    "flags": {
      "mirror": 1
    }
  },
  "smackdown": {
    "num": 479,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Smack Down",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Rock",
    "target": "normal",
    "desc": "The user throws a stone or similar projectile to\nattack an opponent. A flying Pokemon will fall to the\nground when it’s hit. 30% flinch rate.",
    "shortDesc": "The user throws a stone or similar projectile to\nattack an opponent. A flying Pokemon will fall to the\nground when it’s hit. 30% flinch rate.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "25"
      },
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "stormthrow": {
    "num": 480,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Storm Throw",
    "pp": 3,
    "priority": 0,
    "critRatio": 7,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user throws the target violently.\nThis ALWAYS results in a critical hit.\nBypasses Protect. Contact.",
    "shortDesc": "The user throws the target violently.\nThis ALWAYS results in a critical hit.\nBypasses Protect. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 190
    }
  },
  "flameburst": {
    "num": 481,
    "accuracy": 100,
    "basePower": 25,
    "category": "Special",
    "name": "Flame Burst",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The user attacks the target with a bursting flame.\nThis hits 3 times, and damages Pokemon next to the\ntarget for 6% of their HP per hit for a total of 18%.",
    "shortDesc": "The user attacks the target with a bursting flame.\nThis hits 3 times, and damages Pokemon next to the\ntarget for 6% of their HP per hit for a total of 18%.",
    "flags": {
      "defrost": 1,
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": 3,
    "zMove": {
      "basePower": 140
    }
  },
  "sludgewave": {
    "num": 482,
    "accuracy": 90,
    "basePower": 110,
    "category": "Special",
    "name": "Sludge Wave",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "allAdjacentFoes",
    "desc": "The user swamps the foes with a wave of filthy sludge.\nThis ALWAYS lowers the Speed of the foes by 1.",
    "shortDesc": "The user swamps the foes with a wave of filthy sludge.\nThis ALWAYS lowers the Speed of the foes by 1.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 185
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -1
        }
      }
    ]
  },
  "quiverdance": {
    "num": 483,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Quiver Dance",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Bug",
    "target": "self",
    "desc": "The user lightly performs a beautiful, mystic dance.\nThis boosts the user’s Sp. Atk and Speed by 1.\nZ-Effect +2 Sp. Def.",
    "shortDesc": "The user lightly performs a beautiful, mystic dance.\nThis boosts the user’s Sp. Atk and Speed by 1.\nZ-Effect +2 Sp. Def.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "spa": 1
        }
      },
      {
        "chance": 0,
        "boosts": {
          "spe": 1
        }
      }
    ]
  },
  "heavyslam": {
    "num": 484,
    "accuracy": 100,
    "basePower": 1,
    "category": "Physical",
    "name": "Heavy Slam",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "normal",
    "desc": "The user slams into the target with its heavy body.\nThe heavier the user is, the stronger this becomes.\nThis grounds a flying or levitating opponent. Contact.",
    "shortDesc": "The user slams into the target with its heavy body.\nThe heavier the user is, the stronger this becomes.\nThis grounds a flying or levitating opponent. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 170
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "25"
      }
    ]
  },
  "synchronoise": {
    "num": 485,
    "accuracy": 100,
    "basePower": 120,
    "category": "Special",
    "name": "Synchronoise",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "allAdjacent",
    "desc": "Using an odd sound wave, the user inflicts massive\ndamage on any Pokemon that share a type with the\nuser. This ALWAYS boosts the user's Sp. Atk by 1.",
    "shortDesc": "Using an odd sound wave, the user inflicts massive\ndamage on any Pokemon that share a type with the\nuser. This ALWAYS boosts the user's Sp. Atk by 1.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "punch": 1
    },
    "zMove": {
      "basePower": 190
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "spa": 1
          }
        }
      }
    ]
  },
  "electroball": {
    "num": 486,
    "accuracy": 100,
    "basePower": 1,
    "category": "Special",
    "name": "Electro Ball",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "The user hurls an electric orb at the target. The\nfaster the user is than the foe, the higher the power.\nThis ALWAYS boosts the user's Speed by 1 after use.",
    "shortDesc": "The user hurls an electric orb at the target. The\nfaster the user is than the foe, the higher the power.\nThis ALWAYS boosts the user's Speed by 1 after use.",
    "flags": {
      "bullet": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "spe": 1
          }
        }
      }
    ]
  },
  "soak": {
    "num": 487,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Soak",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "The user douses the target in water.\nThis changes their typing to pure Water.\nZ-Effect +2 Sp. Atk.",
    "shortDesc": "The user douses the target in water.\nThis changes their typing to pure Water.\nZ-Effect +2 Sp. Atk.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "pyrodash": {
    "num": 488,
    "accuracy": true,
    "basePower": 50,
    "category": "Physical",
    "name": "Pyro Dash",
    "pp": 15,
    "priority": 1,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The user quickly dashes at the target cloaked in fire.\nThis has +1 priority, and can't miss. Contact.",
    "shortDesc": "The user quickly dashes at the target cloaked in fire.\nThis has +1 priority, and can't miss. Contact.",
    "flags": {
      "contact": 1,
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "coil": {
    "num": 489,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Coil",
    "pp": 3,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "self",
    "desc": "The user coils up it's long body. This boosts\nthe user's Attack, Defense and Accuracy by 1.\nZ-Effect +2 crit rate.",
    "shortDesc": "The user coils up it's long body. This boosts\nthe user's Attack, Defense and Accuracy by 1.\nZ-Effect +2 crit rate.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "atk": 1
        }
      },
      {
        "chance": 0,
        "boosts": {
          "def": 1
        }
      },
      {
        "chance": 0,
        "boosts": {
          "accuracy": 1
        }
      }
    ]
  },
  "lowsweep": {
    "num": 490,
    "accuracy": 100,
    "basePower": 75,
    "category": "Physical",
    "name": "Low Sweep",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user makes a swift attack on the target’s legs.\nThis has a 30% flinch rate. Contact.",
    "shortDesc": "The user makes a swift attack on the target’s legs.\nThis has a 30% flinch rate. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 150
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "sludgeshot": {
    "num": 491,
    "accuracy": true,
    "basePower": 45,
    "category": "Special",
    "name": "Sludge Shot",
    "pp": 20,
    "priority": 1,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "The user shoots sludge at astonishing speed.\nThis has +1 priority, and can't miss.",
    "shortDesc": "The user shoots sludge at astonishing speed.\nThis has +1 priority, and can't miss.",
    "flags": {
      "bullet": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 90
    }
  },
  "foulplay": {
    "num": 492,
    "accuracy": 100,
    "basePower": 95,
    "category": "Physical",
    "name": "Foul Play",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "This devious attack uses the target's Attack stat\ninstead of the user's when dealing damage. Contact.",
    "shortDesc": "This devious attack uses the target's Attack stat\ninstead of the user's when dealing damage. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    }
  },
  "simplebeam": {
    "num": 493,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Simple Beam",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user’s mysterious psychic wave changes the\ntarget’s Ability to Simple. Z-Effect +2 Sp. Atk.",
    "shortDesc": "The user’s mysterious psychic wave changes the\ntarget’s Ability to Simple. Z-Effect +2 Sp. Atk.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "entrainment": {
    "num": 494,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Entrainment",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user influences the target to copy it's ability.\nZ-Effect +2 Atk.",
    "shortDesc": "The user influences the target to copy it's ability.\nZ-Effect +2 Atk.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "afteryou": {
    "num": 495,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "After You",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "Makes an ally move right after the user.\nThis can be useful to let a slower ally move first.",
    "shortDesc": "Makes an ally move right after the user.\nThis can be useful to let a slower ally move first.",
    "flags": {
      "bypasssub": 1
    }
  },
  "harmonize": {
    "num": 496,
    "accuracy": 100,
    "basePower": 60,
    "category": "Special",
    "name": "Harmonize",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "allAdjacentFoes",
    "desc": "The user attacks the target with it's voice. Others can\nharmonize to increase the power of the voice.\nThis ALWAYS drops the foe's attacking stats by 1.",
    "shortDesc": "The user attacks the target with it's voice. Others can\nharmonize to increase the power of the voice.\nThis ALWAYS drops the foe's attacking stats by 1.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "punch": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      }
    ]
  },
  "echoedvoice": {
    "num": 497,
    "accuracy": 95,
    "basePower": 30,
    "category": "Special",
    "name": "Echoed Voice",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "allAdjacentFoes",
    "desc": "The user attacks the target with an echoing voice.\nIf this move is used every turn, its power\nis boosted by 40 each time, for a maximum of 200.",
    "shortDesc": "The user attacks the target with an echoing voice.\nIf this move is used every turn, its power\nis boosted by 40 each time, for a maximum of 200.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "punch": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "skittersmack": {
    "num": 498,
    "accuracy": true,
    "basePower": 70,
    "category": "Physical",
    "name": "Skitter Smack",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Bug",
    "target": "normal",
    "desc": "The user creeps up on the foe, striking them quickly.\nThis ALWAYS drops the foe's attacking stats by 1.\nThis also ignores any defense boosts. Contact.",
    "shortDesc": "The user creeps up on the foe, striking them quickly.\nThis ALWAYS drops the foe's attacking stats by 1.\nThis also ignores any defense boosts. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 140
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      }
    ]
  },
  "clearsmog": {
    "num": 499,
    "accuracy": true,
    "basePower": 55,
    "category": "Special",
    "name": "Clear Smog",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "allAdjacentFoes",
    "desc": "The user emits an odd gas, damaging the foes and\nresetting all stat changes to zero.",
    "shortDesc": "The user emits an odd gas, damaging the foes and\nresetting all stat changes to zero.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 110
    }
  },
  "storedpower": {
    "num": 500,
    "accuracy": 100,
    "basePower": 20,
    "category": "Special",
    "name": "Stored Power",
    "pp": 3,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user releases it's stored up power all at once.\nThis move gains 20 Base Power for every stat boost,\nand ALWAYS boosts the user's Sp. Atk by 1 after use.",
    "shortDesc": "The user releases it's stored up power all at once.\nThis move gains 20 Base Power for every stat boost,\nand ALWAYS boosts the user's Sp. Atk by 1 after use.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "spa": 1
          }
        }
      }
    ]
  },
  "quickguard": {
    "num": 501,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Quick Guard",
    "pp": 30,
    "priority": 6,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user protects its side of the field from all\ntargeted priority moves. This can be used repeatedly\nwithout risk of failing. Z-Effect +3 Defense.",
    "shortDesc": "The user protects its side of the field from all\ntargeted priority moves. This can be used repeatedly\nwithout risk of failing. Z-Effect +3 Defense.",
    "flags": {
      "snatch": 1
    }
  },
  "allyswitch": {
    "num": 502,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Ally Switch",
    "pp": 15,
    "priority": 6,
    "critRatio": 1,
    "type": "Psychic",
    "target": "self",
    "desc": "The user switches places with an ally.\nThis has +6 priority. Z-Effect +3 Speed.",
    "shortDesc": "The user switches places with an ally.\nThis has +6 priority. Z-Effect +3 Speed.",
    "flags": {}
  },
  "scald": {
    "num": 503,
    "accuracy": 100,
    "basePower": 60,
    "category": "Special",
    "name": "Scald",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "The user shoots boiling hot water at its target.\nThis ALWAYS burns the target.",
    "shortDesc": "The user shoots boiling hot water at its target.\nThis ALWAYS burns the target.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "brn"
      }
    ]
  },
  "shellsmash": {
    "num": 504,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Shell Smash",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user breaks its shell, which lowers Defense and\nSp. Def stats by 1, but raises Sp. Atk, Attack, and\nSpeed by 2. Z-Effect +1 Speed.",
    "shortDesc": "The user breaks its shell, which lowers Defense and\nSp. Def stats by 1, but raises Sp. Atk, Attack, and\nSpeed by 2. Z-Effect +1 Speed.",
    "flags": {
      "dance": 1,
      "snatch": 1
    }
  },
  "healpulse": {
    "num": 505,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Heal Pulse",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user emits a healing pulse that restores the\ntarget’s HP by 2/3 of its max HP.\nZ-Effect heals user fully.",
    "shortDesc": "The user emits a healing pulse that restores the\ntarget’s HP by 2/3 of its max HP.\nZ-Effect heals user fully.",
    "flags": {
      "protect": 1,
      "pulse": 1,
      "reflectable": 1
    }
  },
  "hex": {
    "num": 506,
    "accuracy": 100,
    "basePower": 70,
    "category": "Special",
    "name": "Hex",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "This sinister attack does double damage to a foe\nwith a status affliction.",
    "shortDesc": "This sinister attack does double damage to a foe\nwith a status affliction.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 140
    }
  },
  "skydrop": {
    "num": 507,
    "accuracy": true,
    "basePower": 95,
    "category": "Physical",
    "name": "Sky Drop",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "The user takes the target into the sky, then drops it\nnext turn. The foe can't attack while in the sky.\nFails if too heavy. Can't miss. Contact. 30% Flinch.",
    "shortDesc": "The user takes the target into the sky, then drops it\nnext turn. The foe can't attack while in the sky.\nFails if too heavy. Can't miss. Contact. 30% Flinch.",
    "flags": {
      "charge": 1,
      "contact": 1,
      "gravity": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "shiftgear": {
    "num": 508,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Shift Gear",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "self",
    "desc": "The user rotates its gears, raising its Attack and\nSp. Atk by 1, and raising it's Speed by 2.\nZ-Effect +2 crit rate.",
    "shortDesc": "The user rotates its gears, raising its Attack and\nSp. Atk by 1, and raising it's Speed by 2.\nZ-Effect +2 crit rate.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "spe": 2
        }
      },
      {
        "chance": 0,
        "boosts": {
          "atk": 1
        }
      },
      {
        "chance": 0,
        "boosts": {
          "spa": 1
        }
      }
    ]
  },
  "circlethrow": {
    "num": 509,
    "accuracy": true,
    "basePower": 95,
    "category": "Physical",
    "name": "Circle Throw",
    "pp": 15,
    "priority": -4,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The target is thrown, and a different Pokemon is\ndragged out. This attack always goes last, and can't\nmiss. Contact.",
    "shortDesc": "The target is thrown, and a different Pokemon is\ndragged out. This attack always goes last, and can't\nmiss. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    }
  },
  "burningmalice": {
    "num": 510,
    "accuracy": 100,
    "basePower": 85,
    "category": "Special",
    "name": "Burning Malice",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "allAdjacentFoes",
    "desc": "The user's bitterness flares up, engulfing the target\nin flames fueled by pure malice. This consumes\nany berries or gems the foe holds.",
    "shortDesc": "The user's bitterness flares up, engulfing the target\nin flames fueled by pure malice. This consumes\nany berries or gems the foe holds.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    }
  },
  "quash": {
    "num": 511,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Quash",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "Doesn't exist.",
    "shortDesc": "Doesn't exist.",
    "flags": {
      "mirror": 1,
      "protect": 1
    }
  },
  "acrobatics": {
    "num": 512,
    "accuracy": 100,
    "basePower": 55,
    "category": "Physical",
    "name": "Acrobatics",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "The user nimbly strikes the target. If the user is not\nholding an item, this attack inflicts double damage.\nContact.",
    "shortDesc": "The user nimbly strikes the target. If the user is not\nholding an item, this attack inflicts double damage.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 110
    }
  },
  "reflecttype": {
    "num": 513,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Reflect Type",
    "pp": 15,
    "priority": 4,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user reflects the target’s type, making it the\nsame type as the target.\nThis has +4 priority. Z-Effect +1 all stats.",
    "shortDesc": "The user reflects the target’s type, making it the\nsame type as the target.\nThis has +4 priority. Z-Effect +1 all stats.",
    "flags": {
      "bypasssub": 1,
      "protect": 1
    }
  },
  "retaliate": {
    "num": 514,
    "accuracy": 100,
    "basePower": 95,
    "category": "Physical",
    "name": "Retaliate",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user gets revenge for a fainted ally. If an ally\nfainted in the previous turn, this move’s power\nis doubled to insane levels. Contact.",
    "shortDesc": "The user gets revenge for a fainted ally. If an ally\nfainted in the previous turn, this move’s power\nis doubled to insane levels. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    }
  },
  "finalgambit": {
    "num": 515,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Final Gambit",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user risks it all to attack the target. This user\nfaints, and deals damage equal to it's current HP.",
    "shortDesc": "The user risks it all to attack the target. This user\nfaints, and deals damage equal to it's current HP.",
    "flags": {},
    "zMove": {
      "basePower": 255
    }
  },
  "bestow": {
    "num": 516,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Bestow",
    "pp": 15,
    "priority": 4,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user passes its held item to the target when the\ntarget isn’t holding an item. Z-Effect +2 Attack.",
    "shortDesc": "The user passes its held item to the target when the\ntarget isn’t holding an item. Z-Effect +2 Attack.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1
    }
  },
  "inferno": {
    "num": 517,
    "accuracy": 80,
    "basePower": 130,
    "category": "Special",
    "name": "Inferno",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The user attacks by engulfing the target in an\ncatastrophic inferno of flames. This always leaves\nthe target with a burn.",
    "shortDesc": "The user attacks by engulfing the target in an\ncatastrophic inferno of flames. This always leaves\nthe target with a burn.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 205
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "brn"
      }
    ]
  },
  "waterpledge": {
    "num": 518,
    "accuracy": 100,
    "basePower": 80,
    "category": "Special",
    "name": "Water Pledge",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "A column of water strikes the target. When combined\nwith its fire equivalent, its power increases and a\nrainbow appears. 25% chance to boost Sp. Atk by one.",
    "shortDesc": "A column of water strikes the target. When combined\nwith its fire equivalent, its power increases and a\nrainbow appears. 25% chance to boost Sp. Atk by one.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 25,
        "self": {
          "boosts": {
            "spa": 1
          }
        }
      }
    ]
  },
  "firepledge": {
    "num": 519,
    "accuracy": 100,
    "basePower": 80,
    "category": "Special",
    "name": "Fire Pledge",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "A column of fire hits the target. When used with its\ngrass equivalent, its power increases and a vast sea\nof fire appears. 25% chance to boost Sp. Atk by one.",
    "shortDesc": "A column of fire hits the target. When used with its\ngrass equivalent, its power increases and a vast sea\nof fire appears. 25% chance to boost Sp. Atk by one.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 25,
        "self": {
          "boosts": {
            "spa": 1
          }
        }
      }
    ]
  },
  "grasspledge": {
    "num": 520,
    "accuracy": 100,
    "basePower": 80,
    "category": "Special",
    "name": "Grass Pledge",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "A column of grass hits the target. When used with\nits water equivalent, its power increases and a vast\nswamp appears. 25% chance to boost Sp. Atk by one.",
    "shortDesc": "A column of grass hits the target. When used with\nits water equivalent, its power increases and a vast\nswamp appears. 25% chance to boost Sp. Atk by one.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 25,
        "self": {
          "boosts": {
            "spa": 1
          }
        }
      }
    ]
  },
  "voltswitch": {
    "num": 521,
    "accuracy": true,
    "basePower": 75,
    "category": "Special",
    "name": "Volt Switch",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "After making its attack, the user rushes back to\nswitch places with a party Pokemon in waiting.\nThis attack can't miss.",
    "shortDesc": "After making its attack, the user rushes back to\nswitch places with a party Pokemon in waiting.\nThis attack can't miss.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 150
    }
  },
  "strugglebug": {
    "num": 522,
    "accuracy": 100,
    "basePower": 60,
    "category": "Special",
    "name": "Struggle Bug",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Bug",
    "target": "allAdjacentFoes",
    "desc": "The user struggles, lashing out at all opponents.\nThis ALWAYS drops the foe's attacking stats by 1.",
    "shortDesc": "The user struggles, lashing out at all opponents.\nThis ALWAYS drops the foe's attacking stats by 1.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      }
    ]
  },
  "bulldoze": {
    "num": 523,
    "accuracy": 100,
    "basePower": 60,
    "category": "Physical",
    "name": "Bulldoze",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "allAdjacent",
    "desc": "The user strikes everything around it with a small\nearthquake. This lowers the Speed stat of\nthose hit by 1.",
    "shortDesc": "The user strikes everything around it with a small\nearthquake. This lowers the Speed stat of\nthose hit by 1.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -1
        }
      }
    ]
  },
  "frostbreath": {
    "num": 524,
    "accuracy": 100,
    "basePower": 65,
    "category": "Special",
    "name": "Frost Breath",
    "pp": 5,
    "priority": 0,
    "critRatio": 7,
    "type": "Ice",
    "target": "normal",
    "desc": "The user blows its freezing breath on the target.\nThis attack always results in a critical hit.",
    "shortDesc": "The user blows its freezing breath on the target.\nThis attack always results in a critical hit.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 175
    }
  },
  "dragontail": {
    "num": 525,
    "accuracy": true,
    "basePower": 95,
    "category": "Physical",
    "name": "Dragon Tail",
    "pp": 15,
    "priority": -4,
    "critRatio": 1,
    "type": "Dragon",
    "target": "normal",
    "desc": "The user slams the target with its tail, and a\ndifferent Pokemon is dragged out. This attack always\ngoes last, and can't miss. Contact.",
    "shortDesc": "The user slams the target with its tail, and a\ndifferent Pokemon is dragged out. This attack always\ngoes last, and can't miss. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    }
  },
  "workup": {
    "num": 526,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Work Up",
    "pp": 3,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user is roused, and its Attack and Sp. Atk\nstats increase by 1. Z-Effect +1 Speed.",
    "shortDesc": "The user is roused, and its Attack and Sp. Atk\nstats increase by 1. Z-Effect +1 Speed.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "atk": 1
        }
      },
      {
        "chance": 0,
        "boosts": {
          "spa": 1
        }
      }
    ]
  },
  "electroweb": {
    "num": 527,
    "accuracy": 100,
    "basePower": 60,
    "category": "Special",
    "name": "Electroweb",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "allAdjacentFoes",
    "desc": "The user attacks and captures opposing Pokemon\nusing an electric net. This lowers their\nSpeed stat by 1.",
    "shortDesc": "The user attacks and captures opposing Pokemon\nusing an electric net. This lowers their\nSpeed stat by 1.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -1
        }
      }
    ]
  },
  "wildcharge": {
    "num": 528,
    "accuracy": 100,
    "basePower": 110,
    "category": "Physical",
    "name": "Wild Charge",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "The user shrouds itself in electricity and smashes\ninto its target. This has 20% recoil, and a 20%\nchance to paralyze the target. Contact.",
    "shortDesc": "The user shrouds itself in electricity and smashes\ninto its target. This has 20% recoil, and a 20%\nchance to paralyze the target. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      20,
      100
    ],
    "zMove": {
      "basePower": 185
    },
    "secondaries": [
      {
        "chance": 20,
        "status": "par"
      }
    ]
  },
  "drillrun": {
    "num": 529,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Drill Run",
    "pp": 10,
    "priority": 0,
    "critRatio": 3,
    "type": "Ground",
    "target": "normal",
    "desc": "The user crashes into its target while rotating its\nbody or body parts like a drill.  This has a 50% (+2)\ncrit rate. Contact.",
    "shortDesc": "The user crashes into its target while rotating its\nbody or body parts like a drill.  This has a 50% (+2)\ncrit rate. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    }
  },
  "dracojet": {
    "num": 530,
    "accuracy": true,
    "basePower": 50,
    "category": "Physical",
    "name": "Draco Jet",
    "pp": 15,
    "priority": 1,
    "critRatio": 1,
    "type": "Dragon",
    "target": "normal",
    "desc": "The user strikes the target with immense speed.\nThis has +1 priority, and can't miss. Contact.",
    "shortDesc": "The user strikes the target with immense speed.\nThis has +1 priority, and can't miss. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "hoodwink": {
    "num": 531,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Hoodwink",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user unleashes a vicious blow after its cute act\nmakes the target less wary. This flinches the target\n30% of the time. Contact.",
    "shortDesc": "The user unleashes a vicious blow after its cute act\nmakes the target less wary. This flinches the target\n30% of the time. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1,
      "sound": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "branchleech": {
    "num": 532,
    "accuracy": 100,
    "basePower": 90,
    "category": "Physical",
    "name": "Branch Leech",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user drains the foe's energy with branch-like\nappendages. The user’s HP is restored by 50% of\ndamage dealt. Contact.",
    "shortDesc": "The user drains the foe's energy with branch-like\nappendages. The user’s HP is restored by 50% of\ndamage dealt. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "drain": [
      1,
      2
    ],
    "zMove": {
      "basePower": 175
    }
  },
  "sacredsword": {
    "num": 533,
    "accuracy": true,
    "basePower": 65,
    "category": "Physical",
    "name": "Sacred Sword",
    "pp": 5,
    "priority": 0,
    "critRatio": 7,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user attacks by slicing with a long horn or blade.\nThis ignores all stat boosts the target may have.\nThis ALWAYS lands a critical hit. Contact.",
    "shortDesc": "The user attacks by slicing with a long horn or blade.\nThis ignores all stat boosts the target may have.\nThis ALWAYS lands a critical hit. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 175
    }
  },
  "razorshell": {
    "num": 534,
    "accuracy": 100,
    "basePower": 80,
    "category": "Physical",
    "name": "Razor Shell",
    "pp": 10,
    "priority": 0,
    "critRatio": 3,
    "type": "Water",
    "target": "normal",
    "desc": "The user cuts its target with it's hard shell. This\nhas a 50% (+2) crit rate. Contact.",
    "shortDesc": "The user cuts its target with it's hard shell. This\nhas a 50% (+2) crit rate. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    }
  },
  "heatcrash": {
    "num": 535,
    "accuracy": 100,
    "basePower": 1,
    "category": "Physical",
    "name": "Heat Crash",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The user slams its target with its flame-covered\nbody. The more the user outweighs the target, the\nstronger this is. This has a 30% burn rate. Contact.",
    "shortDesc": "The user slams its target with its flame-covered\nbody. The more the user outweighs the target, the\nstronger this is. This has a 30% burn rate. Contact.",
    "flags": {
      "contact": 1,
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 170
    },
    "secondaries": [
      {
        "chance": 30,
        "status": "brn"
      }
    ]
  },
  "leafflurry": {
    "num": 536,
    "accuracy": 100,
    "basePower": 45,
    "category": "Special",
    "name": "Leaf Flurry",
    "pp": 20,
    "priority": 1,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user whips up a rapid flurry of leaves at the foe.\nThis has +1 priority, and can't miss.",
    "shortDesc": "The user whips up a rapid flurry of leaves at the foe.\nThis has +1 priority, and can't miss.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 90
    }
  },
  "steamroller": {
    "num": 537,
    "accuracy": 100,
    "basePower": 130,
    "category": "Physical",
    "name": "Steamroller",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Bug",
    "target": "normal",
    "desc": "The user crushes its target by rolling over the target\nwith its rolled-up body. This flinches 30% of the\ntime and boosts Speed by TWO 100% of the time.",
    "shortDesc": "The user crushes its target by rolling over the target\nwith its rolled-up body. This flinches 30% of the\ntime and boosts Speed by TWO 100% of the time.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 200
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      },
      {
        "chance": 100,
        "self": {
          "boosts": {
            "spe": 2
          }
        }
      }
    ]
  },
  "cottonguard": {
    "num": 538,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Cotton Guard",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "self",
    "desc": "The user protects itself by wrapping its body in dense\ncotton, which raises the user's Defense by 3.\nZ-Effect heals user fully.",
    "shortDesc": "The user protects itself by wrapping its body in dense\ncotton, which raises the user's Defense by 3.\nZ-Effect heals user fully.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "def": 3
        }
      }
    ]
  },
  "nightdaze": {
    "num": 539,
    "accuracy": 100,
    "basePower": 100,
    "category": "Special",
    "name": "Night Daze",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "allAdjacentFoes",
    "desc": "The user lets loose a horrible pitch-black shock wave.\nThis flinches 25% of the time, and afflicts a sleeping\nfoe with a horrible nightmare.",
    "shortDesc": "The user lets loose a horrible pitch-black shock wave.\nThis flinches 25% of the time, and afflicts a sleeping\nfoe with a horrible nightmare.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "9"
      },
      {
        "chance": 25,
        "volatileStatus": "flinch"
      }
    ]
  },
  "psystrike": {
    "num": 540,
    "accuracy": 85,
    "basePower": 130,
    "category": "Special",
    "name": "Psystrike",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user materializes a chaotic psychic blast to\nattack the target. This attack does physical damage.",
    "shortDesc": "The user materializes a chaotic psychic blast to\nattack the target. This attack does physical damage.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 200
    }
  },
  "tailslap": {
    "num": 541,
    "accuracy": 100,
    "basePower": 25,
    "category": "Physical",
    "name": "Tail Slap",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user attacks by striking the target hard with its\ntail. It hits 2-5 times in a row. Contact.",
    "shortDesc": "The user attacks by striking the target hard with its\ntail. It hits 2-5 times in a row. Contact.",
    "flags": {
      "contact": 1,
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": [
      2,
      5
    ],
    "zMove": {
      "basePower": 140
    }
  },
  "hurricane": {
    "num": 542,
    "accuracy": 85,
    "basePower": 120,
    "category": "Special",
    "name": "Hurricane",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "The user attacks by surrounding its opponent in a\nfierce hurricane. This flinches 20% of the time, and\ncan't miss in the rain.",
    "shortDesc": "The user attacks by surrounding its opponent in a\nfierce hurricane. This flinches 20% of the time, and\ncan't miss in the rain.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 195
    },
    "secondaries": [
      {
        "chance": 20,
        "volatileStatus": "flinch"
      }
    ]
  },
  "headlongrush": {
    "num": 543,
    "accuracy": 100,
    "basePower": 150,
    "category": "Physical",
    "name": "Headlong Rush",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "normal",
    "desc": "The user charges into the target with insane force.\nThis has 50% recoil, and lowers the user's\nDefense and Sp. Def by 1 after use. Contact.",
    "shortDesc": "The user charges into the target with insane force.\nThis has 50% recoil, and lowers the user's\nDefense and Sp. Def by 1 after use. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      1,
      2
    ],
    "self": {
      "boosts": {
        "def": -1,
        "spd": -1
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "geargrind": {
    "num": 544,
    "accuracy": 100,
    "basePower": 55,
    "category": "Physical",
    "name": "Gear Grind",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "normal",
    "desc": "The user attacks by grinding the target in it's gears.\nThis hits twice, with a 20% chance to flinch per hit.\nContact.",
    "shortDesc": "The user attacks by grinding the target in it's gears.\nThis hits twice, with a 20% chance to flinch per hit.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "multihit": 2,
    "zMove": {
      "basePower": 180
    },
    "secondaries": [
      {
        "chance": 20,
        "volatileStatus": "flinch"
      }
    ]
  },
  "searingshot": {
    "num": 545,
    "accuracy": 100,
    "basePower": 100,
    "category": "Special",
    "name": "Searing Shot",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "allAdjacent",
    "desc": "The user torches everything around it in an shower\nof immense flames. This burns 25% of the time.",
    "shortDesc": "The user torches everything around it in an shower\nof immense flames. This burns 25% of the time.",
    "flags": {
      "bullet": 1,
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    },
    "secondaries": [
      {
        "chance": 50,
        "status": "brn"
      }
    ]
  },
  "technoblast": {
    "num": 546,
    "accuracy": 100,
    "basePower": 120,
    "category": "Special",
    "name": "Techno Blast",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user fires a blast of energy at it's target. The\nmove’s type changes depending on the Drive the\nuser holds. This ALWAYS lowers the foe's Sp. Def by 1.",
    "shortDesc": "The user fires a blast of energy at it's target. The\nmove’s type changes depending on the Drive the\nuser holds. This ALWAYS lowers the foe's Sp. Def by 1.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 200
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spd": -1
        }
      }
    ]
  },
  "serenade": {
    "num": 547,
    "accuracy": 100,
    "basePower": 70,
    "category": "Special",
    "name": "Serenade",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "allAdjacentFoes",
    "desc": "The user sings a song and attacks by\nappealing to the hearts of the listening opponents.\nThis makes the foes drowsy, falling asleep in 2 turns.",
    "shortDesc": "The user sings a song and attacks by\nappealing to the hearts of the listening opponents.\nThis makes the foes drowsy, falling asleep in 2 turns.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "punch": 1
    },
    "zMove": {
      "basePower": 140
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "14"
      }
    ]
  },
  "radiantedge": {
    "num": 548,
    "accuracy": 100,
    "basePower": 65,
    "category": "Special",
    "name": "Radiant Edge",
    "pp": 5,
    "priority": 0,
    "critRatio": 7,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user conjures up a blade made from light, slashing\nat the foe. This deals PHYSICAL damage, NOT Special.\nThis ALWAYS results in a critical hit.",
    "shortDesc": "The user conjures up a blade made from light, slashing\nat the foe. This deals PHYSICAL damage, NOT Special.\nThis ALWAYS results in a critical hit.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "sound": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 175
    }
  },
  "glaciate": {
    "num": 549,
    "accuracy": 90,
    "basePower": 110,
    "category": "Special",
    "name": "Glaciate",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ice",
    "target": "allAdjacentFoes",
    "desc": "The user freezes the space around the targets. This\nhas a 100% chance to lower the opponent's Speed by 2.",
    "shortDesc": "The user freezes the space around the targets. This\nhas a 100% chance to lower the opponent's Speed by 2.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 190
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -2
        }
      }
    ]
  },
  "electroassault": {
    "num": 550,
    "accuracy": 100,
    "basePower": 150,
    "category": "Physical",
    "name": "Electro Assault",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "The user surrounds itself with a great amount of\nelectricity and charges the foe. This drops the user's\nDefenses by 1 after use, & deals 50% recoil. Contact.",
    "shortDesc": "The user surrounds itself with a great amount of\nelectricity and charges the foe. This drops the user's\nDefenses by 1 after use, & deals 50% recoil. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      1,
      2
    ],
    "self": {
      "boosts": {
        "def": -1,
        "spd": -1
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "dragonfury": {
    "num": 551,
    "accuracy": 80,
    "basePower": 130,
    "category": "Special",
    "name": "Dragon Fury",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Dragon",
    "target": "normal",
    "desc": "The user fires off a destructive blast of dragon breath.\nThis ALWAYS leaves the foe with a burn.",
    "shortDesc": "The user fires off a destructive blast of dragon breath.\nThis ALWAYS leaves the foe with a burn.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 205
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "brn"
      }
    ]
  },
  "fierydance": {
    "num": 552,
    "accuracy": 100,
    "basePower": 80,
    "category": "Special",
    "name": "Fiery Dance",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "Cloaked in flames, the user dances with enthusiasm.\nThis ALWAYS boosts the user's Sp. Atk stat by 1.",
    "shortDesc": "Cloaked in flames, the user dances with enthusiasm.\nThis ALWAYS boosts the user's Sp. Atk stat by 1.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "spa": 1
          }
        }
      }
    ]
  },
  "icebreaker": {
    "num": 553,
    "accuracy": true,
    "basePower": 140,
    "category": "Physical",
    "name": "Ice Breaker",
    "pp": 1,
    "priority": 0,
    "critRatio": 7,
    "type": "Ice",
    "target": "normal",
    "desc": "Charging up energy on the 1st turn, the user fires a\nnmassive chunk of energized ice on the 2nd. This will\nALWAYS paralyze and ALWAYS crit. Ignores protect.",
    "shortDesc": "Charging up energy on the 1st turn, the user fires a\nnmassive chunk of energized ice on the 2nd. This will\nALWAYS paralyze and ALWAYS crit. Ignores protect.",
    "flags": {
      "charge": 1,
      "mirror": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 250
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "par"
      }
    ]
  },
  "freezerburn": {
    "num": 554,
    "accuracy": 100,
    "basePower": 120,
    "category": "Special",
    "name": "Freezer Burn",
    "pp": 1,
    "priority": 0,
    "critRatio": 7,
    "type": "Ice",
    "target": "normal",
    "desc": "Charging up energy on the 1st turn, the user unleashes\na wave of harsh, frigid cold on the 2nd. The resulting\nfrostbite ALWAYS burns & ALWAYS crits. Ignores protect.",
    "shortDesc": "Charging up energy on the 1st turn, the user unleashes\na wave of harsh, frigid cold on the 2nd. The resulting\nfrostbite ALWAYS burns & ALWAYS crits. Ignores protect.",
    "flags": {
      "charge": 1,
      "defrost": 1,
      "mirror": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 250
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "brn"
      }
    ]
  },
  "dismalcry": {
    "num": 555,
    "accuracy": 100,
    "basePower": 60,
    "category": "Special",
    "name": "Dismal Cry",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "allAdjacentFoes",
    "desc": "The user unleashes a horrible sound imbued with dark\nfeelings. This demoralizes all foes who hear it,\nALWAYS dropping the foe's attacking stats by 1.",
    "shortDesc": "The user unleashes a horrible sound imbued with dark\nfeelings. This demoralizes all foes who hear it,\nALWAYS dropping the foe's attacking stats by 1.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "punch": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      }
    ]
  },
  "iciclecrash": {
    "num": 556,
    "accuracy": 90,
    "basePower": 110,
    "category": "Physical",
    "name": "Icicle Crash",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ice",
    "target": "normal",
    "desc": "The user attacks by harshly crashing large icicles\nonto the target. This flinches 30% of the time.",
    "shortDesc": "The user attacks by harshly crashing large icicles\nonto the target. This flinches 30% of the time.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 185
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "blazingassault": {
    "num": 557,
    "accuracy": 100,
    "basePower": 150,
    "category": "Physical",
    "name": "Blazing Assault",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "Cloaked in flames, the user delivers a physical\nonslaught on the foe. This has 50% recoil, and drops\nthe user's Defense and Sp. Def by 1. Contact.",
    "shortDesc": "Cloaked in flames, the user delivers a physical\nonslaught on the foe. This has 50% recoil, and drops\nthe user's Defense and Sp. Def by 1. Contact.",
    "flags": {
      "contact": 1,
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      1,
      2
    ],
    "self": {
      "boosts": {
        "def": -1,
        "spd": -1
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "blazingoutburst": {
    "num": 558,
    "accuracy": 100,
    "basePower": 180,
    "category": "Special",
    "name": "Blazing Outburst",
    "pp": 3,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The use fires off a destructive burst of flames.\nThis lowers the user's Sp. Atk by 4 (2/3) after use.\nPower DOUBLES when used right after Electro Outburst.",
    "shortDesc": "The use fires off a destructive burst of flames.\nThis lowers the user's Sp. Atk by 4 (2/3) after use.\nPower DOUBLES when used right after Electro Outburst.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "spa": -4
      }
    },
    "zMove": {
      "basePower": 230
    }
  },
  "electrooutburst": {
    "num": 559,
    "accuracy": 100,
    "basePower": 180,
    "category": "Special",
    "name": "Electro Outburst",
    "pp": 3,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "The use fires off a destructive bolt of lightning.\nThis lowers the user's Sp. Atk by 4 (2/3) after use.\nPower DOUBLES when used right after Blazing Outburst.",
    "shortDesc": "The use fires off a destructive bolt of lightning.\nThis lowers the user's Sp. Atk by 4 (2/3) after use.\nPower DOUBLES when used right after Blazing Outburst.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "spa": -4
      }
    },
    "zMove": {
      "basePower": 230
    }
  },
  "flyingpress": {
    "num": 560,
    "accuracy": true,
    "basePower": 125,
    "category": "Physical",
    "name": "Flying Press",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "The user dives down onto the target from the sky.\nThis move is Fighting and Flying type simultaneously.\nThis has a 30% paralysis rate. Contact.",
    "shortDesc": "The user dives down onto the target from the sky.\nThis move is Fighting and Flying type simultaneously.\nThis has a 30% paralysis rate. Contact.",
    "flags": {
      "contact": 1,
      "gravity": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 200
    },
    "secondaries": [
      {
        "chance": 30,
        "status": "par"
      }
    ]
  },
  "matblock": {
    "num": 561,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Mat Block",
    "pp": 10,
    "priority": 6,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "Using a pulled-up mat as a shield, the user protects\nitself and allies from damaging moves, not status.\nOnly works on turn 1. Z-Effect gives +1 All Stats.",
    "shortDesc": "Using a pulled-up mat as a shield, the user protects\nitself and allies from damaging moves, not status.\nOnly works on turn 1. Z-Effect gives +1 All Stats.",
    "flags": {
      "snatch": 1
    }
  },
  "belch": {
    "num": 562,
    "accuracy": 100,
    "basePower": 120,
    "category": "Special",
    "name": "Belch",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "Only after eating a berry, the user belches, ALWAYS\nboosting the user's Sp. Atk by 1. This also has a 30%\nflinch rate. You can swap out and still use this move.",
    "shortDesc": "Only after eating a berry, the user belches, ALWAYS\nboosting the user's Sp. Atk by 1. This also has a 30%\nflinch rate. You can swap out and still use this move.",
    "flags": {
      "bypasssub": 1,
      "protect": 1,
      "punch": 1
    },
    "zMove": {
      "basePower": 200
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      },
      {
        "chance": 100,
        "self": {
          "boosts": {
            "spa": 1
          }
        }
      }
    ]
  },
  "rototiller": {
    "num": 563,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Rototiller",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "Plowing the soil, the user boosts the Attack & Sp. Atk\nof any Grass-type on the field, including itself, by 2.\nZ-Effect gives +1 all stats.",
    "shortDesc": "Plowing the soil, the user boosts the Attack & Sp. Atk\nof any Grass-type on the field, including itself, by 2.\nZ-Effect gives +1 all stats.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "atk": 2
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spa": 2
        }
      }
    ]
  },
  "stickyweb": {
    "num": 564,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Sticky Web",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Bug",
    "target": "normal",
    "desc": "The user weaves a sticky net around the opposing\nteam, which lowers their Speed stat by 1 when\nswitching into battle. Z-Effect +3 Accuracy.",
    "shortDesc": "The user weaves a sticky net around the opposing\nteam, which lowers their Speed stat by 1 when\nswitching into battle. Z-Effect +3 Accuracy.",
    "flags": {
      "reflectable": 1
    }
  },
  "finishingblow": {
    "num": 565,
    "accuracy": true,
    "basePower": 35,
    "category": "Physical",
    "name": "Finishing Blow",
    "pp": 10,
    "priority": 0,
    "critRatio": 7,
    "type": "Bug",
    "target": "normal",
    "desc": "The user jabs at the target's critical weakpoint.\nALWAYS results in a critical hit, and will boost the\nuser's Attack by 3 if it knocks out the foe. Contact.",
    "shortDesc": "The user jabs at the target's critical weakpoint.\nALWAYS results in a critical hit, and will boost the\nuser's Attack by 3 if it knocks out the foe. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 100
    }
  },
  "phantomforce": {
    "num": 566,
    "accuracy": true,
    "basePower": 105,
    "category": "Physical",
    "name": "Phantom Force",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "The user vanishes, then strikes the target on the\nnext turn. This drops the user's Defense stat by 1\nafter use. Bypasses Protect & Substitute, and can't miss. Contact.",
    "shortDesc": "The user vanishes, then strikes the target on the\nnext turn. This drops the user's Defense stat by 1\nafter use. Bypasses Protect & Substitute, and can't miss. Contact.",
    "flags": {
      "bypasssub": 1,
      "charge": 1,
      "contact": 1,
      "mirror": 1
    },
    "self": {
      "boosts": {
        "def": -1
      }
    },
    "zMove": {
      "basePower": 185
    }
  },
  "spectrify": {
    "num": 567,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Spectrify",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "The user imbues the target with ghostly power.\nThis adds Ghost type to the target’s type.\nZ-Effect +1 all stats.",
    "shortDesc": "The user imbues the target with ghostly power.\nThis adds Ghost type to the target’s type.\nZ-Effect +1 all stats.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "battlecry": {
    "num": 568,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Battle Cry",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "allAdjacentFoes",
    "desc": "Letting out a battle cry, the user intimidates the\ntarget and lowers its Attack and Sp. Atk stats by 2.\nZ-Effect +2 crit rate.",
    "shortDesc": "Letting out a battle cry, the user intimidates the\ntarget and lowers its Attack and Sp. Atk stats by 2.\nZ-Effect +2 crit rate.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "atk": -2
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spa": -2
        }
      }
    ]
  },
  "iondeluge": {
    "num": 569,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Ion Deluge",
    "pp": 10,
    "priority": 4,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "The user disperses electrically charged particles,\nwhich changes Normal-type moves to Electric-type.\nThis has +4 Priority. Z-Effect +1 all stats.",
    "shortDesc": "The user disperses electrically charged particles,\nwhich changes Normal-type moves to Electric-type.\nThis has +4 Priority. Z-Effect +1 all stats.",
    "flags": {}
  },
  "paraboliccharge": {
    "num": 570,
    "accuracy": 100,
    "basePower": 70,
    "category": "Special",
    "name": "Parabolic Charge",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "allAdjacent",
    "desc": "The user unleashes a strange electric charge that\nheals the user by 50% of damage dealt.",
    "shortDesc": "The user unleashes a strange electric charge that\nheals the user by 50% of damage dealt.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "drain": [
      1,
      2
    ],
    "zMove": {
      "basePower": 140
    }
  },
  "forestscurse": {
    "num": 571,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Forest’s Curse",
    "pp": 3,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user puts a curse on the foe that causes them\nto lose 25% HP at the end of each turn, at no\ncost to the user. Z-Effect +1 all stats.",
    "shortDesc": "The user puts a curse on the foe that causes them\nto lose 25% HP at the end of each turn, at no\ncost to the user. Z-Effect +1 all stats.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "10"
      }
    ]
  },
  "petalblizzard": {
    "num": 572,
    "accuracy": 100,
    "basePower": 100,
    "category": "Special",
    "name": "Petal Blizzard",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "allAdjacentFoes",
    "desc": "The user stirs up a violent blizzard of petals and wind.\nThis ALWAYS lowers opponent Speed by 1.",
    "shortDesc": "The user stirs up a violent blizzard of petals and wind.\nThis ALWAYS lowers opponent Speed by 1.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -1
        }
      }
    ]
  },
  "freezedry": {
    "num": 573,
    "accuracy": 100,
    "basePower": 85,
    "category": "Special",
    "name": "Freeze-Dry",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Ice",
    "target": "normal",
    "desc": "The user rapidly cools the target. This freezes the\ntarget 10% of the time. This move is super effective\non Water types.",
    "shortDesc": "The user rapidly cools the target. This freezes the\ntarget 10% of the time. This move is super effective\non Water types.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 170
    },
    "secondaries": [
      {
        "chance": 10,
        "status": "frz"
      }
    ]
  },
  "disarmingvoice": {
    "num": 574,
    "accuracy": 100,
    "basePower": 60,
    "category": "Special",
    "name": "Disarming Voice",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "allAdjacentFoes",
    "desc": "Letting out a charming cry, the user subdues the\nfoes, ALWAYS dropping the foe's attacking stats by 1.",
    "shortDesc": "Letting out a charming cry, the user subdues the\nfoes, ALWAYS dropping the foe's attacking stats by 1.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "punch": 1,
      "sound": 1
    },
    "zMove": {
      "basePower": 120
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      }
    ]
  },
  "partingshot": {
    "num": 575,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Parting Shot",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "With a parting threat, the user lowers the target’s\nAttack and Sp. Atk stats. Then it switches with a\nparty Pokemon. Z-Effect heals replacement.",
    "shortDesc": "With a parting threat, the user lowers the target’s\nAttack and Sp. Atk stats. Then it switches with a\nparty Pokemon. Z-Effect heals replacement.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      }
    ]
  },
  "topsyturvy": {
    "num": 576,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Topsy-Turvy",
    "pp": 20,
    "priority": 4,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "All stat changes affecting the target turn\nare reversed. Z-Effect heals user fully.\nThis has +4 Priority.",
    "shortDesc": "All stat changes affecting the target turn\nare reversed. Z-Effect heals user fully.\nThis has +4 Priority.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "drainingkiss": {
    "num": 577,
    "accuracy": 100,
    "basePower": 50,
    "category": "Special",
    "name": "Draining Kiss",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user steals the target’s HP with a kiss. The\nuser’s HP is restored by 75% of damage dealt.\nContact.",
    "shortDesc": "The user steals the target’s HP with a kiss. The\nuser’s HP is restored by 75% of damage dealt.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1,
      "sound": 1
    },
    "drain": [
      3,
      4
    ],
    "zMove": {
      "basePower": 100
    }
  },
  "craftyshield": {
    "num": 578,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Crafty Shield",
    "pp": 40,
    "priority": 6,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user blocks any and all targeted status moves.\nThis can be used repeatedly without fail.\nHas +6 Priority. Z-EFFECT GIVES +1 ALL STATS.",
    "shortDesc": "The user blocks any and all targeted status moves.\nThis can be used repeatedly without fail.\nHas +6 Priority. Z-EFFECT GIVES +1 ALL STATS.",
    "flags": {
      "sound": 1
    }
  },
  "floralguard": {
    "num": 579,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Floral Guard",
    "pp": 3,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user raises the Defense and Sp. Def stat of all\nGrass-type allies, including itself with a\nmysterious power. Z-Effect heals user fully.",
    "shortDesc": "The user raises the Defense and Sp. Def stat of all\nGrass-type allies, including itself with a\nmysterious power. Z-Effect heals user fully.",
    "flags": {
      "dance": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "def": 1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spd": 1
        }
      }
    ]
  },
  "grassyterrain": {
    "num": 580,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Grassy Terrain",
    "pp": 5,
    "priority": 4,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user changes the terrain to Grassy Terrain for\n5 turns. Z-Effect +2 Defense.\nTHIS HAS +4 PRIORITY.",
    "shortDesc": "The user changes the terrain to Grassy Terrain for\n5 turns. Z-Effect +2 Defense.\nTHIS HAS +4 PRIORITY.",
    "flags": {}
  },
  "mistyterrain": {
    "num": 581,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Misty Terrain",
    "pp": 5,
    "priority": 4,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user changes the terrain to Misty Terrain for\n5 turns. Z-Effect +2 Sp. Def.\nTHIS HAS +4 PRIORITY.",
    "shortDesc": "The user changes the terrain to Misty Terrain for\n5 turns. Z-Effect +2 Sp. Def.\nTHIS HAS +4 PRIORITY.",
    "flags": {
      "sound": 1
    }
  },
  "electrify": {
    "num": 582,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Electrify",
    "pp": 1,
    "priority": 4,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "The user makes the opponent's selected move\nfor the turn become Electric type.\nThis has +4 Priority. Z-Effect gives +2 Speed.",
    "shortDesc": "The user makes the opponent's selected move\nfor the turn become Electric type.\nThis has +4 Priority. Z-Effect gives +2 Speed.",
    "flags": {
      "mirror": 1,
      "protect": 1
    }
  },
  "playrough": {
    "num": 583,
    "accuracy": 100,
    "basePower": 110,
    "category": "Physical",
    "name": "Play Rough",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user roughhouses the foe strongly, but playfully.\nThis deals 20% recoil damage to the user, and has a\n50% chance to drop the foe's Attack by 1 after use.",
    "shortDesc": "The user roughhouses the foe strongly, but playfully.\nThis deals 20% recoil damage to the user, and has a\n50% chance to drop the foe's Attack by 1 after use.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1,
      "sound": 1
    },
    "recoil": [
      20,
      100
    ],
    "zMove": {
      "basePower": 185
    },
    "secondaries": [
      {
        "chance": 50,
        "boosts": {
          "atk": -1
        }
      }
    ]
  },
  "pixiedust": {
    "num": 584,
    "accuracy": true,
    "basePower": 45,
    "category": "Special",
    "name": "Pixie Dust",
    "pp": 20,
    "priority": 1,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user quickly blows fairy dust at the opponent.\nThis has +1 priority, and can't miss.",
    "shortDesc": "The user quickly blows fairy dust at the opponent.\nThis has +1 priority, and can't miss.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "sound": 1
    },
    "zMove": {
      "basePower": 90
    }
  },
  "moonblast": {
    "num": 585,
    "accuracy": 100,
    "basePower": 100,
    "category": "Special",
    "name": "Moonblast",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "Borrowing the power of the moon, the user attacks\nthe foe. This lowers their Sp. Atk 30% of the time.",
    "shortDesc": "Borrowing the power of the moon, the user attacks\nthe foe. This lowers their Sp. Atk 30% of the time.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "sound": 1
    },
    "zMove": {
      "basePower": 180
    },
    "secondaries": [
      {
        "chance": 30,
        "boosts": {
          "spa": -1
        }
      }
    ]
  },
  "boomburst": {
    "num": 586,
    "accuracy": 100,
    "basePower": 125,
    "category": "Special",
    "name": "Boomburst",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "allAdjacentFoes",
    "desc": "The user unleashes an excruciatingly loud sound wave.\nThis hits all foes.",
    "shortDesc": "The user unleashes an excruciatingly loud sound wave.\nThis hits all foes.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "punch": 1
    },
    "zMove": {
      "basePower": 190
    }
  },
  "fairylock": {
    "num": 587,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Fairy Lock",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "Doesn't exist.",
    "shortDesc": "Doesn't exist.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "sound": 1
    }
  },
  "kingsshield": {
    "num": 588,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "King’s Shield",
    "pp": 5,
    "priority": 6,
    "critRatio": 1,
    "type": "Steel",
    "target": "self",
    "desc": "The user takes a defensive stance while it protects\nitself from damage. It lowers the Attack of any foes\nthat make contact by 2. Z-Effect +1 Speed.",
    "shortDesc": "The user takes a defensive stance while it protects\nitself from damage. It lowers the Attack of any foes\nthat make contact by 2. Z-Effect +1 Speed.",
    "flags": {}
  },
  "playnice": {
    "num": 589,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Play Nice",
    "pp": 20,
    "priority": 4,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user and the target become friends, and the\ntarget loses its will to fight. This has +4 priority,\nand drops their Sp. Atk by 1. Z-Effect +2 Attack.",
    "shortDesc": "The user and the target become friends, and the\ntarget loses its will to fight. This has +4 priority,\nand drops their Sp. Atk by 1. Z-Effect +2 Attack.",
    "flags": {
      "mirror": 1,
      "reflectable": 1,
      "sound": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      }
    ]
  },
  "confide": {
    "num": 590,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Confide",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user tells the target a shocking secret, and\ndrops their Sp. Atk and Sp. Def by one.\nZ-Effect +2 Sp. Atk. BYPASSES PROTECT.",
    "shortDesc": "The user tells the target a shocking secret, and\ndrops their Sp. Atk and Sp. Def by one.\nZ-Effect +2 Sp. Atk. BYPASSES PROTECT.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spd": -1
        }
      }
    ]
  },
  "mineralshower": {
    "num": 591,
    "accuracy": 100,
    "basePower": 150,
    "category": "Special",
    "name": "Mineral Shower",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Rock",
    "target": "allAdjacentFoes",
    "desc": "The user whips up a storm of gemstones and crystals.\nThis lowers the user's Sp. Atk stat by 2 after use.",
    "shortDesc": "The user whips up a storm of gemstones and crystals.\nThis lowers the user's Sp. Atk stat by 2 after use.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "spa": -2
      }
    },
    "zMove": {
      "basePower": 200
    }
  },
  "steameruption": {
    "num": 592,
    "accuracy": 100,
    "basePower": 110,
    "category": "Special",
    "name": "Steam Eruption",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "The user immerses the target in superheated steam.\nThis ALWAYS leaves the foe with a burn.",
    "shortDesc": "The user immerses the target in superheated steam.\nThis ALWAYS leaves the foe with a burn.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 185
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "brn"
      }
    ]
  },
  "psychowarp": {
    "num": 593,
    "accuracy": true,
    "basePower": 120,
    "category": "Physical",
    "name": "Psycho Warp",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "Using great psychic power, the user appears right\nnext to the target and strikes. This lowers the user's\nDefense and Sp. Def by 1 after use. Contact.",
    "shortDesc": "Using great psychic power, the user appears right\nnext to the target and strikes. This lowers the user's\nDefense and Sp. Def by 1 after use. Contact.",
    "flags": {
      "bypasssub": 1,
      "contact": 1,
      "mirror": 1
    },
    "self": {
      "boosts": {
        "def": -1,
        "spd": -1
      }
    },
    "zMove": {
      "basePower": 195
    }
  },
  "surgingstrikes": {
    "num": 594,
    "accuracy": 100,
    "basePower": 25,
    "category": "Physical",
    "name": "Surging Strikes",
    "pp": 3,
    "priority": 0,
    "critRatio": 7,
    "type": "Water",
    "target": "normal",
    "desc": "The user repeatedly strikes the target with the force\nof a tsunami. This hits three times, and always\nresults in a critical hit. Bypasses Protect. Contact.",
    "shortDesc": "The user repeatedly strikes the target with the force\nof a tsunami. This hits three times, and always\nresults in a critical hit. Bypasses Protect. Contact.",
    "flags": {
      "contact": 1,
      "heal": 1,
      "mirror": 1
    },
    "willCrit": true,
    "multihit": 3,
    "zMove": {
      "basePower": 190
    }
  },
  "mysticalfire": {
    "num": 595,
    "accuracy": 100,
    "basePower": 70,
    "category": "Special",
    "name": "Mystical Fire",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The user attacks by forming a strange, magical flame.\nThis ALWAYS drops the foe's attacking stats by 1.",
    "shortDesc": "The user attacks by forming a strange, magical flame.\nThis ALWAYS drops the foe's attacking stats by 1.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 140
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      }
    ]
  },
  "spikyshield": {
    "num": 596,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Spiky Shield",
    "pp": 10,
    "priority": 6,
    "critRatio": 1,
    "type": "Grass",
    "target": "self",
    "desc": "In addition to protecting the user from attacks, this\nmove also damages any attacker who makes\ncontact for 12% of their max HP. Z-Effect +2 Defense.",
    "shortDesc": "In addition to protecting the user from attacks, this\nmove also damages any attacker who makes\ncontact for 12% of their max HP. Z-Effect +2 Defense.",
    "flags": {}
  },
  "aromaticmist": {
    "num": 597,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Aromatic Mist",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "allAdjacentFoes",
    "desc": "The user releases an alluring, strong smelling mist.\nThis lowers the Sp. Atk & Sp. Def stats of foes who\nsmell it by 2. Z-Effect heals the user fully.",
    "shortDesc": "The user releases an alluring, strong smelling mist.\nThis lowers the Sp. Atk & Sp. Def stats of foes who\nsmell it by 2. Z-Effect heals the user fully.",
    "flags": {
      "bypasssub": 1,
      "sound": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spd": -2
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spa": -2
        }
      }
    ]
  },
  "strangeimpulse": {
    "num": 598,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Strange Impulse",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "allAdjacentFoes",
    "desc": "The user’s body emits a bizarre, unnerving impulse.\nThis lowers the Sp. Atk of the foes by 2.\nZ-Effect +2 Sp. Atk.",
    "shortDesc": "The user’s body emits a bizarre, unnerving impulse.\nThis lowers the Sp. Atk of the foes by 2.\nZ-Effect +2 Sp. Atk.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "spa": -2
        }
      }
    ]
  },
  "venomdrench": {
    "num": 599,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Venom Drench",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "allAdjacentFoes",
    "desc": "The opponent is drenched in a special, poison liquid.\nThis drops the Speed & Offenses of the foe by 3.\nFails if the foe isn't poisoned. Z-Effect +3 Sp. Atk.",
    "shortDesc": "The opponent is drenched in a special, poison liquid.\nThis drops the Speed & Offenses of the foe by 3.\nFails if the foe isn't poisoned. Z-Effect +3 Sp. Atk.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "atk": -3
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spa": -3
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spe": -3
        }
      }
    ]
  },
  "powder": {
    "num": 600,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Powder",
    "pp": 5,
    "priority": 4,
    "critRatio": 1,
    "type": "Bug",
    "target": "normal",
    "desc": "Covers the foe in combustible powder. +4 Priority.\nIf the target uses a Fire move, the move fails and\nthey take 25% of their max HP. Z-Effect +1 all stats.",
    "shortDesc": "Covers the foe in combustible powder. +4 Priority.\nIf the target uses a Fire move, the move fails and\nthey take 25% of their max HP. Z-Effect +1 all stats.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    }
  },
  "enchantment": {
    "num": 601,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Enchantment",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "self",
    "desc": "The user summons a magical force for 1 turn.\nOn the second turn, the user gains +2 Sp. Def and\nSp. Atk and +1 Speed. Z-Effect heals user fully.",
    "shortDesc": "The user summons a magical force for 1 turn.\nOn the second turn, the user gains +2 Sp. Def and\nSp. Atk and +1 Speed. Z-Effect heals user fully.",
    "flags": {
      "charge": 1,
      "dance": 1,
      "snatch": 1,
      "sound": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "spa": 2
        }
      },
      {
        "chance": 0,
        "boosts": {
          "spd": 2
        }
      },
      {
        "chance": 0,
        "boosts": {
          "spe": 1
        }
      }
    ]
  },
  "magneticflux": {
    "num": 602,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Magnetic Flux",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "Doesn't exist.",
    "shortDesc": "Doesn't exist.",
    "flags": {
      "bypasssub": 1,
      "snatch": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "def": 1
        }
      },
      {
        "chance": 0,
        "boosts": {
          "spd": 1
        }
      }
    ]
  },
  "happyhour": {
    "num": 603,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Happy Hour",
    "pp": 30,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "Using Happy Hour doubles the amount of prize\nmoney received after battle.\nZ-Effect +1 all stats.",
    "shortDesc": "Using Happy Hour doubles the amount of prize\nmoney received after battle.\nZ-Effect +1 all stats.",
    "flags": {}
  },
  "electricterrain": {
    "num": 604,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Electric Terrain",
    "pp": 5,
    "priority": 4,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "The user changes the terrain to Electric Terrain for\n5 turns. Z-Effect +2 Defense.\nTHIS HAS +4 PRIORITY.",
    "shortDesc": "The user changes the terrain to Electric Terrain for\n5 turns. Z-Effect +2 Defense.\nTHIS HAS +4 PRIORITY.",
    "flags": {}
  },
  "dazzlinggleam": {
    "num": 605,
    "accuracy": 100,
    "basePower": 80,
    "category": "Special",
    "name": "Dazzling Gleam",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "allAdjacentFoes",
    "desc": "The user damages opposing Pokemon by emitting a\nbeautiful gleam of light. This has a 25% chance to\nboost the user's Sp. Atk by one.",
    "shortDesc": "The user damages opposing Pokemon by emitting a\nbeautiful gleam of light. This has a 25% chance to\nboost the user's Sp. Atk by one.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "sound": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 25,
        "self": {
          "boosts": {
            "spa": 1
          }
        }
      }
    ]
  },
  "celebrate": {
    "num": 606,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Celebrate",
    "pp": 40,
    "priority": 4,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "Delibird summons a giant present with holiday spirit.\nThis does nothing, but Delibird enjoys it!\nZ-Effect gives +1 to all stats, and has +4 Priority.",
    "shortDesc": "Delibird summons a giant present with holiday spirit.\nThis does nothing, but Delibird enjoys it!\nZ-Effect gives +1 to all stats, and has +4 Priority.",
    "flags": {}
  },
  "befriend": {
    "num": 607,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Befriend",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user befriends the foe, making them less hostile.\nThis lowers the foe's Sp. Atk stat by 2.\nZ-Effect heals the user fully.",
    "shortDesc": "The user befriends the foe, making them less hostile.\nThis lowers the foe's Sp. Atk stat by 2.\nZ-Effect heals the user fully.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1,
      "sound": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spa": -2
        }
      }
    ]
  },
  "babydolleyes": {
    "num": 608,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Baby-Doll Eyes",
    "pp": 20,
    "priority": 4,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user stares at the target with its baby-doll\neyes, which lowers its Attack by one.\nThis has +4 priority. Z-Effect +2 Attack.",
    "shortDesc": "The user stares at the target with its baby-doll\neyes, which lowers its Attack by one.\nThis has +4 priority. Z-Effect +2 Attack.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1,
      "sound": 1
    },
    "secondaries": [
      {
        "chance": 0,
        "boosts": {
          "atk": -1
        }
      }
    ]
  },
  "nuzzle": {
    "num": 609,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Nuzzle",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "The user cutely nuzzles the foe.\nThis leaves the foe paralyzed and lowers their Attack\nand Sp. Atk by 1. Z-Effect +2 Attack. Contact.",
    "shortDesc": "The user cutely nuzzles the foe.\nThis leaves the foe paralyzed and lowers their Attack\nand Sp. Atk by 1. Z-Effect +2 Attack. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "par"
      },
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      }
    ]
  },
  "holdback": {
    "num": 610,
    "accuracy": true,
    "basePower": 45,
    "category": "Physical",
    "name": "Hold Back",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user goes easy on the foe to avoid knocking them\nout. In return, this boosts the user's Attack and\nAccuracy stats by 1 after use. Can't miss. Contact.",
    "shortDesc": "The user goes easy on the foe to avoid knocking them\nout. In return, this boosts the user's Attack and\nAccuracy stats by 1 after use. Can't miss. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 90
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "atk": 1
          }
        }
      },
      {
        "chance": 100,
        "self": {
          "boosts": {
            "accuracy": 1
          }
        }
      }
    ]
  },
  "infestation": {
    "num": 611,
    "accuracy": 100,
    "basePower": 50,
    "category": "Special",
    "name": "Infestation",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Bug",
    "target": "normal",
    "desc": "The target is infested with a relentless pestilence\nthat traps foe for 12 turns, preventing switching\nand dealing 12% of the foe's max HP per turn.",
    "shortDesc": "The target is infested with a relentless pestilence\nthat traps foe for 12 turns, preventing switching\nand dealing 12% of the foe's max HP per turn.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "poweruppunch": {
    "num": 612,
    "accuracy": 100,
    "basePower": 50,
    "category": "Physical",
    "name": "Power-Up Punch",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "Striking opponents over and over makes the user’s\nfists harder. Hitting a target raises the Attack stat.",
    "shortDesc": "Striking opponents over and over makes the user’s\nfists harder. Hitting a target raises the Attack stat.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "atk": 1
          }
        }
      }
    ]
  },
  "oblivionbeam": {
    "num": 613,
    "accuracy": 100,
    "basePower": 180,
    "category": "Special",
    "name": "Oblivion Beam",
    "pp": 3,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user fires off a devastating beam of darkness from\nthe sky. This drops your Sp. Atk stat by -4. (2/3).",
    "shortDesc": "The user fires off a devastating beam of darkness from\nthe sky. This drops your Sp. Atk stat by -4. (2/3).",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "drain": [
      1,
      2
    ],
    "self": {
      "boosts": {
        "spa": -4
      }
    },
    "zMove": {
      "basePower": 230
    }
  },
  "thousandarrows": {
    "num": 614,
    "accuracy": 100,
    "basePower": 100,
    "category": "Special",
    "name": "Thousand Arrows",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "allAdjacentFoes",
    "desc": "Zygarde fires off an onslaught of arrows.\nThese will ground a flying target.",
    "shortDesc": "Zygarde fires off an onslaught of arrows.\nThese will ground a flying target.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "25"
      }
    ]
  },
  "thousandwaves": {
    "num": 615,
    "accuracy": 100,
    "basePower": 125,
    "category": "Special",
    "name": "Thousand Waves",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "allAdjacentFoes",
    "desc": "Zygarde fires off an onslaught of waves.\nThese will trap the targets in battle.",
    "shortDesc": "Zygarde fires off an onslaught of waves.\nThese will trap the targets in battle.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 190
    }
  },
  "landswrath": {
    "num": 616,
    "accuracy": 100,
    "basePower": 150,
    "category": "Special",
    "name": "Land's Wrath",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "normal",
    "desc": "The user gathers the energy of the land and focuses\nit on the target. This lowers the user's Sp. Atk stat\nby 2 stages after use in exchange.",
    "shortDesc": "The user gathers the energy of the land and focuses\nit on the target. This lowers the user's Sp. Atk stat\nby 2 stages after use in exchange.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "spa": -2
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "eternalbeam": {
    "num": 617,
    "accuracy": 100,
    "basePower": 125,
    "category": "Special",
    "name": "Eternal Beam",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user unleashes a perilous beam fueled by its own\nlife force. This deals 25% recoil, and has a 50%\nchance to drop the foe's Sp. Def stat after use.",
    "shortDesc": "The user unleashes a perilous beam fueled by its own\nlife force. This deals 25% recoil, and has a 50%\nchance to drop the foe's Sp. Def stat after use.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "sound": 1
    },
    "recoil": [
      1,
      4
    ],
    "zMove": {
      "basePower": 195
    },
    "secondaries": [
      {
        "chance": 50,
        "boosts": {
          "spd": -1
        }
      }
    ]
  },
  "torrentialpulse": {
    "num": 618,
    "accuracy": 100,
    "basePower": 100,
    "category": "Special",
    "name": "Torrential Pulse",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "allAdjacentFoes",
    "desc": "The user attacks opponents with a brilliant cascade of\nwater. This has a 50% chance to drop Sp. Def.",
    "shortDesc": "The user attacks opponents with a brilliant cascade of\nwater. This has a 50% chance to drop Sp. Def.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "pulse": 1
    },
    "zMove": {
      "basePower": 180
    },
    "secondaries": [
      {
        "chance": 50,
        "boosts": {
          "spd": -1
        }
      }
    ]
  },
  "precipiceblades": {
    "num": 619,
    "accuracy": 85,
    "basePower": 130,
    "category": "Physical",
    "name": "Precipice Blades",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "allAdjacentFoes",
    "desc": "The user attacks opposing Pokemon by manifesting\nthe power of the land in fearsome, searingly hot\nblades of stone. This burns the foes 30% of the time.",
    "shortDesc": "The user attacks opposing Pokemon by manifesting\nthe power of the land in fearsome, searingly hot\nblades of stone. This burns the foes 30% of the time.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 200
    },
    "secondaries": [
      {
        "chance": 30,
        "status": "brn"
      }
    ]
  },
  "dragonascent": {
    "num": 620,
    "accuracy": 100,
    "basePower": 150,
    "category": "Physical",
    "name": "Dragon Ascent",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Dragon",
    "target": "normal",
    "desc": "The user descends from the sky onto the foe\nwith immense, drakonic force.\nThis drops the user's Attack by 2 after use. Contact.",
    "shortDesc": "The user descends from the sky onto the foe\nwith immense, drakonic force.\nThis drops the user's Attack by 2 after use. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "atk": -2
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "hyperspacefury": {
    "num": 621,
    "accuracy": true,
    "basePower": 150,
    "category": "Physical",
    "name": "Hyperspace Fury",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "Using its many arms, Hoopa Unbound unleashes it's\nfury. This drops Hoopa's Defenses by 1 after use, and\ndeals 30% recoil damage. Contact. Bypasses protect.",
    "shortDesc": "Using its many arms, Hoopa Unbound unleashes it's\nfury. This drops Hoopa's Defenses by 1 after use, and\ndeals 30% recoil damage. Contact. Bypasses protect.",
    "flags": {
      "bypasssub": 1,
      "contact": 1,
      "mirror": 1
    },
    "recoil": [
      30,
      100
    ],
    "self": {
      "boosts": {
        "def": -1,
        "spd": -1
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "breakneckblitz": {
    "num": 623,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Breakneck Blitz",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "Dummy Data",
    "shortDesc": "Dummy Data",
    "flags": {}
  },
  "alloutpummeling": {
    "num": 625,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "All-Out Pummeling",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Fighting",
    "target": "normal",
    "desc": "Dummy Data",
    "shortDesc": "Dummy Data",
    "flags": {}
  },
  "supersonicskystrike": {
    "num": 627,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Supersonic Skystrike",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "Dummy Data",
    "shortDesc": "Dummy Data",
    "flags": {}
  },
  "aciddownpour": {
    "num": 629,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Acid Downpour",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "Dummy Data",
    "shortDesc": "Dummy Data",
    "flags": {}
  },
  "tectonicrage": {
    "num": 631,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Tectonic Rage",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "normal",
    "desc": "Dummy Data",
    "shortDesc": "Dummy Data",
    "flags": {}
  },
  "continentalcrush": {
    "num": 633,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Continental Crush",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Rock",
    "target": "normal",
    "desc": "Dummy Data",
    "shortDesc": "Dummy Data",
    "flags": {}
  },
  "savagespinout": {
    "num": 635,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Savage Spin-Out",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Bug",
    "target": "normal",
    "desc": "Dummy Data",
    "shortDesc": "Dummy Data",
    "flags": {}
  },
  "neverendingnightmare": {
    "num": 637,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Never-Ending Nightmare",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "Dummy Data",
    "shortDesc": "Dummy Data",
    "flags": {}
  },
  "corkscrewcrash": {
    "num": 639,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Corkscrew Crash",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "normal",
    "desc": "Dummy Data",
    "shortDesc": "Dummy Data",
    "flags": {}
  },
  "infernooverdrive": {
    "num": 641,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Inferno Overdrive",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "Dummy Data",
    "shortDesc": "Dummy Data",
    "flags": {
      "defrost": 1
    }
  },
  "hydrovortex": {
    "num": 643,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Hydro Vortex",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "Dummy Data",
    "shortDesc": "Dummy Data",
    "flags": {}
  },
  "bloomdoom": {
    "num": 645,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Bloom Doom",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "Dummy Data",
    "shortDesc": "Dummy Data",
    "flags": {}
  },
  "gigavolthavoc": {
    "num": 647,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Gigavolt Havoc",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "Dummy Data",
    "shortDesc": "Dummy Data",
    "flags": {}
  },
  "shatteredpsyche": {
    "num": 649,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Shattered Psyche",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "Dummy Data",
    "shortDesc": "Dummy Data",
    "flags": {}
  },
  "subzeroslammer": {
    "num": 651,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Subzero Slammer",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Ice",
    "target": "normal",
    "desc": "Dummy Data",
    "shortDesc": "Dummy Data",
    "flags": {}
  },
  "devastatingdrake": {
    "num": 653,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Devastating Drake",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Dragon",
    "target": "normal",
    "desc": "Dummy Data",
    "shortDesc": "Dummy Data",
    "flags": {}
  },
  "blackholeeclipse": {
    "num": 655,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Black Hole Eclipse",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "Dummy Data",
    "shortDesc": "Dummy Data",
    "flags": {}
  },
  "twinkletackle": {
    "num": 657,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Twinkle Tackle",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "Dummy Data",
    "shortDesc": "Dummy Data",
    "flags": {
      "sound": 1
    }
  },
  "catastropika": {
    "num": 658,
    "accuracy": true,
    "basePower": 250,
    "category": "Physical",
    "name": "Catastropika",
    "pp": 1,
    "priority": 0,
    "critRatio": 7,
    "type": "Electric",
    "target": "normal",
    "desc": "Pikachu dives at the target with immense force.\nThis ALWAYS crits and ALWAYS paralyzes the foe.",
    "shortDesc": "Pikachu dives at the target with immense force.\nThis ALWAYS crits and ALWAYS paralyzes the foe.",
    "flags": {},
    "willCrit": true,
    "secondaries": [
      {
        "chance": 100,
        "status": "par"
      }
    ]
  },
  "sedimend": {
    "num": 659,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Sedimend",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "self",
    "desc": "The user mends it's body with sand or other minerals.\nThis heals the user by 50% of it's max HP. This heals\n66% of it's HP in a Sandstorm. Z-Effect +2 Sp. Def.",
    "shortDesc": "The user mends it's body with sand or other minerals.\nThis heals the user by 50% of it's max HP. This heals\n66% of it's HP in a Sandstorm. Z-Effect +2 Sp. Def.",
    "flags": {
      "snatch": 1
    }
  },
  "firstimpression": {
    "num": 660,
    "accuracy": true,
    "basePower": 60,
    "category": "Physical",
    "name": "First Impression",
    "pp": 10,
    "priority": 4,
    "critRatio": 7,
    "type": "Bug",
    "target": "normal",
    "desc": "The user delivers a quick, potent blow. This has +4\npriority, can't miss, & ALWAYS crits. However, it only\nworks the on the 1st turn. Contact. BYPASSES PROTECT.",
    "shortDesc": "The user delivers a quick, potent blow. This has +4\npriority, can't miss, & ALWAYS crits. However, it only\nworks the on the 1st turn. Contact. BYPASSES PROTECT.",
    "flags": {
      "contact": 1,
      "mirror": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 175
    }
  },
  "banefulbunker": {
    "num": 661,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Baneful Bunker",
    "pp": 10,
    "priority": 6,
    "critRatio": 1,
    "type": "Poison",
    "target": "self",
    "desc": "In addition to protecting the user from attacks, this\nmove also poisons any attacker that makes\ndirect contact. Z-Effect +2 Defense.",
    "shortDesc": "In addition to protecting the user from attacks, this\nmove also poisons any attacker that makes\ndirect contact. Z-Effect +2 Defense.",
    "flags": {}
  },
  "spiritshackle": {
    "num": 662,
    "accuracy": true,
    "basePower": 60,
    "category": "Physical",
    "name": "Spirit Shackle",
    "pp": 5,
    "priority": 0,
    "critRatio": 7,
    "type": "Ghost",
    "target": "normal",
    "desc": "The user attacks while simultaneously stitching the\ntarget’s shadow to the ground to prevent the target\nfrom escaping. This always results in a critical hit.",
    "shortDesc": "The user attacks while simultaneously stitching the\ntarget’s shadow to the ground to prevent the target\nfrom escaping. This always results in a critical hit.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 120
    }
  },
  "brutalswing": {
    "num": 663,
    "accuracy": 100,
    "basePower": 125,
    "category": "Physical",
    "name": "Brutal Swing",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user crashes into the target, swinging around.\nThis has 25% recoil. The target’s stat changes don’t\naffect this attack’s damage. Contact.",
    "shortDesc": "The user crashes into the target, swinging around.\nThis has 25% recoil. The target’s stat changes don’t\naffect this attack’s damage. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      1,
      4
    ],
    "zMove": {
      "basePower": 195
    }
  },
  "bubbleburst": {
    "num": 664,
    "accuracy": 100,
    "basePower": 100,
    "category": "Special",
    "name": "Bubble Burst",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "allAdjacentFoes",
    "desc": "The user releases a flurry of exploding bubbles down\nonto the foe. This ALWAYS lowers their Speed by 1.",
    "shortDesc": "The user releases a flurry of exploding bubbles down\nonto the foe. This ALWAYS lowers their Speed by 1.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -1
        }
      }
    ]
  },
  "icehammer": {
    "num": 665,
    "accuracy": 100,
    "basePower": 125,
    "category": "Physical",
    "name": "Ice Hammer",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Ice",
    "target": "normal",
    "desc": "The user wildly swings its heavy fist encased in ice.\nThis deals 25% recoil, and drops Defense 30% of\nthe time. Contact.",
    "shortDesc": "The user wildly swings its heavy fist encased in ice.\nThis deals 25% recoil, and drops Defense 30% of\nthe time. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      1,
      4
    ],
    "zMove": {
      "basePower": 195
    },
    "secondaries": [
      {
        "chance": 30,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "floralhealing": {
    "num": 666,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Floral Healing",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "self",
    "desc": "The user heals itself by 50% of its max HP.\nThis restores 2/3 HP under Grassy Terrain.\nZ-Effect gives +2 Sp. Def.",
    "shortDesc": "The user heals itself by 50% of its max HP.\nThis restores 2/3 HP under Grassy Terrain.\nZ-Effect gives +2 Sp. Def.",
    "flags": {
      "protect": 1,
      "reflectable": 1
    }
  },
  "highhorsepower": {
    "num": 667,
    "accuracy": 100,
    "basePower": 95,
    "category": "Physical",
    "name": "High Horsepower",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "normal",
    "desc": "The user kicks the target with immense power using\nits hooves. This has a 30% flinch chance. Contact.",
    "shortDesc": "The user kicks the target with immense power using\nits hooves. This has a 30% flinch chance. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 30,
        "volatileStatus": "flinch"
      }
    ]
  },
  "strengthsap": {
    "num": 668,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Strength Sap",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user drains the target's life force. This\nrecovers massive HP,  equal to the foe's Attack stat.\nThis also lowers Attack by 1. Z-Effect +2 Sp. Def.",
    "shortDesc": "The user drains the target's life force. This\nrecovers massive HP,  equal to the foe's Attack stat.\nThis also lowers Attack by 1. Z-Effect +2 Sp. Def.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      }
    ]
  },
  "solarblade": {
    "num": 669,
    "accuracy": 100,
    "basePower": 90,
    "category": "Physical",
    "name": "Solar Blade",
    "pp": 10,
    "priority": 0,
    "critRatio": 7,
    "type": "Grass",
    "target": "normal",
    "desc": "The user gathers light and strikes with a blade on the\nsecond turn. This doesn't need to charge in sun.\nContact. ALWAYS CRITS. Ignores protect.",
    "shortDesc": "The user gathers light and strikes with a blade on the\nsecond turn. This doesn't need to charge in sun.\nContact. ALWAYS CRITS. Ignores protect.",
    "flags": {
      "charge": 1,
      "contact": 1,
      "mirror": 1
    },
    "willCrit": true,
    "zMove": {
      "basePower": 200
    }
  },
  "seedshot": {
    "num": 670,
    "accuracy": true,
    "basePower": 45,
    "category": "Physical",
    "name": "Seed Shot",
    "pp": 25,
    "priority": 1,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user quickly shoots small seeds and other\nplant matter at the foe. This can't miss.\nThis attack has +1 priority.",
    "shortDesc": "The user quickly shoots small seeds and other\nplant matter at the foe. This can't miss.\nThis attack has +1 priority.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "spotlight": {
    "num": 671,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Spotlight",
    "pp": 15,
    "priority": 6,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user shines a spotlight on the foe so they become\nthe center of attention for the rest of the turn.\nZ-Effect gives +1 to all stats.",
    "shortDesc": "The user shines a spotlight on the foe so they become\nthe center of attention for the rest of the turn.\nZ-Effect gives +1 to all stats.",
    "flags": {
      "protect": 1,
      "reflectable": 1
    }
  },
  "toxicthread": {
    "num": 672,
    "accuracy": 100,
    "basePower": 0,
    "category": "Status",
    "name": "Toxic Thread",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Poison",
    "target": "normal",
    "desc": "The user shoots poisonous filaments to poison and slow\nthe foe. This both poisons the foe, and drops their\nSpeed & Evasion stats by 4. Z-Effect +1 all stats.",
    "shortDesc": "The user shoots poisonous filaments to poison and slow\nthe foe. This both poisons the foe, and drops their\nSpeed & Evasion stats by 4. Z-Effect +1 all stats.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "psn"
      },
      {
        "chance": 100,
        "boosts": {
          "spe": -4
        }
      },
      {
        "chance": 100,
        "boosts": {
          "evasion": -4
        }
      }
    ]
  },
  "laserfocus": {
    "num": 673,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Laser Focus",
    "pp": 30,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "The user concentrates intensely. The attack on the\nnext turn always results in a critical hit.\nZ-Effect +2 Speed.",
    "shortDesc": "The user concentrates intensely. The attack on the\nnext turn always results in a critical hit.\nZ-Effect +2 Speed.",
    "flags": {
      "snatch": 1
    }
  },
  "gearup": {
    "num": 674,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Gear Up",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "self",
    "desc": "The user gears up for battle. This heals the user by\n50% of their max HP. With a Z-Crystal, however,\nthis will give the user +1 to ALL stats.",
    "shortDesc": "The user gears up for battle. This heals the user by\n50% of their max HP. With a Z-Crystal, however,\nthis will give the user +1 to ALL stats.",
    "flags": {
      "bypasssub": 1,
      "snatch": 1
    }
  },
  "hellthrust": {
    "num": 675,
    "accuracy": 100,
    "basePower": 100,
    "category": "Physical",
    "name": "Hell Thrust",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user savagely strikes the target, and the\nresultant suffering prevents the target from using\nFairy-type moves for 2 turns. Contact.",
    "shortDesc": "The user savagely strikes the target, and the\nresultant suffering prevents the target from using\nFairy-type moves for 2 turns. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "24"
      }
    ]
  },
  "bugbomber": {
    "num": 676,
    "accuracy": 100,
    "basePower": 25,
    "category": "Special",
    "name": "Bug Bomber",
    "pp": 3,
    "priority": 0,
    "critRatio": 7,
    "type": "Bug",
    "target": "normal",
    "desc": "The user fires 3 balls made from varying components.\nThis hits 3 times, ALWAYS results in a critical hit,\nand bypasses Protect. Heals an ally by 50% when used.",
    "shortDesc": "The user fires 3 balls made from varying components.\nThis hits 3 times, ALWAYS results in a critical hit,\nand bypasses Protect. Heals an ally by 50% when used.",
    "flags": {
      "bullet": 1,
      "heal": 1,
      "mirror": 1
    },
    "willCrit": true,
    "multihit": 3,
    "zMove": {
      "basePower": 190
    }
  },
  "anchorshot": {
    "num": 677,
    "accuracy": 100,
    "basePower": 140,
    "category": "Physical",
    "name": "Anchor Shot",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "normal",
    "desc": "Dhelmise pummels and wraps the target with it's\nanchor. This traps the target in battle, and ALWAYS\nlowers their Speed stat by 4. Contact.",
    "shortDesc": "Dhelmise pummels and wraps the target with it's\nanchor. This traps the target in battle, and ALWAYS\nlowers their Speed stat by 4. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 200
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "spe": -4
        }
      },
      {
        "chance": 100,
        "boosts": {
          "evasion": -4
        }
      }
    ]
  },
  "psychicterrain": {
    "num": 678,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Psychic Terrain",
    "pp": 5,
    "priority": 4,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user changes the terrain to Psychic Terrain for\n5 turns. Z-Effect +2 Sp. Def.\nTHIS HAS +4 PRIORITY.",
    "shortDesc": "The user changes the terrain to Psychic Terrain for\n5 turns. Z-Effect +2 Sp. Def.\nTHIS HAS +4 PRIORITY.",
    "flags": {}
  },
  "lunge": {
    "num": 679,
    "accuracy": 100,
    "basePower": 90,
    "category": "Physical",
    "name": "Lunge",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Bug",
    "target": "normal",
    "desc": "The user makes a lunge at the target, attacking with\nfull force. This always lowers the target’s Defense\nstat by one. Contact.",
    "shortDesc": "The user makes a lunge at the target, attacking with\nfull force. This always lowers the target’s Defense\nstat by one. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "firelash": {
    "num": 680,
    "accuracy": 100,
    "basePower": 90,
    "category": "Physical",
    "name": "Fire Lash",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The user lashes the target with a burning whip, tail\nor the like. This always lowers the target's Defense\nstat by one. Contact.",
    "shortDesc": "The user lashes the target with a burning whip, tail\nor the like. This always lowers the target's Defense\nstat by one. Contact.",
    "flags": {
      "contact": 1,
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "powertrip": {
    "num": 681,
    "accuracy": true,
    "basePower": 20,
    "category": "Physical",
    "name": "Power Trip",
    "pp": 3,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user boasts its strength and attacks the target.\nThis gains 20 Base Power for every stat boost.\nThe user gains +1 Attack after each use. Contact.",
    "shortDesc": "The user boasts its strength and attacks the target.\nThis gains 20 Base Power for every stat boost.\nThe user gains +1 Attack after each use. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 160
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "atk": 1
          }
        }
      }
    ]
  },
  "burnup": {
    "num": 682,
    "accuracy": 100,
    "basePower": 140,
    "category": "Special",
    "name": "Burn Up",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "normal",
    "desc": "The user burns its fire out in a massive blast this\nremoves the user's Fire typing after use. This fails\nafter the Fire type is lost, & ALWAYS burns the foe.",
    "shortDesc": "The user burns its fire out in a massive blast this\nremoves the user's Fire typing after use. This fails\nafter the Fire type is lost, & ALWAYS burns the foe.",
    "flags": {
      "defrost": 1,
      "heal": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 205
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "brn"
      }
    ]
  },
  "speedswap": {
    "num": 683,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Speed Swap",
    "pp": 10,
    "priority": 4,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user exchanges Speed stats with the target.\nZ-Effect +1 all stats. +4 Priority.",
    "shortDesc": "The user exchanges Speed stats with the target.\nZ-Effect +1 all stats. +4 Priority.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1
    }
  },
  "smartstrike": {
    "num": 684,
    "accuracy": true,
    "basePower": 75,
    "category": "Physical",
    "name": "Smart Strike",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "normal",
    "desc": "The user concentrates, and strikes the target with a\nsharp horn, blade or the like. This can't miss, and\nboosts the user's Accuracy by 1 after use. Contact.",
    "shortDesc": "The user concentrates, and strikes the target with a\nsharp horn, blade or the like. This can't miss, and\nboosts the user's Accuracy by 1 after use. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 150
    },
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "accuracy": 1
          }
        }
      }
    ]
  },
  "purify": {
    "num": 685,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Purify",
    "pp": 20,
    "priority": 4,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user heals the target’s status condition. If the\nmove succeeds, it heals the user to max HP.\nZ-Effect +1 all stats, even if Purify fails.",
    "shortDesc": "The user heals the target’s status condition. If the\nmove succeeds, it heals the user to max HP.\nZ-Effect +1 all stats, even if Purify fails.",
    "flags": {
      "protect": 1,
      "reflectable": 1
    }
  },
  "revelationdance": {
    "num": 686,
    "accuracy": 100,
    "basePower": 90,
    "category": "Special",
    "name": "Revelation Dance",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user does a dance that embodies it's typing.\nThis move changes type based on the user's primary\ntyping. This has a 50% chance to boost Sp. Atk by 1.",
    "shortDesc": "The user does a dance that embodies it's typing.\nThis move changes type based on the user's primary\ntyping. This has a 50% chance to boost Sp. Atk by 1.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 50,
        "self": {
          "boosts": {
            "spa": 1
          }
        }
      }
    ]
  },
  "coreenforcer": {
    "num": 687,
    "accuracy": 100,
    "basePower": 150,
    "category": "Special",
    "name": "Core Enforcer",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Dragon",
    "target": "allAdjacentFoes",
    "desc": "Zygarde unleashes it's inner power on the foe.\nThis ignores the effects of abilities if it moves last.\nLowers your Defensive stats by 1 and deals 30% recoil.",
    "shortDesc": "Zygarde unleashes it's inner power on the foe.\nThis ignores the effects of abilities if it moves last.\nLowers your Defensive stats by 1 and deals 30% recoil.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      30,
      100
    ],
    "self": {
      "boosts": {
        "def": -1,
        "spd": -1
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "tropkick": {
    "num": 688,
    "accuracy": 100,
    "basePower": 90,
    "category": "Physical",
    "name": "Trop Kick",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Grass",
    "target": "normal",
    "desc": "The user lands an intense jungle kick on the target.\nThis ALWAYS drops the foe's attacking stats by 1.\nContact.",
    "shortDesc": "The user lands an intense jungle kick on the target.\nThis ALWAYS drops the foe's attacking stats by 1.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      }
    ]
  },
  "instruct": {
    "num": 689,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Instruct",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "Oranguru instructs the target to use the move they\nmost recently used again. This takes up your turn, not\ntheirs. Z-Effect gives +1 All Stats.",
    "shortDesc": "Oranguru instructs the target to use the move they\nmost recently used again. This takes up your turn, not\ntheirs. Z-Effect gives +1 All Stats.",
    "flags": {
      "bypasssub": 1,
      "protect": 1
    }
  },
  "beakblast": {
    "num": 690,
    "accuracy": true,
    "basePower": 100,
    "category": "Special",
    "name": "Beak Blast",
    "pp": 2,
    "priority": 3,
    "critRatio": 1,
    "type": "Flying",
    "target": "normal",
    "desc": "Toucannon sends a massive, rapid blast from\nits own beak. This has +3 Priority, and ALWAYS burns.",
    "shortDesc": "Toucannon sends a massive, rapid blast from\nits own beak. This has +3 Priority, and ALWAYS burns.",
    "flags": {
      "defrost": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 250
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "brn"
      }
    ]
  },
  "drakonicwave": {
    "num": 691,
    "accuracy": 100,
    "basePower": 125,
    "category": "Special",
    "name": "Drakonic Wave",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Dragon",
    "target": "allAdjacentFoes",
    "desc": "The user unleashes a destructive soundwave or blast\nimbued with dragon energy. This hits all foes.",
    "shortDesc": "The user unleashes a destructive soundwave or blast\nimbued with dragon energy. This hits all foes.",
    "flags": {
      "bypasssub": 1,
      "mirror": 1,
      "protect": 1,
      "punch": 1
    },
    "zMove": {
      "basePower": 190
    }
  },
  "dragonhammer": {
    "num": 692,
    "accuracy": 100,
    "basePower": 110,
    "category": "Physical",
    "name": "Dragon Hammer",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Dragon",
    "target": "normal",
    "desc": "The user hammers down on the opponent. This has\n20% recoil and a 50% chance to drop the foe's\nDefense by 1. Contact.",
    "shortDesc": "The user hammers down on the opponent. This has\n20% recoil and a 50% chance to drop the foe's\nDefense by 1. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "recoil": [
      20,
      100
    ],
    "zMove": {
      "basePower": 185
    },
    "secondaries": [
      {
        "chance": 50,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "nightburst": {
    "num": 693,
    "accuracy": true,
    "basePower": 50,
    "category": "Special",
    "name": "Night Burst",
    "pp": 15,
    "priority": 1,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user quickly releases a weak shock wave of\ndark energy. This has +1 priority, and can't miss.",
    "shortDesc": "The user quickly releases a weak shock wave of\ndark energy. This has +1 priority, and can't miss.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 100
    }
  },
  "auroraveil": {
    "num": 694,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Aurora Veil",
    "pp": 20,
    "priority": 0,
    "critRatio": 1,
    "type": "Ice",
    "target": "normal",
    "desc": "This move reduces damage from physical and\nspecial moves for five turns. This can be used only\nin a hailstorm. Z-Effect heals user fully.",
    "shortDesc": "This move reduces damage from physical and\nspecial moves for five turns. This can be used only\nin a hailstorm. Z-Effect heals user fully.",
    "flags": {
      "snatch": 1
    }
  },
  "sinisterarrowraid": {
    "num": 695,
    "accuracy": true,
    "basePower": 250,
    "category": "Physical",
    "name": "Sinister Arrow Raid",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "The user, Decidueye, creates countless arrows\nusing its Z-Power and shoots the target with\nfull force.",
    "shortDesc": "The user, Decidueye, creates countless arrows\nusing its Z-Power and shoots the target with\nfull force.",
    "flags": {
      "bypasssub": 1,
      "contact": 1
    }
  },
  "maliciousmoonsault": {
    "num": 696,
    "accuracy": true,
    "basePower": 250,
    "category": "Physical",
    "name": "Malicious Moonsault",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user, Incineroar, strengthens its body using\nits Z-Power and crashes into the target with\nfull force.",
    "shortDesc": "The user, Incineroar, strengthens its body using\nits Z-Power and crashes into the target with\nfull force.",
    "flags": {
      "contact": 1
    }
  },
  "oceanicoperetta": {
    "num": 697,
    "accuracy": true,
    "basePower": 250,
    "category": "Special",
    "name": "Oceanic Operetta",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "The user, Primarina, summons a massive amount of \nwater using its Z-Power and attacks the target with \nfull force.",
    "shortDesc": "The user, Primarina, summons a massive amount of \nwater using its Z-Power and attacks the target with \nfull force.",
    "flags": {
      "punch": 1
    }
  },
  "guardianofalola": {
    "num": 698,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Guardian of Alola",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user, the Land Spirit Pokemon, obtains Alola’s\nenergy using its Z-Power and attacks the target with\nfull force. This reduces the target’s HP greatly.",
    "shortDesc": "The user, the Land Spirit Pokemon, obtains Alola’s\nenergy using its Z-Power and attacks the target with\nfull force. This reduces the target’s HP greatly.",
    "flags": {}
  },
  "soulstealing7starstrike": {
    "num": 699,
    "accuracy": true,
    "basePower": 200,
    "category": "Physical",
    "name": "Soul-Stealing 7-Star Strike",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "After obtaining Z-Power, the user, Marshadow,\npunches and kicks the target consecutively\nwith full force. This heals 50% of damage dealt.",
    "shortDesc": "After obtaining Z-Power, the user, Marshadow,\npunches and kicks the target consecutively\nwith full force. This heals 50% of damage dealt.",
    "flags": {
      "bypasssub": 1,
      "contact": 1
    },
    "drain": [
      1,
      2
    ]
  },
  "stokedsparksurfer": {
    "num": 700,
    "accuracy": true,
    "basePower": 250,
    "category": "Special",
    "name": "Stoked Sparksurfer",
    "pp": 1,
    "priority": 0,
    "critRatio": 7,
    "type": "Electric",
    "target": "normal",
    "desc": "After obtaining Z-Power, the user, Alolan Raichu,\nattacks the target with full force. This move will\nALWAYS crit and ALWAYS paralyze the foe.",
    "shortDesc": "After obtaining Z-Power, the user, Alolan Raichu,\nattacks the target with full force. This move will\nALWAYS crit and ALWAYS paralyze the foe.",
    "flags": {
      "contact": 1
    },
    "willCrit": true,
    "secondaries": [
      {
        "chance": 100,
        "status": "par"
      }
    ]
  },
  "pulverizingpancake": {
    "num": 701,
    "accuracy": true,
    "basePower": 250,
    "category": "Physical",
    "name": "Pulverizing Pancake",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "Snorlax moves its enormous body energetically,\nslamming onto the target with full force. Contact. \nThis ALWAYS leaves the target with Paralysis.",
    "shortDesc": "Snorlax moves its enormous body energetically,\nslamming onto the target with full force. Contact. \nThis ALWAYS leaves the target with Paralysis.",
    "flags": {
      "contact": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "par"
      }
    ]
  },
  "extremeevoboost": {
    "num": 702,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Extreme Evoboost",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "self",
    "desc": "After obtaining Z-Power, the user, Eevee, gets\nenergy from its evolved friends and boosts its\nstats sharply.",
    "shortDesc": "After obtaining Z-Power, the user, Eevee, gets\nenergy from its evolved friends and boosts its\nstats sharply.",
    "flags": {},
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "atk": 2,
          "def": 2,
          "spa": 2,
          "spd": 2,
          "spe": 2
        }
      }
    ]
  },
  "genesissupernova": {
    "num": 703,
    "accuracy": true,
    "basePower": 250,
    "category": "Special",
    "name": "Genesis Supernova",
    "pp": 1,
    "priority": 0,
    "critRatio": 7,
    "type": "Psychic",
    "target": "normal",
    "desc": "Mew unleashes an immense blast of ancient power.\nThis ALWAYS crits, is 250 BP AND\nwill give Mew +1 all stats BEFORE attacking.",
    "shortDesc": "Mew unleashes an immense blast of ancient power.\nThis ALWAYS crits, is 250 BP AND\nwill give Mew +1 all stats BEFORE attacking.",
    "flags": {},
    "willCrit": true,
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "atk": 1,
            "def": 1,
            "spa": 1,
            "spd": 1,
            "spe": 1
          }
        }
      }
    ]
  },
  "shelltrap": {
    "num": 704,
    "accuracy": 100,
    "basePower": 250,
    "category": "Special",
    "name": "Shell Trap",
    "pp": 5,
    "priority": -4,
    "critRatio": 1,
    "type": "Fire",
    "target": "allAdjacentFoes",
    "desc": "The user sets a shell trap. If the user is hit by a\nphysical move, the trap will explode at the end of the\nturn, burning the foes and inflicting massive damage.",
    "shortDesc": "The user sets a shell trap. If the user is hit by a\nphysical move, the trap will explode at the end of the\nturn, burning the foes and inflicting massive damage.",
    "flags": {
      "defrost": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 250
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "brn"
      }
    ]
  },
  "fleurcannon": {
    "num": 705,
    "accuracy": 100,
    "basePower": 150,
    "category": "Special",
    "name": "Fleur Cannon",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user unleashes a strong beam fueled by fairy\nenergy. This drops the user's Sp. Atk by 2 after use.",
    "shortDesc": "The user unleashes a strong beam fueled by fairy\nenergy. This drops the user's Sp. Atk by 2 after use.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "sound": 1
    },
    "self": {
      "boosts": {
        "spa": -2
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "psychicfangs": {
    "num": 706,
    "accuracy": 100,
    "basePower": 85,
    "category": "Physical",
    "name": "Psychic Fangs",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user bites the target with fangs imbued with\npsychic energy. This breaks the effects of Reflect\nand Light Screen. Contact.",
    "shortDesc": "The user bites the target with fangs imbued with\npsychic energy. This breaks the effects of Reflect\nand Light Screen. Contact.",
    "flags": {
      "bite": 1,
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 170
    }
  },
  "stompingtantrum": {
    "num": 707,
    "accuracy": true,
    "basePower": 75,
    "category": "Physical",
    "name": "Stomping Tantrum",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Ground",
    "target": "allAdjacentFoes",
    "desc": "Driven by frustration, the user stomps the ground\naround itself. If the user’s previous move has\nfailed or missed, this damage doubles. Can't miss.",
    "shortDesc": "Driven by frustration, the user stomps the ground\naround itself. If the user’s previous move has\nfailed or missed, this damage doubles. Can't miss.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 150
    }
  },
  "shadowbone": {
    "num": 708,
    "accuracy": 100,
    "basePower": 90,
    "category": "Physical",
    "name": "Shadow Bone",
    "pp": 1,
    "priority": 4,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "The user attacks by beating the target with a bone\nimbued with spirits. This ALWAYS drops\ndefense, ALWAYS flinches and has +4 Priority.",
    "shortDesc": "The user attacks by beating the target with a bone\nimbued with spirits. This ALWAYS drops\ndefense, ALWAYS flinches and has +4 Priority.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 175
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "flinch"
      },
      {
        "chance": 100,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "accelerock": {
    "num": 709,
    "accuracy": true,
    "basePower": 45,
    "category": "Physical",
    "name": "Accelerock",
    "pp": 20,
    "priority": 1,
    "critRatio": 1,
    "type": "Rock",
    "target": "normal",
    "desc": "The user smashes into the target at high speed with\nit's rocky body. This has +1 priority, and can't\nmiss. Contact.",
    "shortDesc": "The user smashes into the target at high speed with\nit's rocky body. This has +1 priority, and can't\nmiss. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 90
    }
  },
  "liquidation": {
    "num": 710,
    "accuracy": 100,
    "basePower": 85,
    "category": "Physical",
    "name": "Liquidation",
    "pp": 15,
    "priority": 0,
    "critRatio": 1,
    "type": "Water",
    "target": "normal",
    "desc": "The user pummels the target using a full-force blast\nof water. This lowers Defense 25% of the time.\nContact.",
    "shortDesc": "The user pummels the target using a full-force blast\nof water. This lowers Defense 25% of the time.\nContact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 170
    },
    "secondaries": [
      {
        "chance": 25,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "radiantoutburst": {
    "num": 711,
    "accuracy": 100,
    "basePower": 180,
    "category": "Special",
    "name": "Radiant Outburst",
    "pp": 3,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "The user unleashes a destructive, yet beautiful blast\nof colorful light and energy. This drops the user's\nSp. Atk stat by 4 (or 2/3) after use, however.",
    "shortDesc": "The user unleashes a destructive, yet beautiful blast\nof colorful light and energy. This drops the user's\nSp. Atk stat by 4 (or 2/3) after use, however.",
    "flags": {
      "mirror": 1,
      "protect": 1,
      "sound": 1
    },
    "self": {
      "boosts": {
        "spa": -4
      }
    },
    "zMove": {
      "basePower": 230
    }
  },
  "spectralthief": {
    "num": 712,
    "accuracy": true,
    "basePower": 95,
    "category": "Physical",
    "name": "Spectral Thief",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "The user hides in the shadows, and strikes. This\nsteals any stat boosts the target has, then attacks.\nIgnores Protect and Substitute. Can't miss. Contact.",
    "shortDesc": "The user hides in the shadows, and strikes. This\nsteals any stat boosts the target has, then attacks.\nIgnores Protect and Substitute. Can't miss. Contact.",
    "flags": {
      "bypasssub": 1,
      "contact": 1,
      "mirror": 1
    },
    "zMove": {
      "basePower": 175
    }
  },
  "solarstrike": {
    "num": 713,
    "accuracy": 100,
    "basePower": 120,
    "category": "Physical",
    "name": "Solar Strike",
    "pp": 3,
    "priority": 0,
    "critRatio": 7,
    "type": "Fire",
    "target": "normal",
    "desc": "The user flies up and descends onto the target with\na column of flames. ALWAYS crits, ALWAYS burns, and\ndeals 30% recoil to the user. Contact.",
    "shortDesc": "The user flies up and descends onto the target with\na column of flames. ALWAYS crits, ALWAYS burns, and\ndeals 30% recoil to the user. Contact.",
    "flags": {
      "contact": 1,
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "willCrit": true,
    "recoil": [
      30,
      100
    ],
    "zMove": {
      "basePower": 250
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "brn"
      }
    ]
  },
  "spectralbeam": {
    "num": 714,
    "accuracy": 100,
    "basePower": 150,
    "category": "Special",
    "name": "Spectral Beam",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "The user blasts the target with a devastating,\nshadowy beam. This move ignores the target's Ability.\nThis lowers the user's Sp. Atk by 2 after use.",
    "shortDesc": "The user blasts the target with a devastating,\nshadowy beam. This move ignores the target's Ability.\nThis lowers the user's Sp. Atk by 2 after use.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "spa": -2
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "tearfullook": {
    "num": 715,
    "accuracy": true,
    "basePower": 0,
    "category": "Status",
    "name": "Tearful Look",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user gets teary eyed to make the target lose\nits combative spirit. This lowers both offensive stats\nby 1. Z-Effect +3 Accuracy. BYPASSES PROTECT.",
    "shortDesc": "The user gets teary eyed to make the target lose\nits combative spirit. This lowers both offensive stats\nby 1. Z-Effect +3 Accuracy. BYPASSES PROTECT.",
    "flags": {
      "mirror": 1,
      "reflectable": 1
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "atk": -1
        }
      },
      {
        "chance": 100,
        "boosts": {
          "spa": -1
        }
      }
    ]
  },
  "zingzap": {
    "num": 716,
    "accuracy": 90,
    "basePower": 85,
    "category": "Physical",
    "name": "Zing Zap",
    "pp": 10,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "The user swiftly and nimbly strikes the target.\nThis has a 30% chance to flinch, and ALWAYS boosts\nthe user's Speed by 1 after use. Contact.",
    "shortDesc": "The user swiftly and nimbly strikes the target.\nThis has a 30% chance to flinch, and ALWAYS boosts\nthe user's Speed by 1 after use. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 170
    },
    "secondaries": [
      {
        "chance": 20,
        "status": "par"
      },
      {
        "chance": 30,
        "volatileStatus": "flinch"
      },
      {
        "chance": 100,
        "self": {
          "boosts": {
            "spe": 1
          }
        }
      }
    ]
  },
  "cosmicchaos": {
    "num": 717,
    "accuracy": true,
    "basePower": 1,
    "category": "Special",
    "name": "Cosmic Chaos",
    "pp": 1,
    "priority": 4,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "The user staggers the foe with cosmic energy\nThis attack will ALWAYS flinch the foe, and go first.\nThis halves the foe's current HP stat.",
    "shortDesc": "The user staggers the foe with cosmic energy\nThis attack will ALWAYS flinch the foe, and go first.\nThis halves the foe's current HP stat.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 180
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "flinch"
      }
    ]
  },
  "multiattack": {
    "num": 718,
    "accuracy": 100,
    "basePower": 120,
    "category": "Physical",
    "name": "Multi-Attack",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Normal",
    "target": "normal",
    "desc": "The user slashes at the foe, cloaked in energy.\nThis move's type changes with the user's held Memory.\nThis ALWAYS drops the foe's Defense by 1. Contact.",
    "shortDesc": "The user slashes at the foe, cloaked in energy.\nThis move's type changes with the user's held Memory.\nThis ALWAYS drops the foe's Defense by 1. Contact.",
    "flags": {
      "contact": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 200
    },
    "secondaries": [
      {
        "chance": 100,
        "boosts": {
          "def": -1
        }
      }
    ]
  },
  "10000000voltthunderbolt": {
    "num": 719,
    "accuracy": true,
    "basePower": 250,
    "category": "Special",
    "name": "10,000,000 Volt Thunderbolt",
    "pp": 1,
    "priority": 0,
    "critRatio": 7,
    "type": "Electric",
    "target": "normal",
    "desc": "The user, Pikachu wearing a cap, powers up a jolt of\nelectricity using its Z-Power and unleashes it.\nALWAYS CRITS AND ALWAYS PARAS.",
    "shortDesc": "The user, Pikachu wearing a cap, powers up a jolt of\nelectricity using its Z-Power and unleashes it.\nALWAYS CRITS AND ALWAYS PARAS.",
    "flags": {},
    "willCrit": true,
    "secondaries": [
      {
        "chance": 100,
        "status": "par"
      }
    ]
  },
  "mindblown": {
    "num": 720,
    "accuracy": 100,
    "basePower": 200,
    "category": "Special",
    "name": "Mind Blown",
    "pp": 2,
    "priority": 0,
    "critRatio": 1,
    "type": "Fire",
    "target": "allAdjacent",
    "desc": "Blacephalon attacks everything around it by blowing\nup it's own head for amusement. This will ALWAYS\nflinch the opponent, in exchange for losing 50% HP.",
    "shortDesc": "Blacephalon attacks everything around it by blowing\nup it's own head for amusement. This will ALWAYS\nflinch the opponent, in exchange for losing 50% HP.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 250
    },
    "secondaries": [
      {
        "chance": 100,
        "volatileStatus": "flinch"
      }
    ]
  },
  "plasmashot": {
    "num": 721,
    "accuracy": 80,
    "basePower": 130,
    "category": "Special",
    "name": "Plasma Shot",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Electric",
    "target": "normal",
    "desc": "The user fires an intense blast of superheated plasma.\nThis ALWAYS burns the target, and turns Normal type\nmoves to Electric type moves for the rest of the turn.",
    "shortDesc": "The user fires an intense blast of superheated plasma.\nThis ALWAYS burns the target, and turns Normal type\nmoves to Electric type moves for the rest of the turn.",
    "flags": {
      "defrost": 1,
      "mirror": 1,
      "protect": 1
    },
    "zMove": {
      "basePower": 205
    },
    "secondaries": [
      {
        "chance": 100,
        "status": "brn"
      }
    ]
  },
  "twilightcannon": {
    "num": 722,
    "accuracy": 100,
    "basePower": 150,
    "category": "Special",
    "name": "Twilight Cannon",
    "pp": 5,
    "priority": 0,
    "critRatio": 1,
    "type": "Dark",
    "target": "normal",
    "desc": "The user unleashed a wicked beam of dark energy. This\nis Physical or Special, based on the user's higher\nstat, & drops offensive stats by 2. IGNORES ABILITIES.",
    "shortDesc": "The user unleashed a wicked beam of dark energy. This\nis Physical or Special, based on the user's higher\nstat, & drops offensive stats by 2. IGNORES ABILITIES.",
    "flags": {
      "mirror": 1,
      "protect": 1
    },
    "self": {
      "boosts": {
        "atk": -2,
        "spa": -2
      }
    },
    "zMove": {
      "basePower": 210
    }
  },
  "lightthatburnsthesky": {
    "num": 723,
    "accuracy": true,
    "basePower": 220,
    "category": "Special",
    "name": "Light That Burns the Sky",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Psychic",
    "target": "normal",
    "desc": "This attack inflicts Attack or Sp. Atk damage,\nwhichever stat is higher for the user \nThis move ignores the target’s Ability.",
    "shortDesc": "This attack inflicts Attack or Sp. Atk damage,\nwhichever stat is higher for the user \nThis move ignores the target’s Ability.",
    "flags": {}
  },
  "searingsunrazesmash": {
    "num": 724,
    "accuracy": true,
    "basePower": 220,
    "category": "Physical",
    "name": "Searing Sunraze Smash",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Steel",
    "target": "normal",
    "desc": "After obtaining Z-Power, the user, Solgaleo,\nattacks the target with full force. This move can\nignore the effect of the target’s Ability.",
    "shortDesc": "After obtaining Z-Power, the user, Solgaleo,\nattacks the target with full force. This move can\nignore the effect of the target’s Ability.",
    "flags": {
      "contact": 1
    }
  },
  "menacingmoonrazemaelstrom": {
    "num": 725,
    "accuracy": true,
    "basePower": 220,
    "category": "Special",
    "name": "Menacing Moonraze Maelstrom",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Ghost",
    "target": "normal",
    "desc": "After obtaining Z-Power, the user, Lunala,\nattacks the target with full force. This move can\nignore the effect of the target’s Ability.",
    "shortDesc": "After obtaining Z-Power, the user, Lunala,\nattacks the target with full force. This move can\nignore the effect of the target’s Ability.",
    "flags": {
      "bypasssub": 1
    }
  },
  "letssnuggleforever": {
    "num": 726,
    "accuracy": true,
    "basePower": 250,
    "category": "Physical",
    "name": "Let’s Snuggle Forever",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Fairy",
    "target": "normal",
    "desc": "After obtaining Z-Power, the user, Mimikyu,\npunches the target with full force.",
    "shortDesc": "After obtaining Z-Power, the user, Mimikyu,\npunches the target with full force.",
    "flags": {
      "contact": 1
    }
  },
  "splinteredstormshards": {
    "num": 727,
    "accuracy": true,
    "basePower": 190,
    "category": "Physical",
    "name": "Splintered Stormshards",
    "pp": 1,
    "priority": 0,
    "critRatio": 7,
    "type": "Rock",
    "target": "normal",
    "desc": "After obtaining Z-Power, the user, Lycanroc,\nattacks the target with full force. This move negates\nthe effect on the battlefield.",
    "shortDesc": "After obtaining Z-Power, the user, Lycanroc,\nattacks the target with full force. This move negates\nthe effect on the battlefield.",
    "flags": {},
    "willCrit": true
  },
  "clangoroussoulblaze": {
    "num": 728,
    "accuracy": true,
    "basePower": 190,
    "category": "Special",
    "name": "Clangorous Soulblaze",
    "pp": 1,
    "priority": 0,
    "critRatio": 1,
    "type": "Dragon",
    "target": "allAdjacentFoes",
    "desc": "After obtaining Z-Power, the user, Kommo-o,\nattacks the opposing Pokemon with full force. This\ngives +1 all stats in exchange for 30% recoil.",
    "shortDesc": "After obtaining Z-Power, the user, Kommo-o,\nattacks the opposing Pokemon with full force. This\ngives +1 all stats in exchange for 30% recoil.",
    "flags": {
      "bypasssub": 1,
      "punch": 1
    },
    "recoil": [
      30,
      100
    ],
    "secondaries": [
      {
        "chance": 100,
        "self": {
          "boosts": {
            "atk": 1,
            "def": 1,
            "spa": 1,
            "spd": 1,
            "spe": 1
          }
        }
      }
    ]
  }
}